import { ConversationMetadata } from 'src/types/common';

export const CONVERSATIONS: ConversationMetadata[] = [
  {
    duration: 5965.949375,
    speaker_count: 9,
    id: 1892,
    snippets: [
      {
        audio_end_offset: 287.082,
        audio_start_offset: 0.812,
        duration: 283.802,
        id: 189200000,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 294.85,
        audio_start_offset: 287.082,
        duration: 6.958000000000027,
        id: 189200004,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 321.47,
        audio_start_offset: 294.85,
        duration: 26.620000000000005,
        id: 189200005,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 325.27,
        audio_start_offset: 321.47,
        duration: 3.359999999999957,
        id: 189200006,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 349.81,
        audio_start_offset: 325.27,
        duration: 22.78000000000003,
        id: 189200007,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 378.25,
        audio_start_offset: 349.81,
        duration: 28.05000000000001,
        id: 189200008,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 381.52,
        audio_start_offset: 378.25,
        duration: 3.269999999999982,
        id: 189200009,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 382.63,
        audio_start_offset: 381.52,
        duration: 1.1100000000000136,
        id: 189200010,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 390.97,
        audio_start_offset: 382.63,
        duration: 7.53000000000003,
        id: 189200011,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 392.71,
        audio_start_offset: 390.97,
        duration: 1.1099999999999568,
        id: 189200012,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 396.73,
        audio_start_offset: 392.71,
        duration: 2.3100000000000023,
        id: 189200013,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 397.206,
        audio_start_offset: 396.73,
        duration: 0.4759999999999991,
        id: 189200014,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 398.56,
        audio_start_offset: 397.206,
        duration: 1.3039999999999736,
        id: 189200015,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 420.79,
        audio_start_offset: 398.56,
        duration: 21.420000000000016,
        id: 189200016,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 422.92657804632427,
        audio_start_offset: 420.79,
        duration: 2.136578046324246,
        id: 189200017,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 425.89,
        audio_start_offset: 422.92657804632427,
        duration: 2.3334219536757246,
        id: 189200018,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 431.59,
        audio_start_offset: 425.89,
        duration: 5.020000000000039,
        id: 189200019,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 431.9776818774446,
        audio_start_offset: 431.59,
        duration: 0.38768187744460647,
        id: 189200020,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 439.37,
        audio_start_offset: 431.9776818774446,
        duration: 3.422318122555396,
        id: 189200021,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 452.24,
        audio_start_offset: 439.37,
        duration: 12.870000000000005,
        id: 189200022,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 453.656,
        audio_start_offset: 452.24,
        duration: 1.22199999999998,
        id: 189200023,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 500.57,
        audio_start_offset: 453.656,
        duration: 46.22399999999999,
        id: 189200024,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 501.5,
        audio_start_offset: 500.57,
        duration: 0.9300000000000068,
        id: 189200025,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
      },
      {
        audio_end_offset: 502.67,
        audio_start_offset: 501.5,
        duration: 1.170000000000016,
        id: 189200026,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
      },
      {
        audio_end_offset: 512.396,
        audio_start_offset: 502.67,
        duration: 9.531999999999982,
        id: 189200027,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 608.91,
        audio_start_offset: 512.396,
        duration: 91.95400000000006,
        id: 189200028,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 638.13,
        audio_start_offset: 608.91,
        duration: 28.660000000000082,
        id: 189200029,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 663.39,
        audio_start_offset: 638.13,
        duration: 24.92999999999995,
        id: 189200030,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 803.09,
        audio_start_offset: 663.39,
        duration: 139.63800000000015,
        id: 189200031,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 804.62,
        audio_start_offset: 803.09,
        duration: 1.5299999999999727,
        id: 189200033,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 871.71,
        audio_start_offset: 804.62,
        duration: 66.03999999999996,
        id: 189200034,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 875.07,
        audio_start_offset: 871.71,
        duration: 3.0399999999999636,
        id: 189200035,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 927.31,
        audio_start_offset: 875.07,
        duration: 52.239999999999895,
        id: 189200036,
        speaker_id: 6,
        speaker_name: 'Speaker JB',
      },
      {
        audio_end_offset: 931.57,
        audio_start_offset: 927.31,
        duration: 4.260000000000105,
        id: 189200037,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 947.49,
        audio_start_offset: 931.57,
        duration: 2.6099999999999,
        id: 189200038,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 964.23,
        audio_start_offset: 947.49,
        duration: 14.43999999999994,
        id: 189200039,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 975.99,
        audio_start_offset: 964.23,
        duration: 11.42999999999995,
        id: 189200040,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 976.44,
        audio_start_offset: 975.99,
        duration: 0.39999999999997726,
        id: 189200041,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 986.43,
        audio_start_offset: 976.44,
        duration: 9.539999999999964,
        id: 189200042,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 987.408,
        audio_start_offset: 986.43,
        duration: 0.7960000000000491,
        id: 189200043,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 988.14,
        audio_start_offset: 987.408,
        duration: 0.7319999999999709,
        id: 189200044,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 990.27,
        audio_start_offset: 988.14,
        duration: 1.740000000000009,
        id: 189200045,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 992.796,
        audio_start_offset: 990.27,
        duration: 0.9900000000000091,
        id: 189200046,
        speaker_id: 2,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 1036.728,
        audio_start_offset: 992.796,
        duration: 43.75,
        id: 189200047,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1038.15,
        audio_start_offset: 1036.728,
        duration: 0.9120000000000346,
        id: 189200048,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
      },
      {
        audio_end_offset: 1039.89,
        audio_start_offset: 1038.15,
        duration: 1.1199999999998909,
        id: 189200049,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1041.33,
        audio_start_offset: 1039.89,
        duration: 0.9900000000000091,
        id: 189200050,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
      },
      {
        audio_end_offset: 1042.21,
        audio_start_offset: 1041.33,
        duration: 0.8800000000001091,
        id: 189200051,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1043.79,
        audio_start_offset: 1042.21,
        duration: 1.5799999999999272,
        id: 189200052,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 1048.86,
        audio_start_offset: 1043.79,
        duration: 5.069999999999936,
        id: 189200053,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1050.81,
        audio_start_offset: 1048.86,
        duration: 1.9500000000000455,
        id: 189200054,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
      },
      {
        audio_end_offset: 1261.59,
        audio_start_offset: 1050.81,
        duration: 206.40999999999985,
        id: 189200055,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1289.55,
        audio_start_offset: 1261.59,
        duration: 27.450000000000045,
        id: 189200058,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
      },
      {
        audio_end_offset: 1292.79,
        audio_start_offset: 1289.55,
        duration: 1.6600000000000819,
        id: 189200059,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1324.53,
        audio_start_offset: 1292.79,
        duration: 30.569999999999936,
        id: 189200060,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 1331.832,
        audio_start_offset: 1324.53,
        duration: 7.1440000000000055,
        id: 189200061,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1336.53,
        audio_start_offset: 1331.832,
        duration: 4.307999999999993,
        id: 189200062,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 1342.59,
        audio_start_offset: 1336.53,
        duration: 4,
        id: 189200063,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1376.49,
        audio_start_offset: 1342.59,
        duration: 33.450000000000045,
        id: 189200064,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
      },
      {
        audio_end_offset: 1384.69,
        audio_start_offset: 1376.49,
        duration: 1.8399999999999181,
        id: 189200065,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1437.43,
        audio_start_offset: 1384.69,
        duration: 51.99000000000001,
        id: 189200066,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
      },
      {
        audio_end_offset: 1440.13,
        audio_start_offset: 1437.43,
        duration: 1.8999999999998636,
        id: 189200067,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1484.7778623718887,
        audio_start_offset: 1440.13,
        duration: 44.64786237188855,
        id: 189200068,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
      },
      {
        audio_end_offset: 1484.8085061005368,
        audio_start_offset: 1484.7778623718887,
        duration: 0.030643728648101387,
        id: 189200069,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1530.35,
        audio_start_offset: 1484.8085061005368,
        duration: 44.67149389946326,
        id: 189200070,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
      },
      {
        audio_end_offset: 1534.49,
        audio_start_offset: 1530.35,
        duration: 2.259999999999991,
        id: 189200071,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1561.07,
        audio_start_offset: 1534.49,
        duration: 23.730000000000018,
        id: 189200072,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 1709.41,
        audio_start_offset: 1561.07,
        duration: 142.942,
        id: 189200073,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 1981.38,
        audio_start_offset: 1709.41,
        duration: 270.7199999999998,
        highlight_id: 5250339,
        highlight_words:
          "biggest opportunity that it provided for me was that in our department it coincided with a new EM, and we were much strongly encouraged to attend the Friday morning staff meetings. We pretty much had so many things to do on Friday mornings, but we were continuing to be encouraged and so we understood that we need to be there. Because of the pandemic, and because of the tools that we were able to use, we became very close in an appropriate... Nobody is calling you at 9:00 or whatever. We also began to share our case work and to ask each other for help. We often do trainings, two of us, which we didn't used to do and with people that we couldn't have done it with before, that was very... I think that for me, that was our biggest and greatest learnings.",
        id: 189200076,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
        codes: [3, 41, 33, 26, 29, 15],
      },
      {
        audio_end_offset: 1990.51,
        audio_start_offset: 1981.38,
        duration: 5.349999999999909,
        id: 189200079,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2170.3,
        audio_start_offset: 1990.51,
        duration: 178.7360000000001,
        highlight_id: 5250341,
        highlight_words:
          "But then something happened, and when we started the old virtual experience, suddenly I felt safer to be around a lot of people on a Zoom meeting and I suddenly have now met and worked with more colleagues... In fact, in the first six months I have met and worked with on exciting projects, more colleagues in that first six months than I had in the entire seven years prior, and it's just exploded since then.",
        id: 189200080,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
        codes: [2, 11, 41, 33, 26, 29],
      },
      {
        audio_end_offset: 2190.97,
        audio_start_offset: 2170.3,
        duration: 20.33999999999969,
        id: 189200083,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2388.07,
        audio_start_offset: 2190.97,
        duration: 195.56600000000026,
        highlight_id: 5250344,
        highlight_words:
          "I actually feel incredibly comfortable now using the Zoom platform and managing the parties. I've done meetings for up to 200 people and I've done the hybrid model, I've been in person a little bit also, so I've kind of had the best of all worlds I think at this point. I've had all the different experiences, so I really appreciate the opportunity that we were given to learn this technology and learn how to work with it. As Cathy said, I've done a lot more work with my colleagues. We have regular staff meetings. Now I get to see everybody's faces every couple of weeks. I think that's awesome, because before we were kind of all in our own orbits, so now I actually see the people who are in my region and I get to work with them collaboratively, which is great.",
        id: 189200084,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
        codes: [2, 11, 33, 35, 25, 15, 16],
      },
      {
        audio_end_offset: 2397.23,
        audio_start_offset: 2388.07,
        duration: 4.179999999999836,
        id: 189200087,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2398.41,
        audio_start_offset: 2397.23,
        duration: 1.1799999999998363,
        id: 189200088,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 2606.97,
        audio_start_offset: 2398.41,
        duration: 206.9119999999998,
        highlight_id: 5250346,
        highlight_words:
          "Because our work-life balance was dramatically changed. Here, you can't get... I live in Thousand Oaks, and so everywhere I go for the most part, unless I have something that's assigned in the Ventura County area, is hour, to hour, to hour drive with LA traffic. I saw that as an immediate benefit, the fact that I can pretty much have a life.",
        id: 189200089,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
        codes: [2, 29, 19, 20, 21],
      },
      {
        audio_end_offset: 2614.11,
        audio_start_offset: 2606.97,
        duration: 6.8100000000004,
        id: 189200093,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2855.15,
        audio_start_offset: 2614.11,
        duration: 238.33199999999943,
        id: 189200094,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 2862.33,
        audio_start_offset: 2855.15,
        duration: 3.3399999999996908,
        id: 189200098,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2890.63,
        audio_start_offset: 2862.33,
        duration: 27.200000000000273,
        id: 189200099,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 2895.43,
        audio_start_offset: 2890.63,
        duration: 2.549999999999727,
        id: 189200100,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 2923.93,
        audio_start_offset: 2895.43,
        duration: 27.0300000000002,
        id: 189200101,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 3006.27,
        audio_start_offset: 2923.93,
        duration: 82.34000000000015,
        id: 189200102,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3132.05,
        audio_start_offset: 3006.27,
        duration: 124.90999999999985,
        highlight_id: 5250352,
        highlight_words:
          "My experience was very high level manager, basically taking the position and telling me that listen technology is a passing fad and treating it just like that. I'm going, \"No technology is an ever evolving process in our future, and we have to continually explore the things that are out there to see how it can benefit us, so that we can continue to be meaningful in the interactions we have with our customer base out there.\" Labor and management may drag behind us with technology because maybe we're better positioned to look and explore these things, but if we can provide things so that we can do our job better and to always keep our eyes open to those types of things, then whether it's dealing with the interactions with labor and management or the way we do our case reporting and things like that.",
        id: 189200103,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
        codes: [4, 10, 38, 17, 15],
      },
      {
        audio_end_offset: 3144.59,
        audio_start_offset: 3132.05,
        duration: 11.730000000000018,
        id: 189200105,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3265.4,
        audio_start_offset: 3144.59,
        duration: 120.4960000000001,
        id: 189200106,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
      },
      {
        audio_end_offset: 3273.95,
        audio_start_offset: 3265.4,
        duration: 7.019999999999982,
        id: 189200108,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3361.424,
        audio_start_offset: 3273.95,
        duration: 87.32799999999997,
        highlight_id: 5250355,
        highlight_words:
          "Okay, so I have a client that I've worked with many times. She's legal counsel in healthcare industry. I like working with her, but she's very high maintenance. When we went virtual, she freaked out, completely freaked out. \"What am I going to do with this? We can't trust the virtual platform. The parties aren't going to get together. We're not going to be able to get anything done.\" You all of the conversation. What I decided to do with her, because we have a long relationship, we broke it down into little pieces. I had a meeting with her. I had a meeting with her team. I had a meeting with the union team. I brought them together. We had a kind of a give and take in the conversation. We went back and forth to caucus rooms. I took them one at a time and prove to them that they couldn't hear anything if they were in the caucus room, it was a very horizontal process. But at the end of it well, she trusted the process and continued to trust me. We've had several very successful negotiations CBMs with her and her team and she now has become an advocate for FMCS and our virtual platform, and is bringing me clients to teach them about our virtual platform so that we can assist them and facilitate for them,",
        id: 189200109,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
        codes: [4, 13, 11, 30, 17, 15, 16],
      },
      {
        audio_end_offset: 3367.71,
        audio_start_offset: 3361.424,
        duration: 6.286000000000058,
        id: 189200110,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3570.01,
        audio_start_offset: 3367.71,
        duration: 201.87800000000016,
        id: 189200111,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
      },
      {
        audio_end_offset: 3578.03,
        audio_start_offset: 3570.01,
        duration: 2.9799999999995634,
        id: 189200114,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3806.93,
        audio_start_offset: 3578.03,
        duration: 226.41999999999962,
        id: 189200115,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
      },
      {
        audio_end_offset: 3847.91,
        audio_start_offset: 3806.93,
        duration: 38.850000000000364,
        id: 189200118,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3873.3261262650603,
        audio_start_offset: 3847.91,
        duration: 25.416126265060484,
        id: 189200119,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 3873.396,
        audio_start_offset: 3873.3261262650603,
        duration: 0.06987373493984705,
        id: 189200120,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3917.35,
        audio_start_offset: 3873.396,
        duration: 42.723999999999705,
        highlight_id: 5250359,
        highlight_words:
          'The breakout rooms. That was quite interesting, because when I first came to FMCS, we actually had a litigation case, and getting the breakout rooms situated, and the attaching of documents, that was kind of interesting in the sense of where to go to the breakout room, how to set that up. Specifically with litigation, with seeing the documents, being able to refer to different documents. That was kind of interesting, but otherwise, nothing on my part.',
        id: 189200121,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
        codes: [3, 30, 15],
      },
      {
        audio_end_offset: 3938.45,
        audio_start_offset: 3917.35,
        duration: 18.220000000000255,
        id: 189200122,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 3982.55,
        audio_start_offset: 3938.45,
        duration: 43.41000000000031,
        highlight_id: 5250360,
        highlight_words:
          "From me, no. I'm glad that we had both, Zoom and Teams beforehand. I think when I first started, I don't think that we actually had Zoom. I think we only had, Teams and I think there was another platform, so I'm glad that we got Zoom because I'm familiar with Zoom and I like Zoom for litigation type cases those types of cases. But otherwise I'm glad that we have both platforms to use now, we have a choice which is nice. Because in Teams, you can't do the breakout rooms, especially when you need to have a side conversation, so I'm glad that we had that platform.",
        id: 189200123,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
        codes: [4, 15],
      },
      {
        audio_end_offset: 4056.81,
        audio_start_offset: 3982.55,
        duration: 74.25999999999976,
        id: 189200124,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4185.12,
        audio_start_offset: 4056.81,
        duration: 127.36000000000013,
        highlight_id: 5250361,
        highlight_words:
          "Yeah, I don't know if Andrew is still with us, but he had shared that he lived in Thousand Oaks. I certainly identified with that, because I used to be his next door neighbor. I lived in Simi Valley, and I used to have to commute down to the field office in Los Angeles on a daily basis. One pain about that was, so I certainly understand the hour, hour and a half drive to get to the office, sometimes two hours. And meet with the parties who may be somewhere around if they didn't want to meet in the office, and then have to drive to wherever. Sometimes I'd end up driving up by Bakersfield of all crazy places. I certainly identify with him and his driving to the office. It just reminds me of the fact that there's so many labor and management people now through this COVID, that have opened their eyes to how much money they can save and how much personal time they can save by conducting meetings remotely, as opposed to these God awful unnecessary drives and traffic, as well as... Gas is now $5 a gallon and everything else. Not only have to wear and tear on you and your vehicles, so this has opened up labor management's eyes I think that the remote and the hybrid meeting concepts are going to be something that we continually refine, because they're going to want a lot more of that. They're not going to want to spend the money and frankly FMCS, they'll be tickled pink if people want to continue doing stuff remotely because it'll save the agency a ton of money. Yeah, I identify with Andrew on nice to do business in a different way.",
        id: 189200125,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
        codes: [5, 13, 10, 11, 15, 20],
      },
      {
        audio_end_offset: 4187.617499999999,
        audio_start_offset: 4185.12,
        duration: 2.4974999999994907,
        id: 189200127,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4188.45,
        audio_start_offset: 4187.617499999999,
        duration: 0.8325000000004366,
        id: 189200128,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
      },
      {
        audio_end_offset: 4239.15,
        audio_start_offset: 4188.45,
        duration: 49.42000000000007,
        id: 189200129,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
      },
      {
        audio_end_offset: 4242.45,
        audio_start_offset: 4239.15,
        duration: 1.660000000000764,
        id: 189200130,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4337.91,
        audio_start_offset: 4242.45,
        duration: 92.71000000000004,
        highlight_id: 5250362,
        highlight_words:
          "Barbara Owens, you said something that really just hit the center of the target for me. It was when you were describing your high maintenance client, who was mistrustful of everything that was changing, and we all have people like that in our lives, and sometimes it's us. But what you said was, you took this big scary process and you broke it down into bite size chunks, and you walked her through it one step at a time. I know that we've done... In OSD, we do a lot of trying to break these complex things down into what we call digestible pieces, so that we do that as much as we can with whoever we're working with. But it strikes me now that I'm thinking about this in a greater context, that the pandemic has demanded that we do that all around us all of the time now. We break down everything in rethink at all, because the old habit of just whipping into a parking lot, getting out of your car, throwing your... getting your briefcase out of your trunk with your exercises that Joe has used, those days are gone. Even if you wind up in an in-person meeting, and you do pull up in your car and you do pull out your briefcase and you do whip out the exercises, you probably would do you wise to really rethink everything that you did before in light of what you know now and what the clients are expecting now, so that you don't come across as kind of outdated and irrelevant. Barbara, thanks for sharing that.",
        id: 189200131,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
        codes: [5, 13, 10, 11, 17, 16],
      },
      {
        audio_end_offset: 4344.87,
        audio_start_offset: 4337.91,
        duration: 4.779999999999745,
        id: 189200133,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4415.67,
        audio_start_offset: 4344.87,
        duration: 68.97000000000025,
        highlight_id: 5250363,
        highlight_words:
          "I'll jump in. Cathy and Shane, both of you talked about how you project your aura and your energy virtually, and I had really thought about that. I'm a former musician, so I guess maybe a lot of that was instinctive to me. I was concerned that I was properly lit and that I was in the center of my screen, you couldn't see anything behind me, but I wasn't really thinking about energy and aura. I was trying to extract that from the people that I work with, but I wasn't thinking about it in terms of myself. It was interesting to hear both of you comment on that, because I think maybe it was kind of in the back of my mind, but now I'm going to be more aware of that also, instead of just outwardly focusing on the people I'm working with. I'm going to think about that in terms of myself too, because both of you project a very positive, calm energy to me. The fact that you were self aware about that, is now I'm self aware about it too so thank you for that.",
        id: 189200134,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
        codes: [5],
      },
      {
        audio_end_offset: 4425.97,
        audio_start_offset: 4415.67,
        duration: 5.319999999999709,
        id: 189200135,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4530.51,
        audio_start_offset: 4425.97,
        duration: 102.40999999999985,
        highlight_id: 5250364,
        highlight_words:
          "Shane, you are speaking to me because, I also am not on Myers Briggs, I'm an introvert as well and so it... I really don't like forced intimacy and I feel like in staff meetings when they're in-person, sometimes you don't like what you're like. What was this about today? How are you feeling? I didn't like that. But that spoke to me because... When I was in the San Antonio office, I traveled a whole lot and it was lonesome. It was isolated. I was the only one covering all of San Antonio down to Brownsville and drove sometimes five hours is to get to do something. I go back to our staff meetings which now, they're just fun. We have one canceled and we were all like, \"What was it canceled, or should we have it anyway?\" Because it's just fun to be together, and I want to also say that when I was on the FLRA group, that I met and learned a whole bunch of new things and that was really, really fun and we wouldn't have done it. Nobody spoke about FLRA, but... That's all.",
        id: 189200136,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
        codes: [5, 41, 16],
      },
      {
        audio_end_offset: 4535.43,
        audio_start_offset: 4530.51,
        duration: 3.5799999999999272,
        id: 189200137,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4666.51,
        audio_start_offset: 4535.43,
        duration: 129.46399999999994,
        highlight_id: 5248657,
        highlight_words:
          "Hi. I thought what Ms. Owen said really resonated with me when she said about her high maintenance client. It is very uneasy when you're so used to being around people and talking with people face-to-face, to now have to go on this platform where you have to learn this platform. Then now you're like, \"Well, how do I do my face? Is the camera the right way? Can they see all of my face?\" There's all these different things that happen virtually, and for me, it was very uneasy at first having to resort to using these platforms. I had to figure out how to use it. But then the upside to that, I am very much an introvert and so the fact that I was able to be at home and do the same work, I think that really opened up my eyes.",
        id: 189200138,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
        codes: [5, 30],
      },
      {
        audio_end_offset: 4739.332,
        audio_start_offset: 4666.51,
        duration: 70.48999999999978,
        id: 189200140,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4805.35,
        audio_start_offset: 4739.332,
        duration: 64.01800000000003,
        highlight_id: 5250366,
        highlight_words:
          "think what I would like to see would be teams of people working on the projects that give them the most energy and joy in their work, who have self-selected to do that kind of work in an unlimited fashion with as many different people from around the agency as possible all of the time, utilizing whatever methods, whatever materials, whatever platforms, whatever vehicles, whatever to get work done the most elegantly and effectively as possible with, zero regard for geography, and with zero regard for that we've always done it this way, so that's kind of how I see a nice evolution of FMCS.",
        id: 189200141,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
        codes: [6, 33, 35, 26, 15],
      },
      {
        audio_end_offset: 4807.55,
        audio_start_offset: 4805.35,
        duration: 2.199999999999818,
        id: 189200142,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 4909.41,
        audio_start_offset: 4807.55,
        duration: 98.72999999999956,
        highlight_id: 5250367,
        highlight_words:
          "We have a case now with the police department out here, where the chief is having a lot of internal issues and some challenges both with the city council and the mayor, and internally, where we've got with Pete Swanson's group in terms of leadership development and organizational development, which I think is really exciting, and there's certainly a place for our organization to come in as kind of neutrals, but also facilitators in assisting organizations with their organizational issues, which it kind of bleeds over into a lot of stuff that we deal with in terms of communication and conflict resolution and those things. But I think it's exciting that we're kind of branching out and again, kind of increasing our portfolio, our value, because we hear all the time that the CBMs, the number of those are... That number is going down, so in order for us to be relevant, I think it's good that we're looking for other opportunities to get engaged with the community.",
        id: 189200143,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
        codes: [6, 10, 12, 16],
      },
      {
        audio_end_offset: 4915.89,
        audio_start_offset: 4909.41,
        duration: 5.970000000000255,
        id: 189200144,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5019.43,
        audio_start_offset: 4915.89,
        duration: 103.21999999999935,
        highlight_id: 5250368,
        highlight_words:
          "like that we are going to be able to have our own judgment on what's in-person and what's not. I don't feel the need to go back to all in-person, but I'm very happy to be able to do that. I like and think it's useful and helpful. Like the CMP project, the FLRA project, that got to do [regnegs] where the mediators get to learn and expand. I was independent for a long time, and organizational behavior was my field. It gets isolating and you feel like you need to go to a graduate school class or something, to get seated with new ideas and that's happening, so I'd like to continue that. The other thing that we did it one time that in my dream we would do more often, we had mastery classes for the incumbent mediators and we got to go there, which was really wonderful. I would love for those to happen again. They were the best classes that I had gotten to take, they were just spectacular so that's mine.",
        id: 189200145,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
        codes: [6, 33, 44, 25, 16],
      },
      {
        audio_end_offset: 5026.458,
        audio_start_offset: 5019.43,
        duration: 6.895999999999731,
        id: 189200146,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5109.85,
        audio_start_offset: 5026.458,
        duration: 83.06200000000081,
        highlight_id: 5250369,
        highlight_words:
          "Even though my job today is not the job I had five years ago, I actually kind of like this. Speaking to what Cathy said, when we get to the point where we can use our own judgment about being in-person or maybe being on the virtual platform, I think that will be a great opportunity for us to kind of liberate ourselves a little bit from being chained to technology, no offense to my technology friends there, but because I'm an in-person type of person, so I very much look forward to doing that again. But I really appreciate this option of doing things virtually because I've done several virtual meetings with orchestra musicians and they love technology. That's kind of a piece where I can use my past expertise reaching out to colleagues, but I couldn't necessarily go to Chicago, or Indiana, or Arizona. I kind of look forward to that balance between both worlds, and things like this I think are great because we get to talk about what's going to happen next, so I find that very exciting. Thank you.",
        id: 189200147,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
        codes: [6, 11, 24, 19, 20],
      },
      {
        audio_end_offset: 5116.13,
        audio_start_offset: 5109.85,
        duration: 2.7999999999992724,
        id: 189200148,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5199.33,
        audio_start_offset: 5116.13,
        duration: 81.43000000000029,
        highlight_id: 5248662,
        highlight_words:
          "When I came to this agency, it was really nice to see that this agency looked and allowed their employees to essentially go remote or not, and they also looked at what essentially every employee did their job duties, to see if it was a possibility for you to be able to be remote, so I really do appreciate that this agency has kind of opened up his eyes to a new way of doing FMCS work. Allowing also the mediators to use their judgment in in-person meetings if they want to, or to be virtual, which I think it's really nice to see. I've come from a bigger agency and that does not happen, so I really appreciate what this agency has. I think if it continues in the future, the way that it thinks about how everyone does their work, whether it can be virtual, whether it has to be in-person, I think we're headed for an even greater agency to be at.",
        id: 189200149,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
        codes: [6, 11, 37, 38, 34, 29, 15, 19, 21],
      },
      {
        audio_end_offset: 5203.56,
        audio_start_offset: 5199.33,
        duration: 4.230000000000473,
        id: 189200150,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5437.53,
        audio_start_offset: 5203.56,
        duration: 232.32600000000002,
        highlight_id: 5250371,
        highlight_words:
          "looking at it in the future, I would hope that the structure of the politics of the agency is one of inclusion, is one of embracing the information feedback and concepts from the people that work for the organization, in an ever evolving process to make things better. I would think that, we continually look towards the future. We continually look towards our ability to be the best. We ignore political protection or political division, a total change of what our management structure looks like. Maybe not even have management per se, as they are known today, maybe we have more like mentors. Maybe we have people that have responsibilities to do things that take care of business to relieve the mediators of some of the mundane tasks of the record keeping or things like that where the media can do their thing, and really use their intelligence to put our best foot forward as an agency. I look at maybe a pie chart and it has all the different things that our agency does, and that's ever changing as well.",
        id: 189200151,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
        codes: [6, 10, 37, 38],
      },
      {
        audio_end_offset: 5492.49,
        audio_start_offset: 5437.53,
        duration: 53.01000000000022,
        id: 189200154,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5515.71,
        audio_start_offset: 5492.49,
        duration: 21.94000000000051,
        highlight_id: 5250373,
        highlight_words:
          'My takeaway today is that the crafting of the questions that you presented was intentionally designed to invite us to share personal stories as opposed us to just answer academically, checking boxes of correct answers and I really appreciated the chance to share a couple stories.',
        id: 189200155,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
        codes: [7, 43, 45],
      },
      {
        audio_end_offset: 5523.43,
        audio_start_offset: 5515.71,
        duration: 3.100000000000364,
        id: 189200156,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5548.25,
        audio_start_offset: 5523.43,
        duration: 23.409999999999854,
        highlight_id: 5250374,
        highlight_words:
          "My takeaway today was that I was a little apprehensive coming into this. But as with most things, I'm glad that I followed it through to the end and it's great to talk about what we're doing and then also look to the future as to what, what might be coming next, so thank you for that.",
        id: 189200157,
        speaker_id: 4,
        speaker_name: 'Speaker BA',
        codes: [7, 43, 44],
      },
      {
        audio_end_offset: 5553.752,
        audio_start_offset: 5548.25,
        duration: 2.9799999999995634,
        id: 189200158,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5576.75,
        audio_start_offset: 5553.752,
        duration: 21.89799999999923,
        highlight_id: 5248668,
        highlight_words:
          "In the words of [inaudible] 70% of life is showing up, so I'm glad I decided to try something new and that's my takeaway, because this has been positive and getting to know that our colleagues better, so it's get out of your comfort zone and try something new, that's take away.",
        id: 189200159,
        speaker_id: 8,
        speaker_name: 'Speaker AA',
        codes: [7, 43, 44],
      },
      {
        audio_end_offset: 5585.13,
        audio_start_offset: 5576.75,
        duration: 8.38000000000011,
        id: 189200160,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5615.61,
        audio_start_offset: 5585.13,
        duration: 29.01000000000022,
        highlight_id: 5248669,
        highlight_words:
          "Kevin is my takeaway, because I'm imagining us all being Kissingers walking around, and yes I hadn't thought about that international work to that kind of extent, so that's exciting to think about. I mean maybe, maybe not, but it is exciting to chew on.",
        id: 189200161,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
        codes: [7, 43],
      },
      {
        audio_end_offset: 5619.25,
        audio_start_offset: 5615.61,
        duration: 3.6400000000003274,
        id: 189200162,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5688.51,
        audio_start_offset: 5619.25,
        duration: 67.3100000000004,
        highlight_id: 5250377,
        highlight_words:
          "Well, I think one of the takeaways is the comfort of this process seems like everybody's pretty comfortable in doing this sharing, which has been great, and just the interaction so I think the way this is being done... Of course, I want to see how this shapes out at the back end with the transition too from the recordings to the reports and stuff like that. But in this piece part of it, my takeaway is that it was pretty comfortable and nice to get that input and take the time just to sit back and talk about some of these subjects. I mean, if I was an EM, these are the types of dialogues I would already be having with my mediators. What types of things can we do to help you get your job done better? How can we just share information about stuff? What do you think about this? What do you think about that? Where do you see us now? Where do you see us in the future? I mean, these are the types of things our agency should be doing at various levels already. If something like this helps to facilitate this, great.",
        id: 189200163,
        speaker_id: 1,
        speaker_name: 'Speaker KA',
        codes: [7, 43, 45, 44],
      },
      {
        audio_end_offset: 5694.064,
        audio_start_offset: 5688.51,
        duration: 2.139999999999418,
        id: 189200164,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5743.372,
        audio_start_offset: 5694.064,
        duration: 49.149999999999636,
        highlight_id: 5250378,
        highlight_words:
          "My takeaway is, I'm like Ms. Owens. I was very apprehensive in the beginning, but I'm glad like Mr. Fox Andrew said, I'm glad that I actually stuck it through the end. Because it was very nice to see and meet all of you all and hear your personal experiences, because I don't get to actually communicate with the field office at all in what I do, so it was really nice and I appreciate you all bringing this together, having us to come together. I appreciate the questions, they were very to the point and meaningful, and you facilitated great Ms. Delgado, you did great job today.",
        id: 189200165,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
        codes: [7, 35, 43, 44, 25],
      },
      {
        audio_end_offset: 5744.104,
        audio_start_offset: 5743.372,
        duration: 0.706000000000131,
        id: 189200166,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5745.078,
        audio_start_offset: 5744.104,
        duration: 0.7820000000001528,
        id: 189200167,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 5757.01,
        audio_start_offset: 5745.078,
        duration: 9.681999999999789,
        id: 189200168,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5758.33,
        audio_start_offset: 5757.01,
        duration: 0.9899999999997817,
        id: 189200169,
        speaker_id: 3,
        speaker_name: 'Speaker HA',
      },
      {
        audio_end_offset: 5790.13,
        audio_start_offset: 5758.33,
        duration: 30.81999999999971,
        id: 189200170,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5836.69,
        audio_start_offset: 5790.13,
        duration: 46.22999999999956,
        highlight_id: 5248673,
        highlight_words:
          "I liked it. I wanted to say this, I'm so glad you asked that question. I think it was the third question. There's some lengthy question in there, that I didn't understand what it was you were asking so I just waited till somebody else answered and that thought just took the lead from that. But I thought that some of the questions, I really liked the story aspect. I agree with that, but I thought some of them, I didn't know if we would still be talking about technology. It was the one where you said, old and new, it could be something from your past, it could be something... I was like, I don't know what they want, so I mean the topic, I didn't know what the topic was, so I appreciate being able to say that.",
        id: 189200171,
        speaker_id: 5,
        speaker_name: 'Speaker CA',
        codes: [7, 43],
      },
      {
        audio_end_offset: 5845.97,
        audio_start_offset: 5836.69,
        duration: 5.920000000000073,
        id: 189200172,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
      {
        audio_end_offset: 5901.83,
        audio_start_offset: 5845.97,
        duration: 54.149999999999636,
        highlight_id: 5250380,
        highlight_words:
          "As a participant in the process, I felt extremely comfortable with the pace, the flow, having specific questions and I do want to acknowledge what Cathy just said. The fact that we're experiencing a self test on a new technology platform, and the subject happened to coincide that we were discussing amongst ourselves... happen to coincide with pandemic and meetings and technology, that kind of blurred the line of what we're exactly doing. But I can see that if we were a group of folks in a community meeting, that the topic would not be about... We wouldn't be testing the technology in that setting, we would be using the technology and the topics would be very relevant to their lives, and so I think people would dive in immediately to a set of well considered questions like this.",
        id: 189200173,
        speaker_id: 7,
        speaker_name: 'Speaker SA',
        codes: [7, 45, 46],
      },
      {
        audio_end_offset: 5965.25,
        audio_start_offset: 5901.83,
        duration: 63.42000000000007,
        id: 189200174,
        speaker_id: 0,
        speaker_name: 'Speaker IA',
      },
    ],
  },
  {
    duration: 5196.8,
    speaker_count: 8,
    id: 1901,
    snippets: [
      {
        audio_end_offset: 8.87,
        audio_start_offset: 0.97,
        duration: 6.61,
        id: 190100000,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 158.9,
        audio_start_offset: 8.87,
        duration: 149.58999999999997,
        id: 190100001,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 159.848,
        audio_start_offset: 158.9,
        duration: 0.7659999999999911,
        id: 190100003,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 160.91,
        audio_start_offset: 159.848,
        duration: 0.7319999999999993,
        id: 190100004,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 225.59,
        audio_start_offset: 160.91,
        duration: 64.35,
        id: 190100005,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 226.85,
        audio_start_offset: 225.59,
        duration: 0.8700000000000045,
        id: 190100006,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
      },
      {
        audio_end_offset: 228.778,
        audio_start_offset: 226.85,
        duration: 1.7360000000000184,
        id: 190100007,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 229.97,
        audio_start_offset: 228.778,
        duration: 0.8619999999999948,
        id: 190100008,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 231.802,
        audio_start_offset: 229.97,
        duration: 1.6639999999999873,
        id: 190100009,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 233.39,
        audio_start_offset: 231.802,
        duration: 0.8979999999999961,
        id: 190100010,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
      },
      {
        audio_end_offset: 234.99,
        audio_start_offset: 233.39,
        duration: 1.6000000000000227,
        id: 190100011,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 236.27,
        audio_start_offset: 234.99,
        duration: 1.2800000000000011,
        id: 190100012,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 238.136,
        audio_start_offset: 236.27,
        duration: 1.671999999999997,
        id: 190100013,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 239.51,
        audio_start_offset: 238.136,
        duration: 0.9240000000000066,
        id: 190100014,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 351.61,
        audio_start_offset: 239.51,
        duration: 108.49000000000001,
        id: 190100015,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 384.23,
        audio_start_offset: 351.61,
        duration: 31.639999999999986,
        id: 190100017,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 390.15,
        audio_start_offset: 384.23,
        duration: 5.919999999999959,
        id: 190100018,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 392.87,
        audio_start_offset: 390.15,
        duration: 2.2700000000000387,
        id: 190100019,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 396.33,
        audio_start_offset: 392.87,
        duration: 0.75,
        id: 190100020,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 409.74,
        audio_start_offset: 396.33,
        duration: 13.410000000000025,
        id: 190100021,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 410.19,
        audio_start_offset: 409.74,
        duration: 0.44999999999998863,
        id: 190100022,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 419.16,
        audio_start_offset: 410.19,
        duration: 8.970000000000027,
        id: 190100023,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 420.81153610771116,
        audio_start_offset: 419.16,
        duration: 1.651536107711138,
        id: 190100024,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 429.196,
        audio_start_offset: 420.81153610771116,
        duration: 8.310463892288851,
        id: 190100025,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 430.45,
        audio_start_offset: 429.196,
        duration: 0.8639999999999759,
        id: 190100026,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 446.62,
        audio_start_offset: 430.45,
        duration: 16.120000000000005,
        id: 190100027,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 447.22,
        audio_start_offset: 446.62,
        duration: 0.6000000000000227,
        id: 190100028,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 455.33,
        audio_start_offset: 447.22,
        duration: 8.109999999999957,
        id: 190100029,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 455.5,
        audio_start_offset: 455.33,
        duration: 0.17000000000001592,
        id: 190100030,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 476.29,
        audio_start_offset: 455.5,
        duration: 20.399999999999977,
        id: 190100031,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 483.25,
        audio_start_offset: 476.29,
        duration: 5.7999999999999545,
        id: 190100032,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 516.73,
        audio_start_offset: 483.25,
        duration: 32.67999999999995,
        id: 190100033,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 523.708,
        audio_start_offset: 516.73,
        duration: 6.795999999999935,
        id: 190100034,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 527.188,
        audio_start_offset: 523.708,
        duration: 3.298000000000002,
        id: 190100035,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 529.25,
        audio_start_offset: 527.188,
        duration: 2.062000000000012,
        id: 190100036,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 529.3050000000001,
        audio_start_offset: 529.25,
        duration: 0.055000000000063665,
        id: 190100037,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 530.35,
        audio_start_offset: 529.3050000000001,
        duration: 0.7149999999999181,
        id: 190100038,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 531.34,
        audio_start_offset: 530.35,
        duration: 0.9900000000000091,
        id: 190100039,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 590.69,
        audio_start_offset: 531.34,
        duration: 58.85000000000002,
        id: 190100040,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
      },
      {
        audio_end_offset: 606.97,
        audio_start_offset: 590.69,
        duration: 13.639999999999986,
        id: 190100041,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 638.044,
        audio_start_offset: 606.97,
        duration: 29.610000000000014,
        id: 190100042,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 643.81,
        audio_start_offset: 638.044,
        duration: 3.9360000000000355,
        id: 190100043,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 645.25,
        audio_start_offset: 643.81,
        duration: 1.0600000000000591,
        id: 190100044,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 662.05,
        audio_start_offset: 645.25,
        duration: 15.759999999999991,
        id: 190100045,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 687.59,
        audio_start_offset: 662.05,
        duration: 24.980000000000018,
        id: 190100046,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
      },
      {
        audio_end_offset: 692.48,
        audio_start_offset: 687.59,
        duration: 4.779999999999973,
        id: 190100047,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 699.872,
        audio_start_offset: 692.48,
        duration: 7.234000000000037,
        id: 190100048,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
      },
      {
        audio_end_offset: 754.31,
        audio_start_offset: 699.872,
        duration: 53.988000000000056,
        id: 190100049,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 755.87,
        audio_start_offset: 754.31,
        duration: 0.9900000000000091,
        id: 190100050,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 785.33,
        audio_start_offset: 755.87,
        duration: 27.870000000000005,
        id: 190100051,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 790.07,
        audio_start_offset: 785.33,
        duration: 4.240000000000009,
        id: 190100052,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 794.18,
        audio_start_offset: 790.07,
        duration: 4.1099999999999,
        id: 190100053,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 803.72,
        audio_start_offset: 794.18,
        duration: 9.540000000000077,
        id: 190100054,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 805.16,
        audio_start_offset: 803.72,
        duration: 1.4399999999999409,
        id: 190100055,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 806.57,
        audio_start_offset: 805.16,
        duration: 1.4100000000000819,
        id: 190100056,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 809.804,
        audio_start_offset: 806.57,
        duration: 3.0879999999999654,
        id: 190100057,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 813.53,
        audio_start_offset: 809.804,
        duration: 3.046000000000049,
        id: 190100058,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 821.63,
        audio_start_offset: 813.53,
        duration: 7.710000000000036,
        id: 190100059,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 825.89,
        audio_start_offset: 821.63,
        duration: 3.4600000000000364,
        id: 190100060,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 828.35,
        audio_start_offset: 825.89,
        duration: 0.29200000000003,
        id: 190100061,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 830.648,
        audio_start_offset: 828.35,
        duration: 2.1159999999999854,
        id: 190100062,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 890.83,
        audio_start_offset: 830.648,
        duration: 57.06200000000001,
        id: 190100063,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 894.43,
        audio_start_offset: 890.83,
        duration: 3.599999999999909,
        id: 190100064,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 916.81,
        audio_start_offset: 894.43,
        duration: 21.81000000000006,
        id: 190100065,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 918.7617911646587,
        audio_start_offset: 916.81,
        duration: 1.9517911646587436,
        id: 190100066,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 919.84,
        audio_start_offset: 918.7617911646587,
        duration: 1.0782088353413428,
        id: 190100067,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 925.6,
        audio_start_offset: 919.84,
        duration: 5.759999999999991,
        id: 190100068,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 935.23,
        audio_start_offset: 925.6,
        duration: 9.17999999999995,
        id: 190100069,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 953.15,
        audio_start_offset: 935.23,
        duration: 17.91999999999996,
        id: 190100070,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 957.808,
        audio_start_offset: 953.15,
        duration: 4.475999999999999,
        id: 190100071,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 958.478,
        audio_start_offset: 957.808,
        duration: 0.6699999999999591,
        id: 190100072,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1062.29,
        audio_start_offset: 958.478,
        duration: 103.00200000000007,
        highlight_id: 5248122,
        highlight_words:
          "... I have found it liberating. I have trying to master Zoom and MS Teams and other technology, but it's enabled me with some mastery of breakout rooms to be very effective in my mediation techniques. I've actually enjoyed it. It's cut down on commuting. My lunch bill is much cheaper too. So in those respects, it's been very good. It's a new technology, a new approach to dealing with people, but I find that what I need to do is meet with them earlier and sooner. Maybe not have as long meetings, shorter, but success rate has been about the same. So all in all, I think it's been helpful. Most of us are healthy and thriving, which is really the point.",
        id: 190100073,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [2, 10, 11, 15, 16, 19, 20, 21],
      },
      {
        audio_end_offset: 1074.39,
        audio_start_offset: 1062.29,
        duration: 4.230000000000018,
        id: 190100074,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1206.318515742129,
        audio_start_offset: 1074.39,
        duration: 131.82851574212896,
        highlight_id: 5250399,
        highlight_words:
          "I fought telework in my previous position for years, to the point that when, because I was a management official, for our [COOP] program, I had to be telework-ready. I had to have my laptop and everything set up to be able it to work telework. All the managers in my facility had to do that. I literally waited until the final day at 4:30, IRM was calling me and telling me that, \"Teri, if you don't come down and pick up this, we're going to bring it to you and we're going to basically strangle you when we bring it down.\" I wanted nothing to do with telework. I like being around people. I did not want to work from home. Fought it, fought it, fought it. So when this came out, it was quite a shock to my system. I didn't fight it because I knew we had to do it, but I just really was not looking forward to it. But I will say that I have gotten used to it. I do think we're productive in it.",
        id: 190100075,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [2, 29, 17, 15],
      },
      {
        audio_end_offset: 1401.95,
        audio_start_offset: 1206.318515742129,
        duration: 192.7254842578709,
        highlight_id: 5248125,
        highlight_words:
          "I was still working at the Navy base in Mechanicsburg whenever the pandemic hit last year. I actually haven't come on board with FMCS. I came on board last August. So I was still a director at the Navy, the Navy Depo. I was the director of budget and finance there. Just like Teri said earlier, we had a COOP that we had to be ready in the event that if something did happen, the directors were required to take their laptops home every evening. We were required to... I mean, we were doing a lot of automated things and, like our system of record that we had, that is Navy-wide. So I would telework on Wednesdays anyway. So it wasn't exactly a shock to my system, but I did welcome it because it was a 46-mile commute round trip from my home to the Depo. So I welcomed the break of paying for gasoline and the wear and tear on my tires and putting all that mileage on.",
        id: 190100078,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
        codes: [2, 15, 20],
      },
      {
        audio_end_offset: 1413.81,
        audio_start_offset: 1401.95,
        duration: 11.8599999999999,
        id: 190100081,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1541.364,
        audio_start_offset: 1413.81,
        duration: 126.02800000000002,
        highlight_id: 5248127,
        highlight_words:
          "In the region that we're in, we're pretty rural and we cover a large area. We cover almost three quarters way down Mississippi, up into [Hamensburg]. So we're about an hour off the Gulf Coast. We cover 80 miles deep into Tennessee to Jackson, Tennessee, and the majority of the state of Arkansas. I don't know what it is about Southern folk, but they'd much rather look you in the eye and [inaudible] than do it over the computer. So about 15% of our work is federal sector, public sector, and everything else is private sector. So we do a lot of collective bargaining, a lot of grievance mediation, a lot of relationship development training in this territory. However, Arkansas, Mississippi, Tennessee went back full face-to-face with no regard about a year ago. So as far as the federal sector goes, as Eileen said, it was enlightening. I think that's going to be the way of our future with our work for federal sector as far as the telework or virtual will continue. It's going to be cost savings to the government to do that. It's a wonderful platform.",
        id: 190100082,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [3, 2, 10, 11, 28, 29, 19, 20],
      },
      {
        audio_end_offset: 1557.51,
        audio_start_offset: 1541.364,
        duration: 14.975999999999885,
        id: 190100084,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1622.544,
        audio_start_offset: 1557.51,
        duration: 62.789999999999964,
        highlight_id: 5248129,
        highlight_words:
          "I guess since we are remote, my office partner, [Luther Minit] and I have always acted as if we're independent consultants working for the federal government. So we've done a lot of unique things, coffee with commissioners, and we'd go throughout the territory and do outreaches and familiarize people with us and our services through that. We've put together training opportunities and done flyers and hand bills and cold calls and trying to sell those to gain work. It's concerning, a little bit, I guess, concerning is a good word that it's going to take a while to rebuild their trust in us and their desire to use us. Because I feel like some of them feel like that we turned our back on them and that would be a personal reflection on me because I represent the agency in this area. How does that sit with you? I mean, I get the sense that it's a little uncomfortable for you. It's uncomfortable for me because we built relationships over 11 years and then we prided ourself on not telling our customers, \"No,\" when they needed us to work out whatever situation we needed to work out in order to be there for them. Again, everything that we cover is right to work. So it's difficult to get into some of these contract negotiations anyway. So you work very hard for 11 years and then all of a sudden, you start to have to start telling your customers, \"No,\" for a year, a little over, and it's concerning.",
        id: 190100085,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [3, 10, 12, 33, 17],
      },
      {
        audio_end_offset: 1628.31,
        audio_start_offset: 1622.544,
        duration: 5.435999999999922,
        highlight_id: 5248129,
        highlight_words:
          "I guess since we are remote, my office partner, [Luther Minit] and I have always acted as if we're independent consultants working for the federal government. So we've done a lot of unique things, coffee with commissioners, and we'd go throughout the territory and do outreaches and familiarize people with us and our services through that. We've put together training opportunities and done flyers and hand bills and cold calls and trying to sell those to gain work. It's concerning, a little bit, I guess, concerning is a good word that it's going to take a while to rebuild their trust in us and their desire to use us. Because I feel like some of them feel like that we turned our back on them and that would be a personal reflection on me because I represent the agency in this area. How does that sit with you? I mean, I get the sense that it's a little uncomfortable for you. It's uncomfortable for me because we built relationships over 11 years and then we prided ourself on not telling our customers, \"No,\" when they needed us to work out whatever situation we needed to work out in order to be there for them. Again, everything that we cover is right to work. So it's difficult to get into some of these contract negotiations anyway. So you work very hard for 11 years and then all of a sudden, you start to have to start telling your customers, \"No,\" for a year, a little over, and it's concerning.",
        id: 190100086,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
        codes: [3, 10, 12, 33, 17],
      },
      {
        audio_end_offset: 1666.47,
        audio_start_offset: 1628.31,
        duration: 36.039999999999964,
        highlight_id: 5248129,
        highlight_words:
          "I guess since we are remote, my office partner, [Luther Minit] and I have always acted as if we're independent consultants working for the federal government. So we've done a lot of unique things, coffee with commissioners, and we'd go throughout the territory and do outreaches and familiarize people with us and our services through that. We've put together training opportunities and done flyers and hand bills and cold calls and trying to sell those to gain work. It's concerning, a little bit, I guess, concerning is a good word that it's going to take a while to rebuild their trust in us and their desire to use us. Because I feel like some of them feel like that we turned our back on them and that would be a personal reflection on me because I represent the agency in this area. How does that sit with you? I mean, I get the sense that it's a little uncomfortable for you. It's uncomfortable for me because we built relationships over 11 years and then we prided ourself on not telling our customers, \"No,\" when they needed us to work out whatever situation we needed to work out in order to be there for them. Again, everything that we cover is right to work. So it's difficult to get into some of these contract negotiations anyway. So you work very hard for 11 years and then all of a sudden, you start to have to start telling your customers, \"No,\" for a year, a little over, and it's concerning.",
        id: 190100087,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [3, 10, 12, 33, 17],
      },
      {
        audio_end_offset: 1679.17,
        audio_start_offset: 1666.47,
        duration: 12.700000000000045,
        id: 190100088,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1813.07,
        audio_start_offset: 1679.17,
        duration: 131.6959999999999,
        highlight_id: 5248961,
        highlight_words:
          "Until we got the Zoom and those platforms up and running, it was different to not have that collaboration in person, but a lot of the software that we use, the One Drive, the Zoom, Teams, all those things that we use have made it a lot easier to share information, share products, to oversee. I'm the DAS for Southeast region, so we do handle a lot of paperwork and to have that collaboration was a disadvantage at first, but it has gotten a lot better with the platforms that we use virtually.",
        id: 190100089,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
        codes: [3, 2, 11, 33, 26, 15],
      },
      {
        audio_end_offset: 1824.93,
        audio_start_offset: 1813.07,
        duration: 1.2999999999999545,
        id: 190100091,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1828.536,
        audio_start_offset: 1824.93,
        duration: 3.5319999999999254,
        id: 190100092,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 1837.93,
        audio_start_offset: 1828.536,
        duration: 9.394000000000005,
        id: 190100093,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1951.344,
        audio_start_offset: 1837.93,
        duration: 110.49199999999996,
        highlight_id: 5248964,
        highlight_words:
          "Challenges, it's funny, because we almost had the opposite experience about Mark was talking about. We had a lot, lot of initial resistance to virtual and then people gave up. So there were days where morning, noon, night, you were in negotiations or training or something and just physically, it was, especially last year, it was just really exhausting. That was a huge challenge because I think all the mediators in my district and also, we were light on mediators.",
        id: 190100094,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [3, 31, 17, 15],
      },
      {
        audio_end_offset: 1972.93,
        audio_start_offset: 1951.344,
        duration: 20.54600000000005,
        id: 190100096,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 1997.8190066225166,
        audio_start_offset: 1972.93,
        duration: 24.88900662251649,
        id: 190100097,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
      },
      {
        audio_end_offset: 2068.45,
        audio_start_offset: 1997.8190066225166,
        duration: 68.75099337748361,
        id: 190100098,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 2107.11,
        audio_start_offset: 2068.45,
        duration: 37.38000000000011,
        id: 190100099,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2109.99,
        audio_start_offset: 2107.11,
        duration: 2.1900000000000546,
        id: 190100100,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 2113.02,
        audio_start_offset: 2109.99,
        duration: 3.0300000000002,
        id: 190100101,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2126.138,
        audio_start_offset: 2113.02,
        duration: 12.92599999999993,
        id: 190100102,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
      },
      {
        audio_end_offset: 2184.51,
        audio_start_offset: 2126.138,
        duration: 56.3720000000003,
        id: 190100103,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2210.724,
        audio_start_offset: 2184.51,
        duration: 25.229999999999563,
        highlight_id: 5248965,
        highlight_words:
          'This is anecdotal obviously, but I found that people were more toxic online than they would be in person, face-to-face. So that could be very challenging because short of hitting the mute button and saying, "Oh, sorry, I did that by accident," it was really hard to stop people sometimes from going off on each other.',
        id: 190100104,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [3, 24, 30, 15],
      },
      {
        audio_end_offset: 2215.95,
        audio_start_offset: 2210.724,
        duration: 4.415999999999713,
        id: 190100105,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2248.14,
        audio_start_offset: 2215.95,
        duration: 32.190000000000055,
        highlight_id: 5248966,
        highlight_words:
          "Well, you don't feel heard when people are shouting at each other. I felt like I had less control because a lot of what I do when... I use my body a lot in person negotiations. So for example, if someone's doing, I don't know, getting defensive about things, I'll go over and sit by them or stand in front of them to block the conversation. I didn't have that physical ability to close the lines of sight that I use a lot.",
        id: 190100106,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [3, 11, 24, 28, 15],
      },
      {
        audio_end_offset: 2253.79,
        audio_start_offset: 2248.14,
        duration: 2.8200000000001637,
        id: 190100107,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2302.03,
        audio_start_offset: 2253.79,
        duration: 46.90000000000009,
        highlight_id: 5248967,
        highlight_words:
          "On the plus side, I do some international work. No travel at the moment, but we're doing a program with Taiwan and we're using Zoom.gov, and we're able to have simultaneous translation from English into Chinese, by there's a Zoom program we can use. The same with Chinese into English. What it's made is the ability to actually put on a program that doesn't have to be twice as long. So sometimes technology is helpful. Before the invasion of Ukraine, we were working with the Ukrainian mediation service, but all I'm getting at is that sometimes you can get some positive responses.",
        id: 190100108,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [4, 2, 10, 15, 16, 19],
      },
      {
        audio_end_offset: 2320.91,
        audio_start_offset: 2302.03,
        duration: 18.559999999999945,
        id: 190100109,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2389.19,
        audio_start_offset: 2320.91,
        duration: 67.48000000000002,
        highlight_id: 5248968,
        highlight_words:
          "think I had a lot of resistance at the beginning where people didn't want to use the technology, but I think over the time, more and more people are wanting to use it. Now, I'm having issues with parties where one doesn't want to meet in person. They want to continue to meet virtual because basically it's economics. I mean, they can have a meeting, everybody can be at different places, they don't have to pay travel, they don't have to fly their lawyers in from another state. So while it's good, they've adjusted to it, the other problem is some want to and some don't want to. So now that is a thing we're going to have to deal with too with are we going to be in person and getting the parties to agree to one venue, because I do see that when it's a mixed situation where part of them are in person and part... That, I found not to be as effective. I find that... I don't know. There's a different vibe to it. It has an impact on negotiations if you're not all consistently one together or all virtual.",
        id: 190100110,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [3, 2, 10, 11, 17, 15, 19, 20],
      },
      {
        audio_end_offset: 2399.37,
        audio_start_offset: 2389.19,
        duration: 6.940000000000055,
        id: 190100111,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2483.73,
        audio_start_offset: 2399.37,
        duration: 81.82999999999993,
        highlight_id: 5248969,
        highlight_words:
          "I've found in virtual, a lot of times, you want to keep them short because keeping people's attention is much harder virtually. Like Barbara said, if you have somebody and you're in a negotiation and they're on their phone or they're doing something and they're not paying attention, your ability to walk up behind them or in a training to walk up behind them, you do have a different set of skills that you can use to try to deal with that where if they are just online and you see them off on their phone or not paying attention, it's very hard without specifically calling them out, which you don't want to do. You don't want to make a situation any worse, put anybody on the spot because you're trying to get agreement. So you don't want to point out the deficiencies, you know what I mean? So it just really narrows down what you have the ability to use to put everybody back into focus. I'll do the thing of, \"Excuse me, there's something happening outside. Can we take a five minute break,\" and that's really just to try to get everybody keep... And then I can come back and say, \"Now, we'll all come back and we're going to start on this,\" and try to focus everybody's attention back in. Just having to find different things to try to keep everybody on track that we didn't have available to us, the skills that we had for in person meetings. I'm sorry. Did I get off track? I apologize for that.",
        id: 190100112,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [3, 2, 11, 24, 28, 15, 16, 19],
      },
      {
        audio_end_offset: 2495.17,
        audio_start_offset: 2483.73,
        duration: 11.110000000000127,
        id: 190100114,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2535.304,
        audio_start_offset: 2495.17,
        duration: 38.92000000000007,
        highlight_id: 5248970,
        highlight_words:
          "Looking at 10 or 20 different pictures on there, you can't get the same feeling as being able to just glance at them in the room to see whether or not, in any circumstance, and RDTs are especially hard for me because you can't tell whether they're getting it the same way you can if you're in person. You can't... I mean, it's just a different vibe. I mean, I think we get better at it, but it's still much different with 20 little pictures or 25 little pictures, or you've got more than that and you're not able to see them all at one time or you can't see them all because you have a display or something that you're putting up, you can't can't see. So yeah, it is frustrating.",
        id: 190100115,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [3, 11, 24, 28, 15, 16],
      },
      {
        audio_end_offset: 2540.47,
        audio_start_offset: 2535.304,
        duration: 5.165999999999713,
        id: 190100116,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2610.964,
        audio_start_offset: 2540.47,
        duration: 70.49400000000014,
        highlight_id: 5248971,
        highlight_words:
          "Yeah. I think it's hard to read people's non-verbal cues. Now, I'm not able to sit in. I just do the budgeting portion of it. So I've never sat in a mediation effort, but I think it comes down to, because of me, just my own experience, I wear binaural hearing aids. So a lot of times, I key in, I read lips. I can hear because of my hearing aids, but a lot of times, I also read a face to try to see what they're truly trying to convey. So I think we're missing that. We're missing the way people shuffle around at a meeting, or if they're tapping their pencil, I mean, you just... I miss that portion of it, but at the same time, I'm trying to be positive about it because this is now the new workforce. That's my take.",
        id: 190100117,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
        codes: [3, 11, 24, 28],
      },
      {
        audio_end_offset: 2629.15,
        audio_start_offset: 2610.964,
        duration: 16.65599999999995,
        id: 190100118,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2692.47,
        audio_start_offset: 2629.15,
        duration: 59.17000000000007,
        highlight_id: 5248972,
        highlight_words:
          "Well, I haven't had trouble. I don't know if anybody else has. I haven't had trouble with cameras off during bargaining or mediation, grievance mediation, or facilitate a dialogue. If there were, I would feel... I would say I wouldn't continue without the cameras being on. I'm sure I would. But with training, it's just different. You have this attitude of you either want to be there or you don't, and if you want to be there, you'll probably have your camera on and you'll engage. Sometimes, people with their cameras off still engage. They'll still chat or they'll still chime in. I've seen managers basically beg people to put their cameras on and they still don't. I don't want to have that fight. I'm not going to have that fight, but it's very... Sometimes I feel like I'm just talking to this black hole and I'm just amusing myself or something.",
        id: 190100119,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [3, 24, 28, 17, 15],
      },
      {
        audio_end_offset: 2695.47,
        audio_start_offset: 2692.47,
        duration: 3,
        id: 190100120,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2807.89,
        audio_start_offset: 2695.47,
        duration: 110.15200000000004,
        highlight_id: 5248973,
        highlight_words:
          "When it comes to training, I know Kathy, you know this because we were in training together, we went through our mediator training together. I come from a federal background. I was a federal HR manager for years and years. One of the biggest changes for me, and it was kind of epiphany of realizing that I spent years and years doing training for the federal government, that was about checking boxes, about making sure that I could document that I had given people the information that I was required to make sure they had, rather than doing training to teach people something. Whether you have to be there or you want to be there, I always felt with FMCS that we were trying to teach them something. We were really wanting to get them to come away with these skills or whatever it is we were trying to get out to them. The interactiveness of FMCS training was totally different from what the federal sector normally is. So I miss that and I think that's greatly impacted by us doing it online. I know everyone insists that we can do all this stuff online, but I think one of our big bonuses, and when I talk to people that I've done training with, how FMCS really gets out there, we're hands-on with them, the trainings are very interactive, we give them examples, we get them involved. You just don't get that same type of atmosphere, that interaction with the people online as you do when you've got them in a room and you are making them interact with you. I mean, it's much easier to do in a fun and interactive way in person that you... I just have not found that I've been able to do that to my satisfaction in a virtual form.",
        id: 190100121,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [3, 10, 11, 12, 44, 24, 28, 15, 16],
      },
      {
        audio_end_offset: 2899.25,
        audio_start_offset: 2807.89,
        duration: 85.0600000000004,
        highlight_id: 5248974,
        highlight_words:
          "There's also techniques that labor or management will use in their contract negotiations. One that came to mind is a funny story where were doing a virtual negotiation on our initial contract. Most of our contracts that were established already, they just signed one year or 18-month extensions to try to get past the pandemic. But the virtual contract, of course they didn't have anything to sign as far as extension grant was. So they continued to meet. They agreed to meet virtually for a while. I guess one of the techniques is to storm out of the room if something happens that you don't appreciate or whatever. You notify your team that, \"If it goes awry and I walk out, you follow me. Don't ask any questions, just gather your stuff and come on.\" We had a management chief spokesperson that did a virtual walkout. The rest of her team didn't know what was going on, so they just assumed she got booted. So they just kept on talking, communicating, trying to gain more insight and information. Then she comes back on and says, \"We're done here.\" So it's the equivalent of storming out and forgetting your car keys. Then you got to make that trip back in to reclaim them. But anyway, after that, she refused to meet virtual and everything went face-to-face, I guess, so she could clue her team in on what to do if she did something.",
        id: 190100123,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [4, 11, 24, 17],
      },
      {
        audio_end_offset: 2941.83,
        audio_start_offset: 2899.25,
        duration: 39.86999999999989,
        id: 190100125,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 2964.25,
        audio_start_offset: 2941.83,
        duration: 20.840000000000146,
        highlight_id: 5248975,
        highlight_words:
          "I've appreciated Eileen's [inaudible]. She's really positive and she looks at everything as a new opportunity, rather than a challenge. I've just appreciated the way that she has met all these challenges as opportunities. So that's good to see that attitude.",
        id: 190100126,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [5, 7, 43],
      },
      {
        audio_end_offset: 3005.95,
        audio_start_offset: 2964.25,
        duration: 40.590000000000146,
        highlight_id: 5248976,
        highlight_words:
          "would say Margie talking about her hearing aids. Disabilities are something that we don't, and especially in this virtual format, it's hard to see issues that people may have. I think it makes it even more incumbent on us to be making sure that we're paying attention to those things. I would never know from looking at Margie on here that she had hearing issues. Sometimes it's easier to pick up in person. I think I now worry about making sure that we're addressing those things in a virtual format that we don't realize they're out there because we're not really with the people to see those small things, or not small to them. I mean, but the small clues to us would trigger if we were in person.",
        id: 190100127,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [5, 11, 37, 40, 28, 15],
      },
      {
        audio_end_offset: 3049.97,
        audio_start_offset: 3005.95,
        duration: 40.960000000000036,
        highlight_id: 5248977,
        highlight_words:
          "liked Mark's story about the chief spokesman marching out of the room without her people following her. What I've tried to do in the Zoom is I mention in my opening statement there's so called zoom fatigue, and we can have breaks, much more easy breaks. When I see that people are needing a break, I try to do it, imaginary coffee breaks, or whatever, to see if we can get more productive meetings, but I like your stories, Mark. I can see how you'd be a very effective mediator.",
        id: 190100128,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [5, 10, 11, 31, 19],
      },
      {
        audio_end_offset: 3067.16,
        audio_start_offset: 3049.97,
        duration: 17.190000000000055,
        highlight_id: 5248978,
        highlight_words:
          "Barbara, just to tell you something I've done is I create a breakout room called timeout room. If I get somebody that's yelling and I'm trying to shut them down and they won't listen, they will find themselves in the timeout room.",
        id: 190100129,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [4, 5, 15, 16],
      },
      {
        audio_end_offset: 3070.592,
        audio_start_offset: 3067.16,
        duration: 3.274000000000342,
        id: 190100130,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 3077.3,
        audio_start_offset: 3070.592,
        duration: 6.708000000000084,
        id: 190100131,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 3087.68,
        audio_start_offset: 3077.3,
        duration: 10.379999999999654,
        id: 190100132,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
      },
      {
        audio_end_offset: 3089.39,
        audio_start_offset: 3087.68,
        duration: 1.2600000000002183,
        id: 190100133,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 3117.45,
        audio_start_offset: 3089.39,
        duration: 21.870000000000346,
        highlight_id: 5249003,
        highlight_words:
          "I used to make four. I still of my four, but I used to name one, the company, the union, sidebar, and my office until somebody said, \"We don't want to go to your office. It's like going to the principal's office.\" I didn't even think about that in terms when I was naming it, but it was the same thing of someplace just for me to go if I needed to. So now I just name the one extra rather than my office.",
        id: 190100134,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [4, 5, 15, 16],
      },
      {
        audio_end_offset: 3151.33,
        audio_start_offset: 3117.45,
        duration: 24.870000000000346,
        highlight_id: 5249004,
        highlight_words:
          "Well, I'm just thankful that I was given this opportunity to collaborate with all of you on this. I think each of your stories and each of your responses were wonderful. I thought it was very intelligent, a very intelligent, very well thought discussion. So I appreciate all of you and thank you every for what you do.",
        id: 190100135,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
        codes: [7, 41, 33, 43, 45],
      },
      {
        audio_end_offset: 3160.27,
        audio_start_offset: 3151.33,
        duration: 7.539999999999964,
        id: 190100136,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3291.44,
        audio_start_offset: 3160.27,
        duration: 129.3800000000001,
        highlight_id: 5250450,
        highlight_words:
          "I would agree with Eileen about the virtual fatigue. I've been in a few meetings where they have literally gone all day and the people may have had two 15-minute breaks and I don't know how they do it, because I know I... And they were the presenters, but I was there and it was interesting information. But after a while, you're just like, \"I can't sit here for that long,\" or, \"I can't not move for eight hours straight.\" I don't know. I applaud mediators for trying to do this virtually because I just know, especially RDTs, the training part because it's really hard to hold people's attention and to do this virtually is even harder. So I applaud everyone for trying to do training virtually because, to me, and CBMs, because collective bargaining, of course, you need that one-on-one, you need that interaction. So yeah, that resonated with me completely as the virtual fatigue. Definitely. I do feel like some of the, not really supervisors, but the people that you interact with want you to be there eight hours, nine hours, 12, because it is virtual and they're like, \"Where else do you have to go?\"",
        id: 190100137,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
        codes: [5, 11, 24, 31, 28, 15, 19],
      },
      {
        audio_end_offset: 3305.99,
        audio_start_offset: 3291.44,
        duration: 14.549999999999727,
        id: 190100139,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3308.43,
        audio_start_offset: 3305.99,
        duration: 2.4400000000000546,
        id: 190100140,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 3310.73,
        audio_start_offset: 3308.43,
        duration: 2.300000000000182,
        id: 190100141,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3312.77,
        audio_start_offset: 3310.73,
        duration: 2.0399999999999636,
        id: 190100142,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 3314.986,
        audio_start_offset: 3312.77,
        duration: 2.0720000000001164,
        id: 190100143,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3316.58,
        audio_start_offset: 3314.986,
        duration: 1.4239999999999782,
        id: 190100144,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 3317.794,
        audio_start_offset: 3316.58,
        duration: 1.1779999999998836,
        id: 190100145,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3324.59,
        audio_start_offset: 3317.794,
        duration: 6.166000000000167,
        id: 190100146,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 3548.53,
        audio_start_offset: 3324.59,
        duration: 216.79000000000042,
        highlight_id: 5250452,
        highlight_words:
          "Wow. Yeah. That was tough. As I listen to all of you, each one of your stories, first of all, I learned something new today. One, I'm going to create a timeout room in my virtual meetings. Mark, thank you. I love it. I've not heard of that. So I appreciate learning that today. Teri, I'm also going to create a room for me. I also learned that. Eileen, Mark recognized your positive approach with opportunities. I like to think that I am the same way. So that really resonated as soon as you spoke to that. I'm like, \"Wow, how positive is that?\" So that was just sunshine to me. Margie, you talk about having hearing aids and listening virtually and how difficult that is. Literally, as you were talking about shuffling the papers and tapping the pen, I am picturing that in my mind and hearing that sound and listening to that as you described that and why that resonates with me, over the last two years through some medical challenges, I've had severe hearing loss.",
        id: 190100147,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
        codes: [5, 11, 41, 34, 16],
      },
      {
        audio_end_offset: 3604.204,
        audio_start_offset: 3548.53,
        duration: 54.56999999999971,
        highlight_id: 5250454,
        highlight_words:
          "I think that it's going to look a lot like it's going to look on April the 15th. I think that we're going to continue to have a lot of virtual, especially public sector, private sector, just because of the cost savings. The success rate hasn't really changed in the virtual setting in federal sector mediations, at least from my perspective. So we're still posting good success rates and doing it virtually. So the cost savings, that's going to remain. The opportunity to go face-to-face is going to give us the opportunity to rebuild that customer base that desires that more than they desire the virtual interaction. So I think that's pretty much going to be the wave of the future and I'm actually looking forward to it because I think it's going to be productive for all of us having the multiple formats and the multiple opportunities to meet the needs of our customers.",
        id: 190100151,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [6, 10, 11, 12, 15],
      },
      {
        audio_end_offset: 3618.272,
        audio_start_offset: 3604.204,
        duration: 13.909999999999854,
        id: 190100152,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3643.456,
        audio_start_offset: 3618.272,
        duration: 24.990000000000236,
        highlight_id: 5249011,
        highlight_words:
          "Oh, absolutely. Absolutely. It's such a large part of our business scope here. We don't have a lot of federal sector. We don't have a lot of private sector, or we don't have a lot of federal and public sector. So private sectors are the main scope of work that we have here. So we've got to rebuild that up if we're going to be effective in this area at all.",
        id: 190100153,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [3, 10, 12],
      },
      {
        audio_end_offset: 3645.79,
        audio_start_offset: 3643.456,
        duration: 0.7439999999996871,
        id: 190100154,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3709.49,
        audio_start_offset: 3645.79,
        duration: 63.69999999999982,
        highlight_id: 5250455,
        highlight_words:
          "I would add, I think we're going to have more services that we're going to provide. We've already seen a card check as one. We used to do it and now we may be doing it again. I also said that we used to help people with strike votes and ratification votes. I think if we look at FMCS as an organization that can add value to unions and management, we're going to be asked to do more. Also, conflict within groups, affinity groups that are having trouble. The gig economy, where they may not be organized yet, but they may well be a specific number of employees together, or maybe they're not employees, but perhaps defined as employees or independent contractors. I think we're going to see that people are going to see that what we provide is useful and helpful. I think we're going to end up with more functions than we had and managing that is going to be a challenge.",
        id: 190100155,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [6, 10, 16],
      },
      {
        audio_end_offset: 3717.512,
        audio_start_offset: 3709.49,
        duration: 7.984000000000378,
        id: 190100156,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3766.08,
        audio_start_offset: 3717.512,
        duration: 48.567999999999756,
        highlight_id: 5250456,
        highlight_words:
          "Yeah. Well, I look at the British mediation service, which is called ACAS, Advisory Conciliation and Arbitration Service, and they actually help non-union folks too. But for the most part, there's a national law, which might eventually come here, for a protection against unfair dismissal and gives protections. The mediators, in their case, it's called an individual conciliator, actually helps get them to be, get the issue resolved before it goes to a tribunal. Also, I see us spreading grievance and arbitration provisions a little further than they have now. I mean, I just see the potential there for more for the agency to do.",
        id: 190100157,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [6, 10, 38],
      },
      {
        audio_end_offset: 3770.61,
        audio_start_offset: 3766.08,
        duration: 3.3600000000001273,
        id: 190100158,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3804,
        audio_start_offset: 3770.61,
        duration: 33.38999999999987,
        highlight_id: 5250457,
        highlight_words:
          "I was thinking about it from an internal perspective. I'd like to have more peace within the agency. I know we've had a rough few years in terms of, especially in terms of the field versus headquarters, and I'd really like us... We have so many tools that we teach people on a daily basis, and I feel like everything's at our fingertips and I'd like to see us find a way to use those tools and just, why can't we just get along?",
        id: 190100159,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [6, 41, 38],
      },
      {
        audio_end_offset: 3815.29,
        audio_start_offset: 3804,
        duration: 10.300000000000182,
        id: 190100160,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 3857.31,
        audio_start_offset: 3815.29,
        duration: 40.679999999999836,
        highlight_id: 5249015,
        highlight_words:
          "Well, I will say I think I see those changes happening now. I definitely see a lot more inclusion in listening to voices. So I think we're on that track actually. So I think we're doing a lot of that. I just think sometimes there's a disconnect between the field and headquarters and sometimes that gets on a role and creates a divide. I'd like to see us continue to focus on that, because I think it has been a focus and, feel more like one unified agency.",
        id: 190100161,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [6, 37, 38, 40],
      },
      {
        audio_end_offset: 3864.91,
        audio_start_offset: 3857.31,
        duration: 0.9299999999998363,
        id: 190100162,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4007.21,
        audio_start_offset: 3864.91,
        duration: 140.86600000000044,
        highlight_id: 5250458,
        highlight_words:
          "I'll take my turn now. I do see FMCS as a growing agency. I actually, when I came from the Navy, I was very surprised at the amount of personnel here in this agency. I'll tell you, coming from a Navy area where there was 2,500 employees and, in budgeting, we did the operations for all 2,500 employees. So it was like to me taking a step down in the amount of employees and the amount of budgeting that we to execute per year. But I do see that FMCS, in my opinion, is actually a lot better than what the Navy is as far as giving opportunities, listening to people. I mean, you got the best of all worlds right here. You got mediators, you got [conciliators], you got every thing here. I think that's what makes FMCS unique because you have everything right there. As far as technology-wise, I think we're continuing to grow that. I know in the budget area, we're doing more better with invoicing. We're introducing more things to do the invoicing and collect payments. I know we're trying to do better with IT. Bringing in the IT, getting new systems in place. So things don't have to be so, I don't want to say hands on, but things don't have to be so labor intensive. I mean, I am, for one, I'm happy to be here with FMCS and I look forward to seeing what's going to happen",
        id: 190100163,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
        codes: [6, 37, 38, 35, 15],
      },
      {
        audio_end_offset: 4011.8,
        audio_start_offset: 4007.21,
        duration: 4.5900000000001455,
        id: 190100165,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4191.33,
        audio_start_offset: 4011.8,
        duration: 176.76800000000094,
        highlight_id: 5250459,
        highlight_words:
          "we all know that the reality is the union density is going down and continues to go down in house for a long time. So I would hope that we could look at ways to get other funding other than specifically contracts where we have agreements with another agency to do their ADR. I would hope that we could look at ways of getting other funding where we're not having to directly build people under those type of contracts. So where we could get out into our communities and be the ADR specialists virtually, in person, the globally type of ADR. I mean, we have issues. I've had some people approach me that are talking about doing... It's union in a way, because it's [AFL Brandoff] trying to set up a mediation cadre of people that can work with their members and the community in not just workplace mediation, but maybe community mediation with the schools or with other things where we could go in and help train these people and provide mediation skills in schools that may not unionized, but hey, we've got this issue in our community where we're trying to get these parents and this school board and those type of things. We have such a deep knowledge base that we could provide to our communities, which could make our communities that we live in so much better and helping them to deal with situations that just need somebody to come in and be what we are, that mediator, that person that comes in and has neutral and just tries to get everybody to just get along. I mean, we have that skill and it translates not just to those union situations, but to our communities in general. As our workload changes, I think that is a field and an opportunity for us that's out there that I hope that our management is looking at exploring because it's greatly needed and we could benefit people so much. I mean, we have systems here in, where I'm in Phoenix, Maricopa County, has courts where they have mediation for the courts for small claims court, but also for domestic courts, divorce courts, where they have mediation things. I have a friend who is working in another state with a group that is training people to do mediations for domestic issues. I mean, so there's a lot of mediation work out there that's not specifically covered by our direct funding, which I think we should be hopefully exploring on ways to get funding for that, because it would be nice to have some consistency available, all different states, all different communities. I think we are the cadre that could provide that.",
        id: 190100166,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [6, 11, 38, 16],
      },
      {
        audio_end_offset: 4289.91,
        audio_start_offset: 4191.33,
        duration: 97.31200000000081,
        highlight_id: 5250460,
        highlight_words:
          "But I think your question was about the FMCS of the future. I'd like it to be more representative of America so that we would have more perhaps Spanish-speaking mediators. I know that David [Thaylor] could use a few when we were working with Mexico, but also people of color, people of Asian and other kinds of, and genders. I really think we could be a little more diverse than we are and still have our base union and management. But I believe we can be more developmental and even change the face of our arbitration roster a little bit. Years ago, FMCS had a particular retraining or training program for new arbitrators and they were diverse and they got companies and unions to agree to give them a chance. So they had some guaranteed employment, but I think we can look at ourselves as trying to expand the field of conflict resolution.",
        id: 190100169,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [6, 37, 38, 40],
      },
      {
        audio_end_offset: 4303.75,
        audio_start_offset: 4289.91,
        duration: 6.100000000000364,
        id: 190100171,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4344.49,
        audio_start_offset: 4303.75,
        duration: 40.350000000000364,
        highlight_id: 5250461,
        highlight_words:
          "My hopes for the future with FMCS is that we would gain more business, whether it's through ADR or community involvement or... Because yeah, CBM seems to be dwindling, but I still think it's very viable. I think we still have a dog in the fight, if you will, with collective bargaining, but my hopes would be yes, to broaden our horizons and gain more customers and the abilities to go out there and help communities and conflict resolution. That's what I hope for, for FMCS, to keep us strong in doing what we love to do.",
        id: 190100172,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
        codes: [6, 10, 12],
      },
      {
        audio_end_offset: 4453.37,
        audio_start_offset: 4344.49,
        duration: 104.89800000000105,
        id: 190100173,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4505.16,
        audio_start_offset: 4453.37,
        duration: 50.409999999999854,
        highlight_id: 5250462,
        highlight_words:
          "It's been good for me to [inaudible]. Even though we're part of a huge family, sometimes you still get the feeling that you're out on the island, you're kind of out here, stationed alone in the middle of nowhere. So it's good for me to have the interaction with others and to see the positivity because you know when you're left to your own devices, you always go negative. I don't know why we're built that way, but we tend to be. So it's good to see the positivity and the renewal of hope and promise that others see so that you can see it too, because sometimes you get a little negative, you get a little down. So I'm looking forward to the progress. I'm looking forward to going forward. I'm looking forward to the opportunities.",
        id: 190100175,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [7, 43, 24],
      },
      {
        audio_end_offset: 4516.17,
        audio_start_offset: 4505.16,
        duration: 10.61999999999989,
        id: 190100176,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4578.09,
        audio_start_offset: 4516.17,
        duration: 61.92000000000007,
        highlight_id: 5250463,
        highlight_words:
          "I actually feel better. I mean, I still face the same challenges. That hasn't been resolved in the last hour or two, but at least I think that I'm going to go at it with a better attitude than maybe what I was looking at before I came into the meeting. Because I was really dreading having to rebuild those relationships or at least reestablish our agency's worthiness or our customer base in this area. But listening to people, I think we can approach it a whole lot different direction and probably rebuild that pretty quick. Because it's not like I'm a new guy in a new area. It's just reestablishing old relationships, not rebuilding new ones or not building new ones. So it should be better attitude. [inaudible].",
        id: 190100177,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
        codes: [3, 7, 12, 43],
      },
      {
        audio_end_offset: 4586.23,
        audio_start_offset: 4578.09,
        duration: 0.930000000000291,
        id: 190100178,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4732.534902216427,
        audio_start_offset: 4586.23,
        duration: 145.85690221642744,
        highlight_id: 5250464,
        highlight_words:
          "I guess I can go next. I think it's nice to, like Mark said, we're all kind of out here alone, even though we're having all these meetings. It's nice to get with a different group and realize, \"Yes, we're all going through the same thing. We're persevering, we're looking at what our next steps are to try to move forward in this.\" I think we all... We're there for each other, whether we forget that. You can give somebody a call and say, \"Hey, have you done this,\" or, \"Can I help with that?\" But as far as the technology, it's nice to know... I mean, I think we've all gotten to the point we're acknowledging that this is what's going to happen. Technology is going to be a big part of our future, no matter what we do. I think it's important that our agency continues to look at all of the different things that are coming out as this evolves and to research them, to try to give us the best tools we can to do our job or having to surmount that fact that we can't be there in person no longer they want us there in person. So having the best systems and things in place to be able to use without being too overly burdensome, because, I'll be honest, sometimes some of it is more work than it's worth in the long run. I mean, that's just a reality. I think we can all acknowledge that. There's some things out there, while they're great, your bang for your buck is just not there. So it's nice that the agency is continuing to look at different things to give us other options to use. I appreciate that when something isn't the best, that they are doing what they can to get rid of that and get us [the]. I had issues constantly with RingCentral. I mean, for a while, it was a nightmare. They had to take it all off my computer, redo it. I had to take it off. It was just... When that went away, I was like, \"Good riddance.\" You know what I mean? So I'm still struggling a little bit with MS Teams. It's not my favorite. I liked Zoom much better. I'll be honest, most of the customers I have, other than a few federal agencies, like Zoom better. The MS Teams and the different rooms and how that's set up for us working, to me, I think is burdensome as opposed to Zoom. But I just, like I said, I like the fact that we're not going, \"Well, we've got something and we're done looking.\" We're not doing that. The guys at our agency know what our challenges are and I think they are actively trying to get us the best things they can so that we can go forward as well prepared and as many options as we possibly",
        id: 190100179,
        speaker_id: 2,
        speaker_name: 'Speaker TA',
        codes: [7, 13, 11, 41, 33, 43, 24, 15, 16],
      },
      {
        audio_end_offset: 4857.55,
        audio_start_offset: 4732.534902216427,
        duration: 109.50709778357304,
        highlight_id: 5250465,
        highlight_words:
          "Yeah. I would just add everything that Mark and Teri said, I agree with. I didn't know what this was going to be. Since Kevin is a very persuasive salesman, I said, \"All right, I'll do it.\" But I think it was a good opportunity. I met people that I've dealt with, like Margie, Charlene, who I've never really seen and knew people like Mark, who I may have met, but really haven't interacted with, and Kathy. So it's been really great in that respect. Also for Mark, I just wanted it to tell a tiny, short story that helped me when we first had the pandemic and we were told not to do any face-to-face. I told a story to a union official who said, \"We want to meet with you.\" I said, \"Well, our boss doesn't want us to.\" He tells a story about a group, which is a union group. You were in a small room, everyone's excited and talking. The mediator was told not to meet with the people. So he said, \"Okay, I'll the first meeting, you do it yourself.\" He called the next day to find out or the next week and he found out that everybody caught COVID from that group. So it wasn't being done for any bad reason, but that's why our boss said, \"We want to meet remotely.\" That one won them over, at least, for that particular group. But I've learned a lot and I want to thank Kathy and the whole group.",
        id: 190100182,
        speaker_id: 7,
        speaker_name: 'Speaker EA',
        codes: [7, 11, 41, 35, 43],
      },
      {
        audio_end_offset: 4868.19,
        audio_start_offset: 4857.55,
        duration: 5.599999999999454,
        id: 190100184,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 4876.33,
        audio_start_offset: 4868.19,
        duration: 8.140000000000327,
        id: 190100185,
        speaker_id: 3,
        speaker_name: 'Speaker MB',
      },
      {
        audio_end_offset: 5005.784,
        audio_start_offset: 4876.33,
        duration: 128.07800000000043,
        id: 190100186,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5007.142,
        audio_start_offset: 5005.784,
        duration: 1.1900000000005093,
        id: 190100188,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5014.79,
        audio_start_offset: 5007.142,
        duration: 5.69800000000032,
        id: 190100189,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5016.11,
        audio_start_offset: 5014.79,
        duration: 0.8699999999998909,
        id: 190100190,
        speaker_id: 6,
        speaker_name: 'Speaker MA',
      },
      {
        audio_end_offset: 5016.694,
        audio_start_offset: 5016.11,
        duration: 0.5480000000006839,
        id: 190100191,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5018.51,
        audio_start_offset: 5016.694,
        duration: 0.7659999999996217,
        id: 190100192,
        speaker_id: 4,
        speaker_name: 'Speaker CB',
      },
      {
        audio_end_offset: 5019.274,
        audio_start_offset: 5018.51,
        duration: 0.6679999999996653,
        id: 190100193,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5020.49,
        audio_start_offset: 5019.274,
        duration: 0.6459999999997308,
        id: 190100194,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5024.15,
        audio_start_offset: 5020.49,
        duration: 2.850000000000364,
        id: 190100195,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5026.55,
        audio_start_offset: 5024.15,
        duration: 1.8299999999999272,
        id: 190100196,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5048.45,
        audio_start_offset: 5026.55,
        duration: 20.859999999999673,
        id: 190100197,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5071.53,
        audio_start_offset: 5048.45,
        duration: 21.980000000000473,
        id: 190100198,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5071.884,
        audio_start_offset: 5071.53,
        duration: 0.3280000000004293,
        id: 190100199,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5096.16,
        audio_start_offset: 5071.884,
        duration: 24.27599999999984,
        id: 190100200,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5096.561945364238,
        audio_start_offset: 5096.16,
        duration: 0.4019453642385997,
        id: 190100201,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5129.23,
        audio_start_offset: 5096.561945364238,
        duration: 32.66805463576111,
        id: 190100202,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5146.55,
        audio_start_offset: 5129.23,
        duration: 16.340000000000146,
        highlight_id: 5250466,
        highlight_words:
          "There's a secret sauce to what went on today. I was just curious. I guess, because my check-in was intellectual. I was just trying to figure out... Yeah. I was trying to figure out what the secret sauce was because I thought it was a really, really strong conversation.",
        id: 190100203,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
        codes: [7, 43, 45],
      },
      {
        audio_end_offset: 5150.564,
        audio_start_offset: 5146.55,
        duration: 3.8679999999994834,
        id: 190100204,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5151.536,
        audio_start_offset: 5150.564,
        duration: 0.7779999999993379,
        id: 190100205,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5162.228,
        audio_start_offset: 5151.536,
        duration: 10.510000000000218,
        id: 190100206,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5170.652,
        audio_start_offset: 5162.228,
        duration: 8.265999999999622,
        id: 190100207,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5171.564,
        audio_start_offset: 5170.652,
        duration: 0.9120000000002619,
        id: 190100208,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5173.616,
        audio_start_offset: 5171.564,
        duration: 2.037999999999556,
        id: 190100209,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5180.1397406593405,
        audio_start_offset: 5173.616,
        duration: 6.523740659340547,
        id: 190100210,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5184.356,
        audio_start_offset: 5180.1397406593405,
        duration: 4.02225934065973,
        id: 190100211,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5186.312,
        audio_start_offset: 5184.356,
        duration: 1.956000000000131,
        id: 190100212,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5187.284,
        audio_start_offset: 5186.312,
        duration: 0.8260000000000218,
        id: 190100213,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5187.728,
        audio_start_offset: 5187.284,
        duration: 0.3820000000005166,
        id: 190100214,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
      {
        audio_end_offset: 5188.75,
        audio_start_offset: 5187.728,
        duration: 0.6739999999999782,
        id: 190100215,
        speaker_id: 5,
        speaker_name: 'Speaker BB',
      },
      {
        audio_end_offset: 5194.72,
        audio_start_offset: 5188.75,
        duration: 5.970000000000255,
        id: 190100216,
        speaker_id: 0,
        speaker_name: 'Speaker KB',
      },
    ],
  },
  {
    duration: 5877.4465,
    speaker_count: 6,
    id: 1902,
    snippets: [
      {
        audio_end_offset: 330.74,
        audio_start_offset: 3.07,
        duration: 321.288,
        id: 190200000,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 332.00941815632666,
        audio_start_offset: 330.74,
        duration: 1.2694181563266511,
        id: 190200008,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 333.27883631265337,
        audio_start_offset: 332.00941815632666,
        duration: 1.269418156326708,
        id: 190200009,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 334.54825446898,
        audio_start_offset: 333.27883631265337,
        duration: 1.2694181563266511,
        id: 190200010,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 335.81767262530667,
        audio_start_offset: 334.54825446898,
        duration: 1.2694181563266511,
        id: 190200011,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
      },
      {
        audio_end_offset: 671.772,
        audio_start_offset: 335.81767262530667,
        duration: 326.54432737469347,
        id: 190200012,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 687.93,
        audio_start_offset: 671.772,
        duration: 15.587999999999965,
        id: 190200020,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 688.908,
        audio_start_offset: 687.93,
        duration: 0.7960000000000491,
        id: 190200021,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 717.69,
        audio_start_offset: 688.908,
        duration: 28.78200000000004,
        id: 190200022,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 722.43,
        audio_start_offset: 717.69,
        duration: 2.919999999999959,
        id: 190200023,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 775.89,
        audio_start_offset: 722.43,
        duration: 52.7560000000002,
        id: 190200024,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 780.33,
        audio_start_offset: 775.89,
        duration: 3.4600000000000364,
        id: 190200026,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 847.47,
        audio_start_offset: 780.33,
        duration: 66.19599999999991,
        id: 190200027,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 853.542,
        audio_start_offset: 847.47,
        duration: 6.072000000000003,
        id: 190200029,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 868.75,
        audio_start_offset: 853.542,
        duration: 14.27800000000002,
        id: 190200030,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
      },
      {
        audio_end_offset: 995.47,
        audio_start_offset: 868.75,
        duration: 121.42399999999998,
        id: 190200031,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 997.01,
        audio_start_offset: 995.47,
        duration: 1.5399999999999636,
        id: 190200034,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 997.65,
        audio_start_offset: 997.01,
        duration: 0.6399999999999864,
        id: 190200035,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1001.05,
        audio_start_offset: 997.65,
        duration: 1.8100000000000591,
        id: 190200036,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 1001.644,
        audio_start_offset: 1001.05,
        duration: 0.5080000000000382,
        id: 190200037,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1320.3124832681442,
        audio_start_offset: 1001.644,
        duration: 313.0884832681445,
        id: 190200038,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 1320.3150082572795,
        audio_start_offset: 1320.3124832681442,
        duration: 0.00252498913528143,
        id: 190200046,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1366.03,
        audio_start_offset: 1320.3150082572795,
        duration: 44.844991742720595,
        highlight_id: 5249390,
        highlight_words:
          "think one challenge is that this environment has kind of put us into some silos more than it has been before. I think by that I mean there are less opportunities for us to engage with one another in person and even sometimes in groups as an agency. So I think, in some ways, it's reinforced some of the group biases that we all have in our groups because I think we're operating more within the groups than interacting with the groups that we're not, and I'm talking about within FMCS, that we normally have engaged with. So I think that is a challenge and hopefully we'll have opportunities around that.",
        id: 190200047,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [3, 38, 34, 35, 24],
      },
      {
        audio_end_offset: 1371.772,
        audio_start_offset: 1366.03,
        duration: 5.703999999999951,
        id: 190200048,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1661.918,
        audio_start_offset: 1371.772,
        duration: 287.1860000000004,
        id: 190200049,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 1669.624,
        audio_start_offset: 1661.918,
        duration: 7.044000000000096,
        id: 190200056,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1841.65,
        audio_start_offset: 1669.624,
        duration: 168.9359999999997,
        highlight_id: 5249393,
        highlight_words:
          "So probably piggybacking off of a lot of what Ron and also Tom said, but basically we've been able to travel the country without leaving our office or our home offices. So those have been real opportunities. I worked on a number of projects, be it Ohio, be it working on some projects with others out on the West Coast. So it has really been an opportunity to probably meet people that I haven't even met in person, and we felt like we've known each other for quite some time because we've been working as if we've been co-mediating for a long period of time. So that's been a good opportunity, plus it's kind of holistic, too, because less traffic means more time that you could spend in your home life, although sometimes albeit separating yourself from the office at the end of a certain day. So that could be a challenge and also opportunity. But if you take advantage of your environment, especially in the springtime, and do some of your exercises and not have to go to the gym, do different things sometimes midday sometimes, but probably more so in the morning before you start to work. So all of those things have been great opportunities. I found that when we started that we were able to ratchet up. Our agency was able to ratchet up because I think some of these things had been discussed and placed. Some of the other, slower organizations such as AAA, such as some of the ... They didn't have their act in order. So we were able to provide this service even if they didn't necessarily need us in mediation. Usually if you go in to facilitate, you're going to go in and probably also get active in that case. So I was getting active maybe in construction, folks that probably usually never used the mediation service or have used it very little, and then being able to really get active in their case. So that was an opportunity, dealing with folks that you might not have worked with previously in person. Some of the challenges and also really learning some of the software in terms of incorporating some of the software, such",
        id: 190200057,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [8, 2, 10, 11, 12, 33, 35, 25, 26, 30, 15, 22, 20, 21],
      },
      {
        audio_end_offset: 1845.07,
        audio_start_offset: 1841.65,
        duration: 1.8299999999999272,
        id: 190200061,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 1927.81,
        audio_start_offset: 1845.07,
        duration: 79.52000000000021,
        highlight_id: 5249394,
        highlight_words:
          "Yeah, no. Some of those things that facilitate, especially at RDTs. Now, I do find RDTs very challenging because sometimes if you have a group of folks that want to be off-camera because they think that they're going to come to a training and not necessarily participate, so = sometimes that could be very challenging in terms of delivering. If you don't really have that energy going back and forth, that may be a problematic. So some of the training has been a lot more challenging than, say, delivering a CBM or some other form of intervention. I find certain programs or platforms to be a little bit more challenging in terms of doing CBM work, such as Teams, and some of the limitations of our clients not to have the ability to go onto Zoom and those types of platforms. So having those types of challenges because Teams in terms of break rooms and caucuses and everything, I don't know where I am usually in terms of whether I'm in the main room, whether I booted myself out of the meeting. So some of those pieces are challenges. But basically, I find probably a lot more opportunities than challenges.",
        id: 190200062,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [3, 2, 13, 10, 11, 12, 30, 29, 15, 16],
      },
      {
        audio_end_offset: 1942.43,
        audio_start_offset: 1927.81,
        duration: 14.620000000000118,
        id: 190200064,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 2106.95,
        audio_start_offset: 1942.43,
        duration: 160.45399999999995,
        highlight_id: 5249397,
        highlight_words:
          "I'll probably just echo most of what everybody else said, so I'll try to keep it short and to the point. But I mean first off, just opportunities around the pandemic, I'm first off just thankful to still be gainfully employed, particularly early on, because not everyone had that opportunity to continue working. So I'm thankful for that. I guess being somebody who was under five years when this started, I guess, and someone who's in a younger generation, I guess the idea that I was able to provide assistance to those people who were very seasoned as mediators in the technology to the point now where, even with the meeting tech stuff. But to the point now where people are not as reliant on me helping them or showing them how to do something. People are just able to do things on their own without so much assistance. It's had me become more familiar with the virtual services that the agency provides, which was helpful. But some of the challenges really were the loss of personal connections with ... I'm not here to make friends with any of the clients we work with. But coming in under five years, I don't really know the labor relations community as well as some of the people who have been here for 20 years when we went virtual. I noticed that when I started going back to in-person meetings recently that there's just the same opportunities that come up where you pass somebody in the hallway or where somebody comes to talk to you at the water cooler. It's just not as possible in the virtual environment. Those are the moments that you need to start building more respect and more trust with people in order for them to start to work well with you. I was able to learn that what I thought was a nice compliment down South, \"Bless your heart,\" is not as nice as I thought it was. I was able to learn that sweatpants are workplace-appropriate in a virtual environment. But when you start to go back to in person, you might want to give yourself a couple weeks' lead time to get those work pants tailored to get them let out for all that pandemic weight gain. So those are some of the challenges, I guess, that I faced.",
        id: 190200065,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [3, 2, 13, 10, 11, 12, 35, 26, 28, 30, 29, 15, 16],
      },
      {
        audio_end_offset: 2256.55,
        audio_start_offset: 2106.95,
        duration: 144.05000000000064,
        id: 190200069,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 2259.16,
        audio_start_offset: 2256.55,
        duration: 2.6099999999996726,
        id: 190200073,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 2259.67,
        audio_start_offset: 2259.16,
        duration: 0.5100000000002183,
        id: 190200074,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 2487.55,
        audio_start_offset: 2259.67,
        duration: 226.04599999999982,
        highlight_id: 5249406,
        highlight_words:
          "I don't know if this is really what you're looking ... But it was an opportunity when it happened for me. Sometime back, probably about 2005, I was called by my DM that I was chosen to go to Ghana. That was an opportunity out of ... It was not even on my radar that I was being selected for Ghana or for international travel. Once there, I was able to work with a mediator that has since retired. I know his name so well, and it just skipped my mind just like that, but it'll come back to me. He was from Minnesota, and I was able to work with him, Glenn Tarkowski. So we both went to Ghana, and we were there from ... When we got off the plane, it was from start to finish. So not only did we have to put the program, it was at that time where we didn't have all of the technology where we can go on and take off from a platform or from software or from things that we have within our tool belt just right in a database file. We were not able to do that when we hit the ground running. So we had to spend within the time that we were there, within those two weeks that we were there, we had to spend the time putting the program together. So that took time. We had some of our international cohorts that also was on the presentation team that we worked with in terms of putting that program together. I've since done international since then and we were able to take from the database, our electronic database that we have so much available. So I said, at that point in time, that would have been an opportunity had we had it. But it also was a challenge and challenged us, a stimulating challenge in terms of being able to get on the ground, see what the needs of our customers, and put a program together that fit those needs along with working, again, with the international cohorts to get that together. I think those were opportunities and also challenges and also the opportunity to see how hungry they were, the folks that we were training, that they were hungry for the knowledge because they saw this as a career benefit. We were training potential arbitrators and mediators in their field of practice, that they took this training seriously. So I found myself on a Friday night that most people in the United States want to be out by 4:00 to get on with their lives, they were there from the time that we started in the morning into the evening and still hungry for sitting there and listening to these two trainers from the United States that they believed were coming from an agency that had the knowledge, that had the capabilities to provide and to convey for them in terms of their practices. So that was a real stimulation and I felt as an opportunity and some of the challenges that went along with it.",
        id: 190200075,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [3, 8, 2, 13, 10, 12, 30, 15],
      },
      {
        audio_end_offset: 2508.976975228162,
        audio_start_offset: 2487.55,
        duration: 21.42697522816161,
        id: 190200080,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 2759.752,
        audio_start_offset: 2508.976975228162,
        duration: 244.40502477183873,
        highlight_id: 5249409,
        highlight_words:
          "Yeah. Vanessa, I don't know if I was going to talk about this, but your memory spurred one I had. There's so many experiences that were just amazing to me in this last couple years, one of them in particular. I was asked to assist with a team out of Pete Swanson's unit that was doing some work virtually in Taiwan. There were so many things that were interesting and unique about this for me. I was working with Peter Chang and Ron Simms and David Thaler and Eileen Hoffman and then this minister of labor from Taiwan, labor groups, groups from industry, and I think there were some neutrals. The fact that we were working with a culture I was being introduced to and languages that I was hearing first time, so we had that as well as technology that was interesting and that we were using, the Zoom.gov, interpretations channels that worked really well. Even that process of getting to the Zoom.gov as a platform was a process because initially they had some skepticism about using things they'd heard about Zoom that were early in the pandemic. I remember there was worries that the servers were in mainland China, so this is Taiwan and there's implications for that. It turns out we were able to give them everything we had on Zoom.gov, and the servers are all in the United States, by the way, if you wonder. And then we navigated that issue and then just the whole process. The meetings would start at 5:00 p.m. my time. That's different. They'd go several hours in the night. I enjoyed it. My day fluctuates as far as time based upon what I'm working with. A lot of my people I'm working with during the East Coast, so it starts early and sometimes it gets done a little earlier. But sometimes things on the West Coast go longer, so I'm used to that. I like that part of my job because it's different. I still feel like I have ability, as Vanessa mentioned earlier, to have some balance in my life. I'm really grateful for that. But it was fascinating. We actually are going to have another project coming up with this group, and I'm excited about it because I learned so much. The technology piece was fine, but that's what I do a lot of the time anyway. But what I was fascinated with was getting to be immersed, at least for a time, with people from other cultures and how fascinating and how receptive they are to conflict resolution, mediation, trying to get better at their practice, and learn more about what FMCS has been doing for a while. My understanding, there's been a partnership with Taiwan for some time. I think there were some in-person visits, as Vanessa described, before. But yeah. That's just one experience, but I was glad that your memory triggered my memory because it was a really special one for me, and I hope to be able to do more of those. I'd like to be able to do some in-person trips like that. I understand that you work. It's not like you're sitting around. Everyone that's ever gone on one says you hit the ground running and you work, work, work, work, work.",
        id: 190200081,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [],
      },
      {
        audio_end_offset: 2763.17,
        audio_start_offset: 2759.752,
        duration: 3.41800000000012,
        id: 190200087,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 2764.638,
        audio_start_offset: 2763.17,
        duration: 1.4679999999998472,
        id: 190200088,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 2764.664,
        audio_start_offset: 2764.638,
        duration: 0.026000000000294676,
        id: 190200089,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
      },
      {
        audio_end_offset: 2951.27,
        audio_start_offset: 2764.664,
        duration: 183.6140000000005,
        highlight_id: 5249417,
        highlight_words:
          "As I told you before, I started off up in Minneapolis office working out of Nebraska. My main coverage area was Nebraska, South Dakota, and parts of Iowa. Being transferred three, four years ago, whatever it was, to the south central made me kind of wonder, \"Okay, what's going to happen here?\" A lot of my work wasn't really in Nebraska. I mean there was some public sector, and there's some private sector, but not like other areas. And then Iowa did a lot of public sector, and I actually built up a lot of work up in the South Dakota area. So I had a concern, I guess I'd say, about my cases and the reduction of the cases that I had. I had built up a pretty good rapport with the Indian Health Services up in South Dakota and in Nebraska, but mainly up in South Dakota and still get calls from those folks to do some mediation work, whether it be the collective bargaining, the grievances, or even just personal issues that they had going on. So, to me, that was kind of a challenge or a concern maybe more would be the word. Okay, what's going to happen getting moved to the south central region? But since I've been there, again, I've told you before about doing a lot of work all over, I guess, the south central region, which I'm not sure what the whole area is, but I know it's big, being with Texas and Oklahoma, but also doing work out of the St. Louis offices with having just one mediator there now and then also Illinois with one mediator there. So, to me, those were challenges, again, to get to know the respective groups, the Teamsters, the AFCSME group, and all the various types of people that you've never met before were here in Nebraska and Iowa. It was common practice. I'd go visit with those folks whenever you could, just to try to build up a respectful relationship with all of them and have the trust built up. To me, that's been really a concern or a challenge or an opportunity during my career with FMCS was that move from the Minneapolis office to the south central office. Now today, I feel very happy that that happened. I get to know a lot of other people, get to see how they do things differently. All the areas do do some things differently, but all of us do the same thing is try to serve our customers the best we can. Again, that was my challenge and my opportunity was that.",
        id: 190200090,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
        codes: [3, 8, 2, 13, 10, 11, 12, 25, 26, 30, 29],
      },
      {
        audio_end_offset: 2955.45,
        audio_start_offset: 2951.27,
        duration: 4.179999999999836,
        id: 190200094,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3050.12,
        audio_start_offset: 2955.45,
        duration: 93.09000000000015,
        id: 190200095,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
      },
      {
        audio_end_offset: 3070.91,
        audio_start_offset: 3050.12,
        duration: 20.789999999999964,
        id: 190200097,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3150.32,
        audio_start_offset: 3070.91,
        duration: 79.36200000000008,
        highlight_id: 5249422,
        highlight_words:
          "Yeah. Just in general, you notice that you really could not, on a regular basis, schedule pre-pandemic in-person meetings back to back unless you were very strategic about what you were doing and where you were going to be. But once we got into this and once, I guess, the shock of it wore off for everyone and everyone just jumped into the work, it was three meetings a day and they were usually back to back. They didn't leave a lot of time. I guess somewhere maybe around year one, I would think to myself that there's not a lot of time to reflect. But it just really came to me as I was able to have one of those check-the-box authorized to go to an in-person meeting and just the drive there, just everything's blocked out of your mind. You're just thinking about what you're about to do and the drive back, about how you're not focused on getting something done because you don't have that opportunity to get something done. You have an opportunity to reflect on what you've just been a part of.",
        id: 190200098,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [8, 31, 29, 19, 20, 21],
      },
      {
        audio_end_offset: 3193.83,
        audio_start_offset: 3150.32,
        duration: 40.399999999999636,
        id: 190200100,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3195.36,
        audio_start_offset: 3193.83,
        duration: 1.5300000000002,
        id: 190200102,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 3198.01,
        audio_start_offset: 3195.36,
        duration: 2.650000000000091,
        id: 190200103,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3200.77,
        audio_start_offset: 3198.01,
        duration: 2.7599999999997635,
        id: 190200104,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 3201.93,
        audio_start_offset: 3200.77,
        duration: 1.1599999999998545,
        id: 190200105,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3377.25,
        audio_start_offset: 3201.93,
        duration: 173.93600000000015,
        highlight_id: 5249427,
        highlight_words:
          'I got something that happened to me that might be of value. I talked to you about traveling to South Dakota quite a bit. Let\'s say we had a meeting over in Rapid City, South Dakota, which would take a full day of travel, but I would try to break it up and hit Aberdeen. That\'s where the Indian Health Services is our main office in the central region. And then also, in Pierre, South Dakota, is where the Teachers Uniserv directors and the head of the Uniserv office was there right across the street from the state Capitol. So I used to try to hit those places and do, "Hello. Hey, how is things going?" Try to introduce myself a little bit. I knew that the group in Pierre, South Dakota, was going to get a new management top official and the Uniserv directors themselves and the clericals, two or three different unions. So I knew that person was coming. Actually, he came from Alaska, but also came ... I\'d worked with Glenn Tarkowski again out of Wisconsin. So I stopped there and just said, "Hello. [inaudible] FMCS is here. We can put on training," and all the stuff that you normally would talk to them about. After leaving that, of course, the secretary saw me. I said hello. One or two of the Uniserv people saw me and said hello. After that, they had requested some information about RBOs to I think it might have been Glenn or Lane up there. I can\'t remember for sure for who. So they assigned me to that, which I was happy about. But once they saw who it was, the clerical union folks and the Uniserv folks thought, "We were just in with our management for an hour. We don\'t trust you." Wait a minute here. You don\'t even know. Just the perception of me visiting with that new management, those folks, the perception they took from that, to me, was a very learning experience because they have no idea where I come from or what I did before or anything like that. Now they\'re thinking, "Okay, you\'re a management person and that kind of thing." That was just an interesting challenge, I guess, to overcome that. It has. Actually, even working out of south central here last year, I did RBO work with a school district up in South Dakota. [inaudible] whoever my regional director was at the time that\'s why I understood, hey, this is where this is coming from. I explained to him, "Well, this is what I did. I guess this could have been it. I was doing an EAO while I was out and about traveling from the Omaha area to Rapid, City, South Dakota."',
        id: 190200106,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
        codes: [3, 8, 13, 10, 12, 20],
      },
      {
        audio_end_offset: 3385.044,
        audio_start_offset: 3377.25,
        duration: 7.648000000000138,
        id: 190200110,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3389.438,
        audio_start_offset: 3385.044,
        duration: 4.394000000000233,
        id: 190200111,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 3392.148,
        audio_start_offset: 3389.438,
        duration: 2.6479999999996835,
        id: 190200112,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3394.286,
        audio_start_offset: 3392.148,
        duration: 2.1140000000000327,
        id: 190200113,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 3394.872,
        audio_start_offset: 3394.286,
        duration: 0.487999999999829,
        id: 190200114,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3420.78,
        audio_start_offset: 3394.872,
        duration: 25.908000000000357,
        id: 190200115,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 3426.13,
        audio_start_offset: 3420.78,
        duration: 5.349999999999909,
        id: 190200116,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 3428.32,
        audio_start_offset: 3426.13,
        duration: 2.1399999999998727,
        id: 190200117,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3429.544,
        audio_start_offset: 3428.32,
        duration: 0.5619999999998981,
        id: 190200118,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 3503.69,
        audio_start_offset: 3429.544,
        duration: 67.09199999999964,
        id: 190200119,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3591.06,
        audio_start_offset: 3503.69,
        duration: 87.36999999999989,
        highlight_id: 5249431,
        highlight_words:
          "Todd mentioned windshield time. I had never heard that until working with somebody from Ohio and they talked about windshield time, but that time to really kind of process and really, I don't want to say, deflate but just really regroup after a meeting. You don't necessarily have that when you're sitting here at the computer because once I get out of a meeting, I want to start doing some administrative, looking at emails, doing this, doing that. Then I'm going to go to dinner and eat dinner. So then if you've had a pretty, say, maybe difficult case, maybe a case that you might have to think back on what could I have done differently, those things that you might not be able to take advantage as much as you were doing it in person, having that between time before you get home, hour drive or whatever the case may be to really process, reflect, and all of the things that the virtual world might take away. And then you go to bed. Then you're probably kind of angst or hyped still, dealing with some of the things that you have not necessarily taken time to process.",
        id: 190200121,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [8, 5, 11, 31, 30, 29, 22, 19, 20, 21],
      },
      {
        audio_end_offset: 3597.61,
        audio_start_offset: 3591.06,
        duration: 6.550000000000182,
        id: 190200123,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3601.99,
        audio_start_offset: 3597.61,
        duration: 2.9699999999998,
        id: 190200124,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 3603.61,
        audio_start_offset: 3601.99,
        duration: 1.6200000000003456,
        id: 190200125,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3726.46,
        audio_start_offset: 3603.61,
        duration: 121.98599999999988,
        highlight_id: 5249434,
        highlight_words:
          "guess for me, and I've talked a lot about this and I hate to keep repeating myself. But, Todd, when you mentioned you had started, if I got it right, five years maybe, maybe prior to the pandemic or during the period of time or whatever. But the challenge, I guess it would be getting out to meet the people. I don't know if you were from the local area there or not and had people that you had known before coming to FMCS. But, to me, it resonated to when I moved, again, from the north area to the south area and, not only that, but working in the different states where here in Nebraska and Iowa, I knew most every person on the union side at least and knew a lot of people in management, at least the management attorneys. I'll just for a quick short story here. One of the first cases I had on my own when we did have an Omaha office, it was with two different groups. The management attorney came in. I think I was probably only with the agency maybe a year, maybe a little bit more than that. The management attorney happened to be the same attorney that I used to ... We'd be across the table with each other at different types of meetings. So him and I got outside in the hallway and I say, \"Hey, Bob, you have any problems with me being the mediator?\" He said, \"Not at all. I'm glad to see you. I'm glad you got the job. Congratulations and all that good stuff.\" So from then on, we had our meeting. I was able to get to a deal. From then on, I felt pretty comfortable about doing the work. But that was just kind of a challenge. I can just think about someone just starting off in a new area and then having to do it virtually and not being able to get out and shake hands and, \"Hey, let's have a cup of coffee or let's go eat lunch,\" or whatever that you have. I think that's the biggest challenge. I guess hopefully now, it will become the opportunities that we'll be able to have.",
        id: 190200126,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
        codes: [3, 8, 10, 12, 38, 25, 28, 30],
      },
      {
        audio_end_offset: 3731.57,
        audio_start_offset: 3726.46,
        duration: 5.110000000000127,
        id: 190200129,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 3955.75,
        audio_start_offset: 3731.57,
        duration: 220.12400000000025,
        highlight_id: 5249437,
        highlight_words:
          "Yeah. I can relate to everything everyone said. But one in particular, Ron, I wanted to piggyback on is you mentioned that experience. I think if I understood it, you were doing an EAO outreach to a management side. When you talked to some of the union people, they took umbrage with the fact that you'd been just talking to the management folks. It was a good example because one of the things that ... This really relates back to pre-pandemic when I was in the field. We've had some discussions about this recently. I'm in a committee that's talking about or, actually, not talking about, revising our mediator code of ethics and looking at that and making sure that we update that. So these things come up, the perception issue. I found one of the things that's unique and very challenging for mediators, but I think especially FMCS mediators, is that we're assigned these cases. We go out and get involved in these cases. And then everything we do is under a microscope, every word we say, and that's as it should be. That's the job. But there have been experiences that I've been involved in where I believe that I was following everything I knew about my professional understanding of mediation, ethical understanding of mediation, choosing the words carefully, pushing the parties when I believe they need to be pushed, and get fired from a case and realize you can't take it personally. But the challenge for me is that I know that that happens at times. Parties have to find mediators acceptable and whatever. I understand that. I agree with it. However, there are times when the parties will use the fact that we have, for instance, several mediators in an area to manipulate the system, frankly. Okay, I didn't like what this mediator said because the mediator was pushing me where I really needed to be pushed, so I'm going to ask for another mediator, as an example. It's happened to everybody, I'm sure. The challenge comes back to us as an organization to really communicate in every way we can. I know we do. But from the EMs to everybody else in the organization, to make sure that when we're making those choices, when we're making those assignments, when we're making those ... that they're for the right reasons, that they're for the reasons that should be, which is putting the persons who's best matched for that job. That should be the only reason and not about personality or preference or politics or whatever. So I think it's a unique challenge. I think we're up to it, and I think we do a good job with it. I'm not complaining about it. I just think it's really something that people outside of the world we live in would probably not understand that kind of pressure and those just split second decisions that we're making all the time. It happens in the virtual world as well. The experiences I'm thinking about were more when I was still in the rooms with people. But yeah, I just wanted to share that. It resonated with what you had said, Ron.",
        id: 190200130,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [8, 5, 13, 10, 11, 12, 38, 29],
      },
      {
        audio_end_offset: 3960.17,
        audio_start_offset: 3955.75,
        duration: 1.050000000000182,
        id: 190200135,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4052.31,
        audio_start_offset: 3960.17,
        duration: 84.95799999999963,
        highlight_id: 5249439,
        highlight_words:
          "guess just what resonated with me was the, I believe it might have been the last segment or the segment before, Vanessa and Tom had both spoke to it, was the trainings and just the idea that personally I used to try to do a lot of them and probably had a fairly decent amount of trainings pre-pandemic as compared to now during the pandemic, not because I'm not trying as hard as I can previously pre-pandemic to do trainings, but just that I think that with the clients, for them, it's also not resonating as a successful platform to do it virtually as opposed to in person. To be honest, I truly feel like if you're only going to come in every four years when the parties are at their worst and help them navigate their way out of a bad situation and then walk away and, \"See you in four years,\" or whatever, you're really not helping them develop the relationship that they need in order to weather storms and the difficulties that they have. Again, I truly enjoy doing the trainings, but it definitely is a challenge in the virtual world.",
        id: 190200136,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [5, 10, 11, 28, 30, 15],
      },
      {
        audio_end_offset: 4086.03,
        audio_start_offset: 4052.31,
        duration: 33.720000000000255,
        id: 190200138,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4212.01,
        audio_start_offset: 4086.03,
        duration: 120.596,
        highlight_id: 5249441,
        highlight_words:
          "Well, I think it is being said, just in different ways is that I think there is a challenge in this virtual environment to keep and find balance because we have the ability to be in more meetings and, as Todd said, less face time. I think Vanessa talked about this as well and Ron. There's the ability to be in several places as once. I even came across in my experience with working with some of the MEAN Tech team, people who were literally in two meetings at once on two different devices. I would hear about that and I would say, \"I don't know, man. I think that's a lot.\" I wasn't judging. I was just worried, actually, that they were overextending. Not saying they couldn't do it, but do you need to do that? That's a lot. With my own practice and the work I do now, I have found that I have to be vigilant about carving out time for myself so that I don't just work, work, work. Because working at home, you can just get up and work and you can work all evening if you want, work on the weekends. You can, but is it healthy? So I think that's a theme I'm hearing that's running through is that the opportunities that have been presented through this work that's in the hybrid world we're in now. Also, there's a challenge with just making sure that we don't burn ourselves out, burn each other out, that we support one another in having that balance. I call it life balance. So I think that's an important theme I'm hearing.",
        id: 190200139,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [3, 31, 30, 29, 19, 21],
      },
      {
        audio_end_offset: 4224.41,
        audio_start_offset: 4212.01,
        duration: 12.399999999999636,
        id: 190200142,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4272.94,
        audio_start_offset: 4224.41,
        duration: 48.529999999999745,
        id: 190200143,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
      },
      {
        audio_end_offset: 4325.31124024961,
        audio_start_offset: 4272.94,
        duration: 52.33324024961075,
        id: 190200144,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4406.09,
        audio_start_offset: 4325.31124024961,
        duration: 79.12875975038969,
        highlight_id: 5249446,
        highlight_words:
          "I mean I'll go back to what I think somebody had said in the first segment about being able to collaborate across regions and districts and learn from people outside of your own district or outside of people that you regularly are in touch with, being able to ... No, I completely agree that there's definitely some work that clearly identifiable as should remain virtual, the reimbursable cases, those. To be honest with you, just as, I guess, fiscally responsible government employees, we should be finding a way to save the taxpayers money and still get the job done. But I certainly think that there's some cases and some services should remain in person, are best to be dealt with in person. To be honest, I think that that should really be left up to the mediator's own individual preference and their professional opinion.",
        id: 190200146,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [5, 10, 11, 34, 33, 35, 25, 26, 15],
      },
      {
        audio_end_offset: 4418.07,
        audio_start_offset: 4406.09,
        duration: 11.979999999999563,
        id: 190200148,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4696.87,
        audio_start_offset: 4418.07,
        duration: 274.14400000000114,
        highlight_id: 5250891,
        highlight_words:
          "I think that the mediators are hired and all the staff in FMCS are hired because they're professionals and they know their work. They should be the ones to judge or to make that decision about whether work is in person or virtual. I agree. And then there's going to be some exceptions in terms of just, like you said, some ways to save money and resources that have to be considered because, frankly, the virtual work works. I mean I'm not saying it always works. I do agree there are times when being in person is going to be useful, but it obviously works in a lot of situations.",
        id: 190200149,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [6, 34, 44],
      },
      {
        audio_end_offset: 4700.05,
        audio_start_offset: 4696.87,
        duration: 2.1400000000003274,
        id: 190200156,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4795.37,
        audio_start_offset: 4700.05,
        duration: 93.60999999999967,
        highlight_id: 5249460,
        highlight_words:
          "think that my hope for the agency is that they maintain a level of flexibility that they've been able to address to meet the needs of their clients, not to stay stagnant in terms of what we ... Because stagnant, you don't grow. So I hope that they continue to maintain that level of flexibility. Our core work has always been considered CBM and I think that should still remain our core work in terms of who we are, what we do. But we shouldn't necessarily rest in that area, although it should still be our core work, but to expand in other areas where ... I'm part of the CMP program, and it's a lot of conflict management, resolution, and intervention type programs that I think would be a benefit for a lot of folks in the agency to put a lot of different tools in the tool belt. So hopefully, we'll continue to broaden our skills, but to also maintain who we are as an agency, some of the best resolutionists in terms of labor contract negotiations that there are. That's who we are, but that doesn't necessarily define what we can be.",
        id: 190200157,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [6, 13, 10, 12, 38, 15, 16],
      },
      {
        audio_end_offset: 4797.89,
        audio_start_offset: 4795.37,
        duration: 2.0200000000004366,
        id: 190200159,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4799.566,
        audio_start_offset: 4797.89,
        duration: 1.5319999999992433,
        id: 190200160,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 4810.35,
        audio_start_offset: 4799.566,
        duration: 10.78400000000056,
        id: 190200161,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4813.44,
        audio_start_offset: 4810.35,
        duration: 3.089999999999236,
        id: 190200162,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 4814.67,
        audio_start_offset: 4813.44,
        duration: 1.230000000000473,
        id: 190200163,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4820.47,
        audio_start_offset: 4814.67,
        duration: 2.1899999999996,
        id: 190200164,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 4821.73,
        audio_start_offset: 4820.47,
        duration: 1.2599999999993088,
        id: 190200165,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4827.52,
        audio_start_offset: 4821.73,
        duration: 5.790000000000873,
        id: 190200166,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 4836.95,
        audio_start_offset: 4827.52,
        duration: 8.61999999999989,
        id: 190200167,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4965.25,
        audio_start_offset: 4836.95,
        duration: 123.80400000000009,
        highlight_id: 5249484,
        highlight_words:
          "totally agree with what Vanessa said there. I'm in hopes that FMCS does maintain its core work, which I believe is CBMs. That's kind of where I've always been told from before. If you have a CBM, that takes preference over any other things and especially if they look like they're going to come to some sort of a work stoppage or whatever. So I hope that does maintain. I also agree with Todd about it ought to be left up to the mediators because they're the ones that have been talking to the parties. They're the ones that know what is actually really going on and should have a good feel whether they should be there in person or be there virtually. For me, a concern I was having, traveling as much as I was doing, is the night driving. Well, now I'm not night driving, so I don't have that concern so much for me, especially at 70 years old. Your eyes don't get any better than when they were when you were 30 or 40 or 50. I'll just say that. So that's been one of my concerns. I do believe, and I'm happy to see the agency look at what I believe is looking for ways to maintain FMCS and looking for avenues to assist the parties, maybe not in collective bargaining, but whatever conflict resolution processes that they may feel like needed. I do. I might be wrong. Vanessa, you or whoever might remember. It seemed like years ago they used to have a five-year plan, 10-year plan, a booklet that came out or something that would ... It would be nice to see such a thing. You know what I mean? It'd be nice to see, okay, you know what your thinking is. What are the leadership or whoever who used to put these books, what are they seeing? Maybe even let the mediators have some input into some of that stuff, which would be good. It's just my thought about it.",
        id: 190200168,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
        codes: [6, 13, 10, 11, 12, 38, 35, 15, 19, 20],
      },
      {
        audio_end_offset: 4979.53,
        audio_start_offset: 4965.25,
        duration: 13.649999999999636,
        id: 190200172,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4983.83,
        audio_start_offset: 4979.53,
        duration: 1.230000000000473,
        id: 190200173,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 4988.99,
        audio_start_offset: 4983.83,
        duration: 3.5100000000002183,
        id: 190200174,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 4994.258331654917,
        audio_start_offset: 4988.99,
        duration: 5.268331654917347,
        id: 190200175,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 4996.11,
        audio_start_offset: 4994.258331654917,
        duration: 1.851668345082544,
        id: 190200176,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5041.55,
        audio_start_offset: 4996.11,
        duration: 39.850000000000364,
        highlight_id: 5249485,
        highlight_words:
          "We always talk about communication, and maybe the town hall meetings is helping with a lot of that because, for me, I've always worked on a single-person station. The closest office for me right now is either Cedar Rapids, Iowa, six hours or Kansas City, four hours or wherever. Just like you're saying that you think something's in the works for that, we don't hear that. I don't hear that hardly at all. What's going on? Unless I go to the town hall meetings, and those things have helped out what I felt was maybe some lack of communications that I felt was happening before.",
        id: 190200177,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
        codes: [3, 6, 37, 38, 34, 35, 24],
      },
      {
        audio_end_offset: 5153.37,
        audio_start_offset: 5041.55,
        duration: 111.30799999999999,
        id: 190200178,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5166.07,
        audio_start_offset: 5153.37,
        duration: 9.88000000000011,
        id: 190200181,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5170.27,
        audio_start_offset: 5166.07,
        duration: 2.9099999999998545,
        id: 190200182,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5180.87,
        audio_start_offset: 5170.27,
        duration: 2.259999999999309,
        id: 190200183,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 5184.89,
        audio_start_offset: 5180.87,
        duration: 4.020000000000437,
        id: 190200184,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5186.99,
        audio_start_offset: 5184.89,
        duration: 1.769999999999527,
        id: 190200185,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 5188.784,
        audio_start_offset: 5186.99,
        duration: 1.6480000000001382,
        id: 190200186,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 5252.72,
        audio_start_offset: 5188.784,
        duration: 63.934000000001106,
        highlight_id: 5249488,
        highlight_words:
          "Okay. Well, first of all, Jimmy, great facilitation. I mean I love your style and just I felt like we had all the time in the world. You explained things really well. I found this experience to be every bit as rewarding as I thought it was going to be, and I was pretty excited about it before. I guess the thing that I most appreciate about it, well, two things, one, that the agency is trying something new and letting us be guinea pigs for it. But then also, my colleagues on here, I really appreciate what I've learned from each of you and about each of you. I feel like I know each of you a little bit better than I did. That's the world to me. I want to keep connecting with all of the FMCS colleagues that I can. So this was an opportunity to do that. I felt very just grateful to be a part of it. Thank you.",
        id: 190200187,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [7, 41, 35, 43, 45, 46, 44, 25],
      },
      {
        audio_end_offset: 5256.27,
        audio_start_offset: 5252.72,
        duration: 3.550000000000182,
        id: 190200189,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5295.17,
        audio_start_offset: 5256.27,
        duration: 37.79999999999927,
        highlight_id: 5249489,
        highlight_words:
          "think this group has given me the energy. You asked whether we're emotionally in it. So I guess I said, \"well, depending on how it goes. I'm not necessarily feeling that emotional right now.\" But now I feel like I tapped into that emotion because when you're really with a good group of guys, folks, guys, that's generic, it really kind of feeds you. It feeds your energy and it stimulates your thoughts. So I thought that this was a good group to work with. Also, your facilitation skills, Jimmy.",
        id: 190200190,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
        codes: [7, 41, 37, 35, 43, 45, 44, 25],
      },
      {
        audio_end_offset: 5313.25,
        audio_start_offset: 5295.17,
        duration: 18.079999999999927,
        id: 190200191,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5366.99,
        audio_start_offset: 5313.25,
        duration: 51.68000000000029,
        highlight_id: 5249491,
        highlight_words:
          "I was just going to say I didn't quite know exactly what this was, getting into it. I don't know if I missed something that everybody else ... Or if everybody, \"What is this, really?\" I guess looking at it a little more, I'd be interested to see if what we all identified as the challenges is what rises to the top when the artificial intelligence gets a chance to parse through this audiotape and then really what comes of it. I'm assuming this is referred to as a pilot because this is just the start with us, but then to expand it out to the rest of the agency so that we get a full view of how everyone feels.",
        id: 190200192,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [6, 7, 45, 46],
      },
      {
        audio_end_offset: 5379.495855031668,
        audio_start_offset: 5366.99,
        duration: 12.505855031668034,
        id: 190200193,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5413.57,
        audio_start_offset: 5379.495855031668,
        duration: 34.07414496833189,
        highlight_id: 5249492,
        highlight_words:
          "Got it. Listen, like I said, it's a good thing. It's just interesting to think that that's really one of the skills that we're supposed to have is to be able to sit there and listen to a group of people and then pull out what are the important parts. That, I guess, is a little nerve-wracking thinking that now they've got robots doing our job, too. Listen, I hope this goes well, but as far as Cortico's concerned, I don't know. I don't know. I don't know how I feel about that.",
        id: 190200194,
        speaker_id: 4,
        speaker_name: 'Speaker TB',
        codes: [6, 7, 46, 44, 17, 15],
      },
      {
        audio_end_offset: 5421.858,
        audio_start_offset: 5413.57,
        duration: 8.288000000000466,
        id: 190200195,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5425.87,
        audio_start_offset: 5421.858,
        duration: 2.912000000000262,
        id: 190200196,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5427.306,
        audio_start_offset: 5425.87,
        duration: 1.3519999999998618,
        id: 190200197,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5427.976,
        audio_start_offset: 5427.306,
        duration: 0.6700000000000728,
        id: 190200198,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5431.888,
        audio_start_offset: 5427.976,
        duration: 3.850000000000364,
        id: 190200199,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5436.01,
        audio_start_offset: 5431.888,
        duration: 1.0320000000001528,
        id: 190200200,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5567.71,
        audio_start_offset: 5436.01,
        duration: 130.21399999999994,
        id: 190200201,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5569.66,
        audio_start_offset: 5567.71,
        duration: 1.949999999999818,
        id: 190200204,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 5570.23,
        audio_start_offset: 5569.66,
        duration: 0.569999999999709,
        id: 190200205,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5575.57,
        audio_start_offset: 5570.23,
        duration: 4,
        id: 190200206,
        speaker_id: 3,
        speaker_name: 'Speaker VA',
      },
      {
        audio_end_offset: 5604.47,
        audio_start_offset: 5575.57,
        duration: 28.900000000000546,
        id: 190200207,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5605.45,
        audio_start_offset: 5604.47,
        duration: 0.9799999999995634,
        id: 190200208,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 5610.55,
        audio_start_offset: 5605.45,
        duration: 4.4099999999998545,
        id: 190200209,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5714.59,
        audio_start_offset: 5610.55,
        duration: 101.77999999999975,
        highlight_id: 5249494,
        highlight_words:
          "Todd, it's a great point. It isn't one I'd made yet is that, yeah, all this AI out there. There are people that are saying, \"AI? What a mediator does, an AI could do.\" I don't believe that. But I think that one of the things I'm excited about is that tools like this might give us an opportunity to mediate in more places and different places than we ever did because of the ... Hawk mentioned he's asked me to help him look at the backend of this thing. The little bit we've seen of it is pretty cool. What ends up happening with all this information is something that I think is going to be fascinating. It could be really useful for us as conflict management practitioners, Vanessa, to go out and maybe do work in different venues and areas where we haven't done it before. I mentioned in the chat that I'm going to paraphrase something that Javier said, he wants all the work. The point is I think the vision that he has, my understanding of the agency is that we really become the go-to conflict resolution solution for people in the country. They're paying for it. We're taxpayer-funded. So he wants us to be that entity. That's pretty broad. I'm not taking away from collective bargaining mediation. That is and will be the biggest probably piece of our work. But we're finding that there's other work as well that we might be able to get involved in that's pretty exciting.",
        id: 190200210,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
        codes: [7, 10, 11, 38, 15, 16],
      },
      {
        audio_end_offset: 5790.912,
        audio_start_offset: 5714.59,
        duration: 75.83399999999983,
        id: 190200213,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5791.45,
        audio_start_offset: 5790.912,
        duration: 0.5379999999995562,
        id: 190200215,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5793.84,
        audio_start_offset: 5791.45,
        duration: 2.3900000000003274,
        id: 190200216,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5794.47,
        audio_start_offset: 5793.84,
        duration: 0.6300000000001091,
        id: 190200217,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5808.03,
        audio_start_offset: 5794.47,
        duration: 12.989999999999782,
        id: 190200218,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5812.596,
        audio_start_offset: 5808.03,
        duration: 4.492000000000189,
        id: 190200219,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5812.944,
        audio_start_offset: 5812.596,
        duration: 0.34800000000086584,
        id: 190200220,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5818.39,
        audio_start_offset: 5812.944,
        duration: 2.4459999999999127,
        id: 190200221,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5818.851077019412,
        audio_start_offset: 5818.39,
        duration: 0.46107701941127743,
        id: 190200222,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5822.21,
        audio_start_offset: 5818.851077019412,
        duration: 1.498922980588759,
        id: 190200223,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5843.808,
        audio_start_offset: 5822.21,
        duration: 21.416000000000167,
        id: 190200224,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5850.684,
        audio_start_offset: 5843.808,
        duration: 6.694000000000415,
        id: 190200225,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5857.93,
        audio_start_offset: 5850.684,
        duration: 7.246000000000095,
        id: 190200226,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5858.1,
        audio_start_offset: 5857.93,
        duration: 0.17000000000007276,
        id: 190200227,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5859.576,
        audio_start_offset: 5858.1,
        duration: 1.2819999999992433,
        id: 190200228,
        speaker_id: 5,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5859.9600464700625,
        audio_start_offset: 5859.576,
        duration: 0.38404647006245796,
        id: 190200229,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5869.75,
        audio_start_offset: 5859.9600464700625,
        duration: 9.78995352993752,
        id: 190200230,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 5870.759221260816,
        audio_start_offset: 5869.75,
        duration: 1.009221260816048,
        id: 190200231,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5871.904,
        audio_start_offset: 5870.759221260816,
        duration: 0.9987787391837628,
        id: 190200232,
        speaker_id: 0,
        speaker_name: 'Speaker JA',
      },
      {
        audio_end_offset: 5873.92,
        audio_start_offset: 5871.904,
        duration: 1.845999999999549,
        id: 190200233,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
      {
        audio_end_offset: 5876.658,
        audio_start_offset: 5873.92,
        duration: 2.5460000000002765,
        id: 190200234,
        speaker_id: 1,
        speaker_name: 'Speaker TC',
      },
      {
        audio_end_offset: 5876.9,
        audio_start_offset: 5876.658,
        duration: 0.24199999999927968,
        id: 190200235,
        speaker_id: 2,
        speaker_name: 'Speaker RA',
      },
    ],
  },
  {
    duration: 4972.43425,
    speaker_count: 7,
    id: 1908,
    snippets: [
      {
        audio_end_offset: 274.436,
        audio_start_offset: 1.57,
        duration: 268.672,
        id: 190800000,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 275.81,
        audio_start_offset: 274.436,
        duration: 0.924000000000035,
        id: 190800007,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
      },
      {
        audio_end_offset: 278.252,
        audio_start_offset: 275.81,
        duration: 2.283999999999992,
        id: 190800008,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 279.59,
        audio_start_offset: 278.252,
        duration: 0.9479999999999791,
        id: 190800009,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
      },
      {
        audio_end_offset: 281.612,
        audio_start_offset: 279.59,
        duration: 1.8640000000000327,
        id: 190800010,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 283.07,
        audio_start_offset: 281.612,
        duration: 0.8879999999999768,
        id: 190800011,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 285.59,
        audio_start_offset: 283.07,
        duration: 1.9499999999999886,
        id: 190800012,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 286.91,
        audio_start_offset: 285.59,
        duration: 0.9300000000000068,
        id: 190800013,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
      },
      {
        audio_end_offset: 288.92,
        audio_start_offset: 286.91,
        duration: 1.839999999999975,
        id: 190800014,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 290.45,
        audio_start_offset: 288.92,
        duration: 0.8999999999999773,
        id: 190800015,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
      },
      {
        audio_end_offset: 294.47,
        audio_start_offset: 290.45,
        duration: 3.090000000000032,
        id: 190800016,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 296.33,
        audio_start_offset: 294.47,
        duration: 1.8599999999999568,
        id: 190800017,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
      },
      {
        audio_end_offset: 491.408,
        audio_start_offset: 296.33,
        duration: 193.93600000000004,
        id: 190800018,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 498.332,
        audio_start_offset: 491.408,
        duration: 6.765999999999963,
        id: 190800023,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 666.27,
        audio_start_offset: 498.332,
        duration: 167.16000000000008,
        id: 190800024,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 697.33,
        audio_start_offset: 666.27,
        duration: 28.470000000000027,
        id: 190800027,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
      },
      {
        audio_end_offset: 703.07,
        audio_start_offset: 697.33,
        duration: 2.67999999999995,
        id: 190800028,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 739.37,
        audio_start_offset: 703.07,
        duration: 35.969999999999914,
        id: 190800029,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
      },
      {
        audio_end_offset: 743.87,
        audio_start_offset: 739.37,
        duration: 2.7999999999999545,
        id: 190800030,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 780.35,
        audio_start_offset: 743.87,
        duration: 35.32000000000005,
        id: 190800031,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
      },
      {
        audio_end_offset: 786.57,
        audio_start_offset: 780.35,
        duration: 3.689999999999941,
        id: 190800032,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 818.55,
        audio_start_offset: 786.57,
        duration: 30.629999999999995,
        id: 190800033,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
      },
      {
        audio_end_offset: 821.05,
        audio_start_offset: 818.55,
        duration: 2.5,
        id: 190800034,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 905.09,
        audio_start_offset: 821.05,
        duration: 83.71600000000001,
        id: 190800035,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 1043.87,
        audio_start_offset: 905.09,
        duration: 114.39999999999998,
        id: 190800037,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1049.1,
        audio_start_offset: 1043.87,
        duration: 5.120000000000118,
        id: 190800039,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
      },
      {
        audio_end_offset: 1050.57,
        audio_start_offset: 1049.1,
        duration: 1.1400000000001,
        id: 190800040,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1141.75,
        audio_start_offset: 1050.57,
        duration: 88.74800000000027,
        highlight_id: 5248946,
        highlight_words:
          "So I will say that mine is both an opportunity and a challenge. Walking in the door, this was the first time this position has been formalized. The prior person before me had done an outstanding job with it, still don't know how she had the time to do it. So walked into the door with, I believe that I was set up the best that I could be, but I think that there were challenges because just trying to get the office set up into a really functioning office. So getting the standard forms and procedures and things like that. So that felt like an uphill battle, trying to establish those things.",
        id: 190800041,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
        codes: [3, 2, 41, 34, 33, 35],
      },
      {
        audio_end_offset: 1148.51,
        audio_start_offset: 1141.75,
        duration: 1.0499999999999545,
        id: 190800043,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1151.21,
        audio_start_offset: 1148.51,
        duration: 1.8900000000001,
        id: 190800044,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 1152.848,
        audio_start_offset: 1151.21,
        duration: 1.5160000000000764,
        id: 190800045,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1313.41,
        audio_start_offset: 1152.848,
        duration: 158.35800000000017,
        highlight_id: 5248948,
        highlight_words:
          "So for me, the last two years, I think my biggest challenges have been with virtual work and attorneys that are not from my area. So I had a couple of clients over the past two years that used attorneys that aren't from the area. I'm in Minnesota and they're attorneys from Jersey. And I will just be really frank and say that this was probably the hardest time of my career, as far as being challenged, being challenged by attorneys, being challenged by international reps that I've never met before. And I personally think part of it is, yep, it's easy to do that stuff over virtual, but also the dynamics are changing. And if you look at what's happened in the last two and a half, three years, you can't help but to notice the differences of the people that are on your screen, you can't help, but to notice the differences in all of your clients. And that was really difficult for me because a lot of the times, which any other time, I don't care. I am used to being the only person of color in a room or in a meeting or one of a handful. And so it's not a big deal to me. It doesn't make me uncomfortable, but sometimes it makes other people uncomfortable. And then when I'm challenging them, then it made them really uncomfortable. So I had to try and work through that dynamic.",
        id: 190800046,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [3, 8, 13, 10, 11, 24, 28],
      },
      {
        audio_end_offset: 1318.63,
        audio_start_offset: 1313.41,
        duration: 3.2799999999999727,
        id: 190800049,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1549.49,
        audio_start_offset: 1318.63,
        duration: 228.08400000000006,
        highlight_id: 5248950,
        highlight_words:
          "So just say how things have progressed, but I can say, when COVID first start a couple years ago, if you had told me that I'd be more busy than I was before I would've said, nah, it's not going to happen. No one's going to really want to do this. We'll be lucky to get involved. And that has not been the case that probably been just as busy or busier than I was pre-COVID. So that was an eyeopener. The other thing I can say learned early on that Zoom fatigue is a real thing. Even before they mention it on the news, because you'd be in mediations of any kind. And you could just tell people, just get exhausted after a certain amount of time and you learn over time, you can't have all day bargaining sessions with Zoom, especially if there's 20 people in the room because they just check out. So we learned as mediator with parties, like we're through five or six hours and that's it. And we'll just move along. So mediating is mediating and I love what I do. So whether it's virtual in-person, whatever, I've only had two cases in-person in the last two years.",
        id: 190800050,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
        codes: [8, 10, 11, 12, 31, 30, 15],
      },
      {
        audio_end_offset: 1555.47,
        audio_start_offset: 1549.49,
        duration: 5.2999999999999545,
        id: 190800055,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1726.45,
        audio_start_offset: 1555.47,
        duration: 168.03599999999983,
        highlight_id: 5248952,
        highlight_words:
          "So I certainly believe that there's an opportunity that lies within any challenge. So for a new mediator like myself, I joined in 2018 and had a little bit over a year and a half for the lockdown occurred of doing in-person mediation. And of course, it was like a light switch. Switching from in-person to virtual. So for a new mediator at the time, which I guess I'm still am, but for somebody who had less than a year and a half onto their belt, my biggest challenge was trying to build rapport with the parties, Doing it in-person is significantly different than trying to do it virtually. So I had to try to look for ways that I could connect to the parties by using a virtual platform. And it's not easy. Typically, if you have a decent size party, you're mainly shifting people in and out of rooms. People are coming and going frequently. There's a lot of people on the screen at one time, it doesn't really offer a lot of opportunity for the mediator to really try to get to know either the lead spokesperson or the one who's making the decisions, which is really where I try to hone in on as a mediator.",
        id: 190800056,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
        codes: [3, 10, 11, 12, 30, 15, 16],
      },
      {
        audio_end_offset: 1729.63,
        audio_start_offset: 1726.45,
        duration: 0.9900000000000091,
        id: 190800059,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 1939.07,
        audio_start_offset: 1729.63,
        duration: 206.02999999999997,
        highlight_id: 5248954,
        highlight_words:
          "think I have a bit of a unique perspective on the last two years, seeing as how my first day was March 2nd. So I had a week of onboarding in Glendale and then I was in San Diego with Joe Manillo for one week. And that was actually cut short. I was sent home and then I didn't leave my house again until November of 21 for a strike case, which I was so, so excited for because it's the first time I actually got to mediate in-person and it was a big deal and it was awesome. It went great. But it was the beginning was really challenging for me. I'm used to staying busy all the time, working all the time and then going from that to onboarding. And then all of a sudden the entire agency is in this entirely new realm of completely virtual and all the people I'm supposed to be shadowing are trying to transition their workload to virtual. And there wasn't a lot of shadowing opportunities. There wasn't a lot of... I had new mediator training going on and that was pretty much it.",
        id: 190800060,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
        codes: [3, 8, 35, 29],
      },
      {
        audio_end_offset: 2177.67,
        audio_start_offset: 1939.07,
        duration: 238.26199999999994,
        highlight_id: 5248958,
        highlight_words:
          "would definitely second a lot of what have been said, the opportunities to connect with colleagues from different areas and work on different types of projects that maybe wouldn't arise in Chicago. We're unique within the agency where we do a lot more public sector work than we do say private sector or federal sector, but the ability to partner with folks all over the country started to bring those other flavors into the mix. Had a really great training that I did for some firefighters. And while it was great to connect with them virtually, I was able to pull in a colleague from California who would never, I mean, it was maybe three or four-hour RDT. There's no way the agency would've flown someone from California for a three-hour RDT, but I was able to get a former fire official who within my new mediator class who had been both union and management. And there was some real tension between union and management because of someone who had gone from the union into leadership. And he was a person who had experienced that transition. And so bringing him in for that training and just really being boots on the ground and lived their lives, I think it brought a new dimension to the training that I don't think would've been available to me under the past circumstances.",
        id: 190800064,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
        codes: [8, 2, 13, 10, 33, 35, 25, 26, 27],
      },
      {
        audio_end_offset: 2195.67,
        audio_start_offset: 2177.67,
        duration: 17.549999999999727,
        id: 190800069,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
      },
      {
        audio_end_offset: 2222.74,
        audio_start_offset: 2195.67,
        duration: 27.06999999999971,
        id: 190800070,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 2358.55,
        audio_start_offset: 2222.74,
        duration: 132.29000000000042,
        highlight_id: 5250386,
        highlight_words:
          "I'll start. I'll go one with Kevin and one with Matt. So for Kevin's, his comment and Brenda, you had just mentioned it as well, was the virtual fatigue. I've never experienced anything like that before until obviously two years ago. And it came on quick. I think within four to five months, I felt a significant drop in my energy level, especially if the negotiation was retracted and was going on for multiple hours, multiple days in a row. I really had to recenter myself and bring myself to say, hey, look refocus, because I never experienced it before. And I think it's real as well.",
        id: 190800071,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
        codes: [5, 31, 19],
      },
      {
        audio_end_offset: 2361.79,
        audio_start_offset: 2358.55,
        duration: 0.9899999999997817,
        id: 190800073,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 2364.97,
        audio_start_offset: 2361.79,
        duration: 1.8899999999998727,
        id: 190800074,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
      },
      {
        audio_end_offset: 2365.514,
        audio_start_offset: 2364.97,
        duration: 0.5440000000003238,
        id: 190800075,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 2366.67,
        audio_start_offset: 2365.514,
        duration: 1.0360000000000582,
        id: 190800076,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 2369.93,
        audio_start_offset: 2366.67,
        duration: 0.6700000000000728,
        id: 190800077,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 2473.53,
        audio_start_offset: 2369.93,
        duration: 100.65000000000009,
        highlight_id: 5249020,
        highlight_words:
          "The biggest one that jumped out to me was the [inaudible] and that being set up because, so my COVID experience was, before they started testing for COVID. I'm sure I was one of those first people with COVID. Super Bowl Sunday, I was sicker in dog. I was sick all of February. I was sick for the first week of March. I was sick for half of the second week. I tried to go to work and they were like, \"Yeah, pack your stuff, go home. We're closing the office.\" And the whole time, I really didn't know anything about COVID. I was just laying in my bed, literally sick, going back and forth to the doctor. So I had been watching the news, I didn't know about this thing that they're talking about and all this stuff. And so when I got to the office and they're like, yeah, I was shutting the office, take anything you need, make sure you take it home today. And I'm like, \"What are you talking about?\" So I literally had no idea why the office was shutting and I grabbed what I thought I needed, but you don't know because I wasn't planning on being home. I didn't know I was going to be home. So that trying to be set up and we all had that experience. Can I get another monitor? What about headphones? All that kind of stuff, to get prepared to start to do the virtual work. So that being prepared, that was a big deal for me. So that's when she said making sure it's already and set up, I was like, that was so not me. So I felt that.",
        id: 190800078,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [3, 5, 30, 29],
      },
      {
        audio_end_offset: 2480.77,
        audio_start_offset: 2473.53,
        duration: 6.199999999999818,
        id: 190800080,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 2628.95,
        audio_start_offset: 2480.77,
        duration: 147.28399999999965,
        highlight_id: 5250390,
        highlight_words:
          "A couple things when Matt was saying that he was just hired, had to do his new mediator training online. And every time I hear something like that, I'm like, \"Oh man, he has no idea.\" Lou and I were in the same class. We had a last a year in 2019. And some of my best friends in the agency, they were all from that class. We still stay in touch. We lean on each other, we call each other, et cetera. So I know that you don't know what you don't have because you haven't had it. But that's not easy because that really helped in the first year really just to say, okay, this is what I'm going through. And you're in the same boat that I'm at. And how are you dealing with this, this and this? And just having those opportunities in-person, not only in the training, which is one thing, but going to dinner, having drinks, whatever that was a big help over that year. So missing out on that, I can't imagine just going, hey, I'm here and let's just do RingCentral. That's great. And I'll read from the script and do that because it's just not the same.",
        id: 190800081,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
        codes: [5, 41, 37, 34, 33, 35],
      },
      {
        audio_end_offset: 2726.19,
        audio_start_offset: 2628.95,
        duration: 93.30400000000054,
        highlight_id: 5250435,
        highlight_words:
          "but with LaTonya that really resonates with me. It just makes me continue to think about what I need to think about. Pretty much in any professional setting, there's additional level of consideration of the audience, how I'm being perceived. And that may be for everybody. It may be, I don't know, but because I'm a minority and I'm a female, those are different things that I really have to think about it and think through, as far as my presentation, just doing a check of myself. So the work is there, but it's this, how do I set the stage for myself? And you're always looking for not necessarily that just because I walk in a room, you need to respect me, but you're thinking about am I going to be respected? Are the powers respecting me? Is it about who I am or is it about what I'm saying? Is it about the substance or myself? And so for me, you're dealing with these things that you're thinking about and trying to still put forth the best effort that you can, but you may be running into some barriers that people are who they are and their belief system is what it is. And so that's just additional. So that did resonate with me really deeply because that's something that many women are challenged with. I won't say y'all because I can't speak for everyone, but that's just something that resonated with me. So I appreciate you for sharing that.",
        id: 190800085,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
        codes: [5, 12, 37, 40, 34, 35],
      },
      {
        audio_end_offset: 2849.86,
        audio_start_offset: 2726.19,
        duration: 123.48999999999978,
        highlight_id: 5250441,
        highlight_words:
          "Same a lot of what everyone said resonated with me, but particularly, especially with expanding on what LaTonya was talking about. I had an experience, this is all recorded. So I'm little hesitant to be very real specific. A lot of these things I'm a white male. I don't experience a lot of prejudice, but I experienced it in the sense that I was on a public policy negotiation and Josh and Moira were leading it up and myself and Moira, we had to do a lot of separate interviews with different parties and myself in Moira, we were teaming up. There's a lot of different tribes who were really male dominant and I'm following Moira's lead. She's showing me the ropes. She's a boss, she's got this under control. And I realized that all of a sudden, all of the questions are being directed to me, even though Moira's leading the discussion. And after a couple minutes in this meeting, I realized like, wow, they don't even know how nervous I am. I'm following Moira's lead. She's guiding me through the ropes here and they're disregarding what she's saying. And it's something that she would say that was really an inflective thought or question on what they were saying. And then it's referred back to me, is like that wasn't my thought, directed to Moira. And so it was one of those points where I really saw, and I think it's cultural where they were referring to the man or deferring to the male rather than the female. And I saw that and I was like, \"Oh man, that probably happens way more often than I understand.\" But it was one that was really apparent to me in that moment. So it's just you see it when you see it and sometimes it's hard to miss, but yeah, that's just a personal experience that I can't really relate, but I've seen it.",
        id: 190800087,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
        codes: [8, 5, 13, 10, 38, 40, 26],
      },
      {
        audio_end_offset: 3164.87,
        audio_start_offset: 2849.86,
        duration: 214.94000000000005,
        highlight_id: 5249026,
        highlight_words:
          "And in a similar vein, I will say that sadly, I've also experienced that. Just again, connecting with what LaTonya said, it's so interesting because the demographics of the Chicago office leaned very hard in one particular direction. And so, it was really interesting when I was brought on, people would say don't really tell people you're a new mediator, because you don't want them to have like a difference or try to pull something or whatever. And when they said that because I was actually hired on the same day, at the same time with another mediator, a white male who we have become really great friends, but it was funny because our office is full of white males. And I said, you don't think that people will notice anything different, like when I walk in than usually what they're used to seeing and just think that the new thing, isn't going to be obvious. That's so interesting to me.",
        id: 190800089,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
        codes: [5, 13, 10, 12, 24],
      },
      {
        audio_end_offset: 3167.216,
        audio_start_offset: 3164.87,
        duration: 2.1520000000000437,
        id: 190800093,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
      },
      {
        audio_end_offset: 3172.79,
        audio_start_offset: 3167.216,
        duration: 5.124000000000251,
        id: 190800094,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 3373.19,
        audio_start_offset: 3172.79,
        duration: 196.35999999999967,
        highlight_id: 5250467,
        highlight_words:
          "looking at the direction we're going, the virtual component aside for now looking at the three pillars of our work sound and stable, industrial relations, regulatory negotiations and then reimbursable or administrative dispute resolution in the federal sector. I think that regulatory negotiations and large public policy multi-party negotiations, it seems as though we're looking at more and more of that in this agency. So I think trying to get experience in that and gaining experience and getting better at it, I guess, is something that I think is important for all of us, because it looks like, there's going to be more of that as we go. Especially right now, there's been a large influx of reg negs and multi-party policy negotiation. And with that, you tie in the virtual aspect. One of the things that we just did from June of last year that wrapped up in February was the Washington Resource Management Plan. There was 17 sovereign tribes, several state agencies, several federal agencies. And we did the entire negotiations virtually, which had tons of challenges, but we were able to do something that really hadn't been done as far as convening 180 folks in a plenary session and I think that it's paved the way for how we might do it in the future and not necessarily all virtual, but at least knowing that we have that hybrid capacity that it's really more conducive to people, scheduling and being able to get a lot of these subcommittee meetings or private caucus meetings done virtually. And I think that's going to play a big role in the future. And I think virtual is here to stay for a good portion of our work. And then I look to the future of right now it seems as though there's a resurgence, I think it's somewhat overblown, but maybe it of this labor movement of different Amazon organizing the Starbucks drive, things like that, where we're going to be there for now that we're doing card checks and I think we're going to have a lot of initial contract work and just being prepared for that wave, if it spreads into different minds of work and different organizations, I think we'll be looking at some really combative initial contracts. So being prepared for that and balance that we're balancing all three main pillars of FMCS. I think they're, hopefully it all grows and the agency can start going in the other direction. And instead of shrinking row a little bit too.",
        id: 190800095,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
        codes: [6, 13, 10, 11, 26, 30, 29, 15, 16],
      },
      {
        audio_end_offset: 3380.27,
        audio_start_offset: 3373.19,
        duration: 5.199999999999818,
        id: 190800098,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 3509.73,
        audio_start_offset: 3380.27,
        duration: 123.36400000000049,
        highlight_id: 5250468,
        highlight_words:
          "but my hope is in the future, more people on the outside actually understand what FMCS is and how mediation can be used and how it's helpful. And Kevin Hawkins, and I ran into that with some of the baseball stuff, which was you had the players say, well, we don't need a mediator in there and we can negotiate our own and all this. I work at a DC. So I'm in a bubble, there's a process, we're involved in a lot of things. You don't have to explain what we do and all that. But when you branch out of the federal bubble, a lot of people have no clue what FMCS really does and what a mediator does. And if you go down the Twitter rabbit hole during the baseball negotiation, people had no clue what mediators do or FMCS. And my hope is that, I don't have a solution at this point, but my thought is how do you get FMCS to penetrate and understand that we can be helpful in a lot of different things? Because we do a lot of different things and we do labor relations. We've been doing that since 1947, but we do a lot of other thing. My other hope is, the one thing I like about the hybrid working remotely is the ability as you guys have mentioned to be able to work with people from California and Colorado and all over the country and work with variety of people in different things. That's very helpful, not get so sucked into the silo. I'm only a Northeastern mediator or West Coast or whatever ever. I think people learn a lot doing that. And I like that. And I always like just doing a variety thing. I hate doing the same thing over and over and over again, no matter what it is, even if I'm good at it or there's good outcomes. I like a variety of things. So my role is just to be open to whatever's out there and just say yes and fake it until you make it. So that's my thought.",
        id: 190800099,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
        codes: [6, 13, 10, 12, 33, 25, 26, 30, 29],
      },
      {
        audio_end_offset: 3512.496,
        audio_start_offset: 3509.73,
        duration: 2.6920000000000073,
        id: 190800102,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 3559.45,
        audio_start_offset: 3512.496,
        duration: 46.95399999999972,
        highlight_id: 5249032,
        highlight_words:
          "My hopes and dreams about the future of FMCS, when I first started, everyone said, it's my job to make sure you're successful. And I was like, what? Where am I? Because that's not the feeling that you get normally when you start a job, you don't expect to have that much support behind you right away when you walk in the door. So that I still think is going on. I think is great. When I first started people didn't leave the agency, when you left, you left because you retired. That's what I want to change for the future of FMCS, because that is not the case anymore.",
        id: 190800103,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [6, 41, 37, 40, 35, 25],
      },
      {
        audio_end_offset: 3560.49,
        audio_start_offset: 3559.45,
        duration: 1.0399999999999636,
        id: 190800104,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 3671.07,
        audio_start_offset: 3560.49,
        duration: 107.21000000000004,
        highlight_id: 5250469,
        highlight_words:
          "So my hope for FMCS is that we get back to that place where people want to stay here for the duration of their careers, because we do such wonderful things and interesting things and different things. And I'm with you, I love that it's different every day. And so I'm like, why would you leave that? Why would you leave to go do HR? But for some reason, people aren't sticking it out here anymore. So I hope that we can get back to that. I'm here until I retire you. And I hope to be in plan to be at FMCS until I retire. That's my plan for me in the future is to be here until I retire and do whatever I can to make it better so that people want to stay as well. Because it's been pretty heartbreaking to see the number of people that left. We know we lost a lot of people because of, we had some people going,",
        id: 190800105,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [6, 41, 37, 38, 40, 34, 35],
      },
      {
        audio_end_offset: 3674.342,
        audio_start_offset: 3671.07,
        duration: 3.1039999999998145,
        id: 190800107,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 3778.39,
        audio_start_offset: 3674.342,
        duration: 96.36799999999994,
        highlight_id: 5250470,
        highlight_words:
          "My hopes and dreams, pretty much follow what LaTonya just said, just in my unique seat that I sit in FMCS, my hopes and dreams and I'm going to say this until you all don't see me here anymore, which I hope is no time soon, but my hopes and dreams is that we can heal within. If you don't understand what I'm saying, then this may not apply to you, but I believe it does because it takes all of us. So my hopes and dreams is that everyone can really understand and recognize that it's not this person's problem or this group of people or it's whoever the point fingers can go to. My hopes and dreams that we all come to realization that it takes all of us to make it work. All of us, no matter where we sit, no matter what position we're in and that the same strength and all that we give out to others, we need to also be able to give that back to ourselves and do that and that my hope and dream is going to make us even more dynamic because not only are we the subject matter experts in everything that you all do, but we also live it every day in our workspaces and that we are comfortable. We feel included. It won't be perfect ever, but you will feel a sense of inclusion. You'll feel a sense that you are part, you see where you are in a mission. You see where you are if you're a support staff, you can see where you fit within the mission and the organization and you feel free to be able to have these conversations we're having right now with one another and we can actually mediate ourselves in this fear. So that's my big hope and dream, and I'm going to keep holding onto it as long as I can.",
        id: 190800108,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
        codes: [6, 41, 37, 38, 40, 34, 35],
      },
      {
        audio_end_offset: 3965.55,
        audio_start_offset: 3778.39,
        duration: 181.59000000000015,
        highlight_id: 5250472,
        highlight_words:
          "So my hope and dream, well, my belief, for the future of FMCS is maybe a little bit different than my hope and dream, but my belief for FMCS is, and again, I'm going to have to go with what a couple people had said today about this is that hybrid is here to stay. I think that it makes good fiscal policy to do RDTs, to do reimbursables, even to do EAOS virtually. It just makes good common sense when you're dealing with a relatively small budget, such as our agency is. I do think that our agency, and there's a couple different schools of thought here, prior to my entrance in the FMCS, most of the mediators that I dealt with, and I'm going back through 1995 kept a low profile. They came in, they did their professional best, and they left after the negotiations were over. Our last director, Giacalone changed that a little bit. And he wanted to push our name to the forefront of people's minds when they were dealing with negotiations, where before that wasn't really the case. So I think that our agency is really on the ground floor of a new labor evolution that's going on in this country. I do not think this is a blip. I think this is here to stay. I think the younger generation have a different outlook on what they want from employment. And because of that, I think that they are turning to unions as a lever or a tool to achieve those objectives. So that could give us a great segue for FMCS to come in and be a vital part and a very important part of their intro to labor relations. One way that I think that could be achieved is that our administration has to get it out more in the public. If we have to come get out from under the curtain or from behind the curtain. Which has seems to have been the way mediators always address their job. They'll do it low key. They'll stay behind the scenes and do their work. But I think that if our administration can get into some of these higher profile cases, which can get media attention and can get some eyeballs on the agency, and which would help possibly mitigate their not knowing what we do at our agency. I think that could be a boom, particularly that with the timing of this new labor movement revolution that I think is occurring right in front of us. It's pretty exciting.",
        id: 190800110,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
        codes: [6, 10, 11, 29, 16],
      },
      {
        audio_end_offset: 4208.71,
        audio_start_offset: 3965.55,
        duration: 240.76400000000058,
        highlight_id: 5250894,
        highlight_words:
          "Hopes and dreams just that we do continue to work. I heard the word silos earlier and I do hope that the idea of silos perhaps will be one, that'll be relegated to the past. That we can leverage the talents, the intellect, the verve of our various colleagues across and through the agency, both across the field, but then certainly in leadership too, that we can leverage those relationships to maximize our impact with our client. I love what Matt said about the three pillars. I think if we are really smart in this moment and take this moment as Lou mentioned, and really focus on using technology in our personnel to attack those three areas. I do think that the future looks bright.",
        id: 190800113,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
        codes: [6, 34, 33, 25, 24, 15],
      },
      {
        audio_end_offset: 4243.45,
        audio_start_offset: 4208.71,
        duration: 33.39000000000033,
        highlight_id: 5250475,
        highlight_words:
          "what really resonates with me is the hearing the wisdom of some of the mediators that's been here quite some time and the empathy and the care bear hugs that I heard with the newer mediators and experience sharing. I think that was great. That really resonated with me and helps to keep me in perspective that we do have different people onboarded differently and their experiences therefore are differently, so it helped me to continue to keep that in context.",
        id: 190800117,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
        codes: [6, 41, 37, 34, 35],
      },
      {
        audio_end_offset: 4253.79,
        audio_start_offset: 4243.45,
        duration: 5.890000000000327,
        id: 190800118,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4276.358,
        audio_start_offset: 4253.79,
        duration: 22.376000000000204,
        highlight_id: 5250476,
        highlight_words:
          "First blush takeaway, I would say, just be open and try to remain in touch with as many people as you can, because everyone has different experiences and you might learn something if you're open to listening and that's the key to being a good mediator anyway. So you might as well use it, not when you're mediating, but at all times. So that's my takeaway.",
        id: 190800119,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
        codes: [7, 41, 34, 35, 25],
      },
      {
        audio_end_offset: 4281.07,
        audio_start_offset: 4276.358,
        duration: 2.251999999999498,
        id: 190800120,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4322.2,
        audio_start_offset: 4281.07,
        duration: 41.13000000000011,
        highlight_id: 5250477,
        highlight_words:
          "Yeah, I think that we all had slightly different visions for the future, but we all had very specific experience that led us to that vision. And I think that it's the same in that we all want FMCS to serve more and more effectively. So I think that for us to get there, to allow this agency to be of greater service to the public, we need to use all of the experience and insights from all of our employees to get to that point. Because I think that we all have that same vision in that we can be more effective and we can be used more than we are.",
        id: 190800121,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
        codes: [6, 7, 37, 38, 40, 34],
      },
      {
        audio_end_offset: 4327.01,
        audio_start_offset: 4322.2,
        duration: 3.4099999999998545,
        id: 190800122,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4409.63,
        audio_start_offset: 4327.01,
        duration: 82.61999999999989,
        highlight_id: 5250478,
        highlight_words:
          "So I think the first takeaway that I will take away is the gratitude that everybody feels for this agency. My father worked for the federal government for 35 years. So as I was growing up, I learned a lot about the federal government. The experience is significantly different than what I remember being told specifically in this agency. Any meter that I speak with regardless of the amount of time that he or she may have, there is a genuine honest from the heart interest to help people. I don't think you will find that in all agencies or a lot of agencies. So that in my opinion, makes this agency unique. And for that I'm extremely grateful to be part of this organization, I certainly don't agree with everything that is done. And I'm sure a lot of people don't, but nonetheless, I'm very grateful to be here. I feel like this is my wheelhouse and I have opportunities to make impact that I otherwise didn't have. And for that, this was a good session.",
        id: 190800123,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
        codes: [7, 41, 38, 40, 35, 44],
      },
      {
        audio_end_offset: 4414.15,
        audio_start_offset: 4409.63,
        duration: 3.180000000000291,
        id: 190800124,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4456.81,
        audio_start_offset: 4414.15,
        duration: 41.07000000000062,
        highlight_id: 5250479,
        highlight_words:
          "sticking it out. There's a reason why we eat and care about the future of FMCS because we can get frustrated and being like, yeah, I don't have any hopes and dreams. I'm already looking for another job. None of that, none of that. So I'm just going to take away a lot of appreciation from today.",
        id: 190800125,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [6, 7, 34, 43],
      },
      {
        audio_end_offset: 4542.11,
        audio_start_offset: 4456.81,
        duration: 84.08199999999943,
        highlight_id: 5249044,
        highlight_words:
          "As for me, I will say optimism, hope, gratitude. So many of the things that you all have shared, even when given the opportunity to go down a darker path. Because we want honesty in this conversation. So many things, even the challenges were coupled with opportunities and humor, grace growth. So again, I'll center those in me and use that as I move forward from this space.",
        id: 190800126,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
        codes: [7, 41, 34, 25],
      },
      {
        audio_end_offset: 4606.19,
        audio_start_offset: 4542.11,
        duration: 63.210000000000036,
        highlight_id: 5249047,
        highlight_words:
          "I think this is awesome. When Kevin first told me about this, I was excited and I'm really excited to see it in practice. I can see so many ways that we can utilize this. I'm excited to see what happens on the other end, what the output looks like. But I really like this as a way of really allowing a comfort zone of sharing. And I really like that first question where you really need to be paying attention. You really need to be dialed in for you to see how can you share someone else's perspective or what part of that they shared can you relate with. So it really made you come outside of yourself and to see, am I like someone else's perspective or am I different or am I undecided? And it's okay wherever you are, but it really helped you to take it that next level of more in depth thought process and analysis. So I'm really excited about all of this and I think it went really well.",
        id: 190800128,
        speaker_id: 2,
        speaker_name: 'Speaker LA',
        codes: [7, 41, 34, 35, 43, 45, 44],
      },
      {
        audio_end_offset: 4612.23,
        audio_start_offset: 4606.19,
        duration: 0.9900000000006912,
        id: 190800129,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4701.63,
        audio_start_offset: 4612.23,
        duration: 88.91200000000117,
        highlight_id: 5249048,
        highlight_words:
          "I always just like talking with my colleagues. Any opportunity I have to get involved in something like this, I love it. And I appreciate it. And I think I felt safe just coming in. We had no idea what we were going to be talking about. We all just showed up and said, \"Yep, you can record me. Yep. You can record me.\" But I think that goes to show the amount of trust that we have just amongst ourselves because of who we are and what we do. So I just want to thank you guys for that. And I think also because of that, if this was a tool to be used with other mediators, I think if you have a pretty similar experience. Of course, there's going to be those ones that will drive down that rabbit hole, because there's always a couple, but given people. This is like drinking on their own Kool-Aid. Right now, personally, I think one of problems is FMCS is that we don't drink our own Kool-Aid. We teach all this stuff and we don't drink our own Kool-Aid. And so this is a forum to give people an opportunity to be heard. And we tell our parties, make sure that your folks' voices are heard, they're the ones doing the work. They're the ones that can give you the best in feedback. And so I think this is a great forum for that. And with it being smaller too, then you're being heard.",
        id: 190800130,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
        codes: [7, 41, 37, 38, 40, 34, 35, 25],
      },
      {
        audio_end_offset: 4707.85,
        audio_start_offset: 4701.63,
        duration: 0.9899999999997817,
        id: 190800132,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4748.51,
        audio_start_offset: 4707.85,
        duration: 38.36999999999989,
        highlight_id: 5249049,
        highlight_words:
          "Brenda, I think you had mentioned that there may be a desire to continue this type of forum. I think what would be pretty neat would be to have something like this for new mediator training, where you have a small round circle, a round table group and they would give one story of what their experience was an interesting, funny, bad, whatever it may be, but it may break up the academic feel of the new mediator training and allow the mediators, the current mediators to share some of their stories and give some insight to the mediators of what they're about embark on.",
        id: 190800133,
        speaker_id: 1,
        speaker_name: 'Speaker LB',
        codes: [7, 41, 37, 34, 35, 16],
      },
      {
        audio_end_offset: 4758.21,
        audio_start_offset: 4748.51,
        duration: 5.849999999999454,
        id: 190800134,
        speaker_id: 0,
        speaker_name: 'Speaker BC',
      },
      {
        audio_end_offset: 4786.81,
        audio_start_offset: 4758.21,
        duration: 28.600000000000364,
        highlight_id: 5249050,
        highlight_words:
          "I don't know any mediator that doesn't like talking about stories and that's the way you learn things. And when I was going through new mediator training, it was always helpful to have someone that had been doing it. Then you could just fire away and ask different things. And now, it's flipped to know I'm the person people will pick up a phone and call. So it's always good to pass things forward and any discussion on anything is always for me positive. So that's what I would say.",
        id: 190800135,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
        codes: [7, 41, 35, 25],
      },
      {
        audio_end_offset: 4809.33,
        audio_start_offset: 4786.81,
        duration: 22.339999999999236,
        highlight_id: 5249051,
        highlight_words:
          "I definitely enjoy hearing different perspectives from across the country and it makes me feel like part of the team, broadly, the FMCS team. So we talked about silos. I definitely get in my own little silo, but it's great to break out of that and feel like we're all working together for a common goal.",
        id: 190800136,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
        codes: [7, 41, 34, 33, 35, 25],
      },
      {
        audio_end_offset: 4822.052,
        audio_start_offset: 4809.33,
        duration: 11.390000000000327,
        id: 190800137,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
      },
      {
        audio_end_offset: 4953.924,
        audio_start_offset: 4822.052,
        duration: 131.58000000000084,
        id: 190800138,
        speaker_id: 6,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 4960.69,
        audio_start_offset: 4953.924,
        duration: 6.765999999999622,
        id: 190800140,
        speaker_id: 4,
        speaker_name: 'Speaker KC',
      },
      {
        audio_end_offset: 4964.19,
        audio_start_offset: 4960.69,
        duration: 3.5,
        id: 190800141,
        speaker_id: 6,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 4964.51,
        audio_start_offset: 4964.19,
        duration: 0.32000000000061846,
        id: 190800142,
        speaker_id: 3,
        speaker_name: 'Speaker LC',
      },
      {
        audio_end_offset: 4964.51,
        audio_start_offset: 4964.51,
        duration: 0,
        id: 190800143,
        speaker_id: 5,
        speaker_name: 'Speaker MC',
      },
    ],
  },
  {
    duration: 6948.075083,
    speaker_count: 8,
    id: 1909,
    snippets: [
      {
        audio_end_offset: 3.6161310452418096,
        audio_start_offset: 0.25,
        duration: 3.3661310452418096,
        id: 190900000,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4.47613104524181,
        audio_start_offset: 3.6161310452418096,
        duration: 0.8600000000000003,
        id: 190900001,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 64.95,
        audio_start_offset: 4.47613104524181,
        duration: 60.473868954758196,
        id: 190900002,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 235.384,
        audio_start_offset: 64.95,
        duration: 169.286,
        id: 190900003,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 408.71203021148034,
        audio_start_offset: 235.384,
        duration: 172.7200302114803,
        id: 190900006,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 415.13,
        audio_start_offset: 408.71203021148034,
        duration: 6.417969788519656,
        id: 190900011,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 472.31,
        audio_start_offset: 415.13,
        duration: 54.89999999999998,
        id: 190900012,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 474.41,
        audio_start_offset: 472.31,
        duration: 0.75,
        id: 190900014,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 476.27,
        audio_start_offset: 474.41,
        duration: 1.2999999999999545,
        id: 190900015,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 477.152,
        audio_start_offset: 476.27,
        duration: 0.7240000000000464,
        id: 190900016,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 479.93,
        audio_start_offset: 477.152,
        duration: 1.4379999999999882,
        id: 190900017,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 481.678,
        audio_start_offset: 479.93,
        duration: 1.6159999999999854,
        id: 190900018,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 483.35,
        audio_start_offset: 481.678,
        duration: 0.8620000000000232,
        id: 190900019,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 484.376,
        audio_start_offset: 483.35,
        duration: 0.8319999999999936,
        id: 190900020,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 486.09,
        audio_start_offset: 484.376,
        duration: 1.7139999999999986,
        id: 190900021,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 488.012,
        audio_start_offset: 486.09,
        duration: 1.76400000000001,
        id: 190900022,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 492.75,
        audio_start_offset: 488.012,
        duration: 1.858000000000004,
        id: 190900023,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 493.488,
        audio_start_offset: 492.75,
        duration: 0.6159999999999854,
        id: 190900024,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 495.014,
        audio_start_offset: 493.488,
        duration: 1.5260000000000105,
        id: 190900025,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 496.538,
        audio_start_offset: 495.014,
        duration: 1.391999999999996,
        id: 190900026,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 500.99,
        audio_start_offset: 496.538,
        duration: 4.451999999999998,
        id: 190900027,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 501.628,
        audio_start_offset: 500.99,
        duration: 0.6379999999999768,
        id: 190900028,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 506.62,
        audio_start_offset: 501.628,
        duration: 4.992000000000019,
        id: 190900029,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 510.616,
        audio_start_offset: 506.62,
        duration: 3.9219999999999686,
        id: 190900030,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 786.542,
        audio_start_offset: 510.616,
        duration: 272.602,
        id: 190900031,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 786.555821686747,
        audio_start_offset: 786.542,
        duration: 0.013821686746950945,
        id: 190900036,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 787.668,
        audio_start_offset: 786.555821686747,
        duration: 1.0501783132530136,
        id: 190900037,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 805.5,
        audio_start_offset: 787.668,
        duration: 17.831999999999994,
        id: 190900038,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 809.342,
        audio_start_offset: 805.5,
        duration: 3.673999999999978,
        id: 190900039,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 810.986,
        audio_start_offset: 809.342,
        duration: 1.6200000000000045,
        id: 190900040,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 812.916,
        audio_start_offset: 810.986,
        duration: 1.7960000000000491,
        id: 190900041,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 827.952,
        audio_start_offset: 812.916,
        duration: 14.877999999999929,
        id: 190900042,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 836.83,
        audio_start_offset: 827.952,
        duration: 8.878000000000043,
        id: 190900043,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 837.51,
        audio_start_offset: 836.83,
        duration: 0.67999999999995,
        id: 190900044,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 839.642,
        audio_start_offset: 837.51,
        duration: 2.132000000000062,
        id: 190900045,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 866.37,
        audio_start_offset: 839.642,
        duration: 26.097999999999956,
        id: 190900046,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 874.99,
        audio_start_offset: 866.37,
        duration: 5.669999999999959,
        id: 190900047,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 916.21,
        audio_start_offset: 874.99,
        duration: 40.110000000000014,
        id: 190900048,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 919.97,
        audio_start_offset: 916.21,
        duration: 3.759999999999991,
        id: 190900049,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 974.68,
        audio_start_offset: 919.97,
        duration: 54.60000000000002,
        id: 190900050,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 975.268,
        audio_start_offset: 974.68,
        duration: 0.5260000000000673,
        id: 190900051,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 976.588,
        audio_start_offset: 975.268,
        duration: 1.13799999999992,
        id: 190900052,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 981.43,
        audio_start_offset: 976.588,
        duration: 3.7420000000000755,
        id: 190900053,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1068.89,
        audio_start_offset: 981.43,
        duration: 83.54000000000008,
        id: 190900054,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 1208.058,
        audio_start_offset: 1068.89,
        duration: 134.9179999999999,
        id: 190900056,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1210.12,
        audio_start_offset: 1208.058,
        duration: 1.8920000000000528,
        id: 190900059,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 1211.236,
        audio_start_offset: 1210.12,
        duration: 0.9820000000001983,
        id: 190900060,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1219.07,
        audio_start_offset: 1211.236,
        duration: 4.233999999999924,
        id: 190900061,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 1298.47,
        audio_start_offset: 1219.07,
        duration: 78.52999999999997,
        id: 190900062,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1471.35,
        audio_start_offset: 1298.47,
        duration: 168.60799999999995,
        highlight_id: 5249053,
        highlight_words:
          "Because I had two things happen in the last two years, we all did. We not only went into pandemic lockdown, we had a reorganized agency, like immediately before it, and then we went into lockdown. So for me personally, I had a new role, a new structure in the organization, as well as pandemic. And so the opportunities for myself have been a lot of growth, personally and professionally. And doing a lot of things that, in my mind, have been important for the agency over the years. I love being a mediator. It's really my dream job. It's more like David, spiritual.",
        id: 190900063,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
        codes: [4, 2, 38, 34, 30, 16],
      },
      {
        audio_end_offset: 1480.93,
        audio_start_offset: 1471.35,
        duration: 8.300000000000182,
        id: 190900067,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1604.25,
        audio_start_offset: 1480.93,
        duration: 123.31999999999994,
        highlight_id: 5249056,
        highlight_words:
          "I've had an opportunity to ... I'll talk about the opportunities first, and then I guess the challenges, which is not that many. But a lot of good opportunities for a good work/life balance for me, to exercise more in the morning. It's cut out the commute, so opportunity to lose some pounds. I've actually lost quite a few pounds because I've been able to walk more after work. And the other opportunities were, I don't know.",
        id: 190900068,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
        codes: [4, 2, 29, 21],
      },
      {
        audio_end_offset: 1631.138,
        audio_start_offset: 1604.25,
        duration: 26.81600000000003,
        id: 190900070,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1633.95,
        audio_start_offset: 1631.138,
        duration: 1.4020000000000437,
        id: 190900071,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 1640.064,
        audio_start_offset: 1633.95,
        duration: 6.087999999999965,
        id: 190900072,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 1914.37,
        audio_start_offset: 1640.064,
        duration: 271.74,
        highlight_id: 5249059,
        highlight_words:
          "In terms of challenges, really I think just one really great big one for me, maybe a couple. But the biggest, the overarching one was having done this now for about 12 years, between the FMCS and the national mediation board, I think if you asked me when I first started working as a mediator, what's the primary reason you decided to make the career change, and I think I would've told you back then, it is I like to help parties resolve conflict. That that was the primary reason. I think one thing that's been highlighted for me through this transition to virtual and then living in a virtual world is, I no longer think that's the primary reason that I decided to be a mediator. I think the primary reason I decided to be a mediator is I like people. And I like working with people, and interacting with people and problem solving with people. And so that's created a challenge for me, because having that go away, kind of cold turkey, it really has changed my world and it's really highlighted that for me, so from a personal perspective, I'm excited to have had the opportunity in the last couple weeks to see people face to face and then looking forward to that in the future. I think one of the other challenges that's created is a large portion of my cases are within Texas. And for anybody who watched the press and the news as the pandemic sort of came upon us and people reacted to that, and then how quickly some areas of the US changed their perspective and reacted differently, one of the personal challenges that was created for me is, my parties went back face-to-face eons ago.",
        id: 190900073,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
        codes: [3, 4, 13, 10, 12, 24, 28],
      },
      {
        audio_end_offset: 1919.41,
        audio_start_offset: 1914.37,
        duration: 3.880000000000109,
        id: 190900078,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2073.71,
        audio_start_offset: 1919.41,
        duration: 148.8599999999999,
        highlight_id: 5249062,
        highlight_words:
          "Opportunities, just like Walter, meeting new people. Got the chance to interact with a lot more people. Walter was one of them. I had the pleasure of working with Walter on an international project, and that was great. So that's an opportunity. Expanding the technology, doing more things is always good. I enjoyed that. I was able to reach my international partners more easily. I've developed a friendship with somebody from Ukraine, and I've been in touch with her every couple of days. It's very tough over there. So I value that and a lot of other international relationships that I have, which absolutely would not be possible without the platform. And like Stephanie said, and really Walter also, the less time commuting has freed up more time with family. I have a 15 and a half year old boy, nine year old girl, and I'm around. And my position is the chance to not be around. I'm going to have those decisions to make as we come out of the pandemic, but it's been good being present.",
        id: 190900079,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
        codes: [3, 2, 10, 11, 12, 33, 25, 26, 29, 22],
      },
      {
        audio_end_offset: 2076.95,
        audio_start_offset: 2073.71,
        duration: 1.1100000000001273,
        id: 190900083,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2199.046,
        audio_start_offset: 2076.95,
        duration: 120.40000000000055,
        highlight_id: 5249064,
        highlight_words:
          "So opportunities, right? A lot of the same things you've already heard from several other people, I got to work with new colleagues. It's like today, for example. We might not be able to do this today if we weren't virtual, those kinds of things. When you have pink eye and you have to switch a meeting to virtual, that's always nice, right? To be able to have that backup. We didn't have that before COVID. The party certainly wouldn't have been able to pop a laptop on there and go to Zoom and handle all that on their end as well, so not just our training but the customers and the world getting up to speed virtually gives us another option to be able to still be productive even if we can't be in person, even in the new world, right? So it's another tool in the toolbox. I feel like some of the opportunities involved in that were of course getting to be trained up on those things during COVID for us to be able to do that. I think the agency spent a lot of time and resources on getting us transitioned technologically into that environment to make us productive, to make us relevant. People weren't meeting at all in person, especially two years ago when it was really bad, or a year ago. So I thought that was great and good opportunities.",
        id: 190900084,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [4, 2, 11, 33, 35, 30, 29, 15, 16],
      },
      {
        audio_end_offset: 2201.9454237288137,
        audio_start_offset: 2199.046,
        duration: 2.899423728813872,
        id: 190900088,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2203.812,
        audio_start_offset: 2201.9454237288137,
        duration: 1.768576271186248,
        id: 190900089,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 2300.31,
        audio_start_offset: 2203.812,
        duration: 94.28799999999956,
        highlight_id: 5249066,
        highlight_words:
          "So that new structure, when you have that, that's always challenging. But I think one of the big positives was, the team that I was from still stayed together. We still talk. We still do retirement stuff. We still have support groups. We still meet, just like we did just virtually, sometimes in person. And then I got to meet a new team and make new friends and new colleagues down in the southeast. So that was the positive of that. So now I feel like I'm on two teams with two different people and I feel like I get to know more folks and I think that's nice. There were some transitions with Peter leaving, he retired, and so now Steve is a new director, so I've had a few different directors in that time period, and each one of them has been very professional and worked with me and provided the resources that I needed and the communication that I needed and instruction that I needed for that transition. So I thought those challenges were, now at the end of the day, you can look back and hindsight is 20/20, were handled well.",
        id: 190900090,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [3, 4, 41, 33, 35, 25, 26],
      },
      {
        audio_end_offset: 2306.83,
        audio_start_offset: 2300.31,
        duration: 2.0700000000001637,
        id: 190900093,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2644.008,
        audio_start_offset: 2306.83,
        duration: 333.1779999999999,
        highlight_id: 5249068,
        highlight_words:
          "Challenges, converting trainings into virtual, including the element of fun. Sometimes it wouldn't be hard to convert the training aspects, and [inaudible] but the fun part of it was harder for me, the interaction part of it. On a personal level, another challenge was the fear of the unknown, especially pre-vaccine. That was scary. How much of a toll does that take on society and mankind? And then the other part of a challenge was the loss of windshield university. All the time behind the car with NPR, podcasts, that was where I learned and expanded, and also was able to calm myself, whether it was going to a meeting in the mornings or coming home from work, so that I was able to be in the place when I was there, trying to be pressing. Those are challenges.",
        id: 190900094,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
        codes: [3, 4, 12, 30, 15, 16, 20],
      },
      {
        audio_end_offset: 2734.11,
        audio_start_offset: 2644.008,
        duration: 86.3720000000003,
        id: 190900099,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2740.922,
        audio_start_offset: 2734.11,
        duration: 6.7039999999997235,
        id: 190900100,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 2754.623609271523,
        audio_start_offset: 2740.922,
        duration: 13.701609271523012,
        id: 190900101,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2764.99,
        audio_start_offset: 2754.623609271523,
        duration: 8.356390728476981,
        id: 190900102,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 2767.362,
        audio_start_offset: 2764.99,
        duration: 2.2040000000001783,
        id: 190900103,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 2955.01,
        audio_start_offset: 2767.362,
        duration: 183.7819999999997,
        highlight_id: 5250621,
        highlight_words:
          "So I'll talk about, without getting specific to the parties, about one that really emphasizes a challenge because it weighs heavy on me. I think as mediators, we've all had times where we maybe at times felt like we weren't successful with the parties. And I had a group, a fairly large represented group here in Texas that I was working with. When I first started working with them, they were meeting virtually and I was assisting them virtually. And then they made the decision to go back face-to-face, and sought the approval to join them face-to-face, and we decided as an agency that that wasn't appropriate at that time. So I stayed in a virtual, my max headroom as I described it, environment. And ended up ultimately not being able to help them cross the finish line. And it was a huge challenge for me personally because I really felt like I was hamstrung not being there with them, and having them be there in person. There were things happening in the room. The committees were very large. Multiple people on each side of the table, and I'm going to tell you, eight to 10 people on each side of the table. So it just created some pretty huge challenges for the process, and those weighed heavily on me personally because I ... Maybe it is a cop out, I don't know, on my part but I'd like to think it wasn't. But I really just felt like I was ... It was an unsuccessful environment for me as a mediator, being there as a laptop sitting at the end of the table when everybody else was there in person.",
        id: 190900104,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
        codes: [3, 4, 2, 13, 10, 11, 38, 24, 28],
      },
      {
        audio_end_offset: 2964.94,
        audio_start_offset: 2955.01,
        duration: 9.929999999999836,
        id: 190900107,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3096.91,
        audio_start_offset: 2964.94,
        duration: 127.41400000000021,
        highlight_id: 5250623,
        highlight_words:
          "I had gotten a couple of assignments for a board of adjustments that my first 18 years with FMCS, I think I was invited to three board of adjustments, and all of the sudden I've been invited to several, like four different agencies that have had different types of companies and unions that have board of adjustments. And one of them is in the janitorial field. And in each one of those board of adjustments, in almost anything in my practice, I'm a big advocate of ice breakers. So used an ice breaker in a board of adjustments and simple ice breakers, but it was a third board of adjustment, same union, different janitorial company. And the president of the union said, \"Before we start, I want you to all know that Steve's going to make us do an ice breaker.\" And the first time that he forced me to do it, I wondered why and I thought it was kind of a stupid idea. I've done like five now with him, and I know exactly why he does it. It makes us realize how much more we have in common than we have differences, and how we can build upon those commonalities to reach a solution, and I'm so excited that I can't wait for whatever his ice breaker is.\" So that's my story.",
        id: 190900108,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
        codes: [4, 10, 12, 25],
      },
      {
        audio_end_offset: 3097.996,
        audio_start_offset: 3096.91,
        duration: 0.9520000000002256,
        id: 190900110,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 3102.55,
        audio_start_offset: 3097.996,
        duration: 3.6839999999997417,
        id: 190900111,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3360.88,
        audio_start_offset: 3102.55,
        duration: 256.1080000000002,
        highlight_id: 5250632,
        highlight_words:
          "Mine's another field story. It's, I guess, a challenge. So returning to in person work, right? I had an IBB teacher negotiation in Illinois, over the last couple of months. It ended about a month ago. When you return to work, I think a lot of people, from other colleagues I've been talking, some of them have a mental block about returning to work a little bit, right? And in person, and it's a lot different, it's been awhile, that kind of thing. So some of us haven't fired our big guns in person for awhile when you need to control the room. So that can be a real breakthrough when you have that set of release happen. And so that happened to me here recently. So I don't know if you guys have ever been an IBB and the parties aren't doing that great on the ground rules and decorum and stuff, and you feel like you're watching your awkward married couple fight in front of you, right? So that's never a fun feeling and that's usually what I tell folks when I start to get on them about decorum. You ever been on a date with a married couple and they fight in front of you? How did you feel? It's kind of awkward, huh? When we talk over each other and we fight and argue, it's just going to have to split us up. That's what's going to happen. So we were caucusing. So that was my first little push on them to pay attention, look at the back of your name card. You remember the rules, right? On the FMCS name card. So about noon or so at lunch, and this was a historically difficult group. So we get to noon at lunch, some folks are telling me they're stressed out with other people in the room and how they're talking to each other, and the process, that kind of stuff, the stuff you start hearing. They're not doing what they're supposed to be doing on the breaks, right? I come back from lunch. And they're good for a little while because it was arsenic hour and they were full and sleepy. So we were good for a little bit. We got some stuff done. We made it through a whole issue in like two hours. Wow, good job everybody. So then we get to the end of the day and everybody's starting to crash out. It was an eight hour session, and they're getting grumpy and they're starting to get into economics now, and they're starting to talk over each other again. So I had to end the meeting early, about a half an hour or so before its scheduled time because it just wasn't productive, and basically send them home with a homework process to talk about when we come back the next time, about whether the parties want to reengage in IBB, or if we need to go ahead and talk about some [inaudible] conditional stuff, which is really hard for them to accept because they've been doing IBB for a long time. And I get this email from the superintendent the next day after that meeting, who was very apologetic. He was apologetic for his management side team, and about six hours later the next day, I got an email from the union rep, and they were apologetic about how they were conducting themselves at the mediation. I had almost sent out an email to them in the morning before they sent that to me the next day, basically almost saying sorry I was so harsh and haranguing you or something like that, and I didn't. And so I talked to Steve actually about it, Nolan, who is my current supervisor. And so when I talked to him about it, he was like, \"Maybe that's what they needed to hear,\" and so he's like, \"Let's see if we hear from them before the next meeting.\" Sure enough, I didn't email them as a result of him telling me that. And so I got those emails that day a little bit later, so I'm glad I waited. So we have to remember when we go back in person, it's a lot harder when they're not doing what they're supposed to do, that it is sitting here and controlling something, right? Because you don't know what's going on. There's so much happening in the hallway. It's people and they're interacting, and if they're in person, like Walter said, and I'm remote, I'd rather be the other way almost where they're all separated, and that kind of thing. Because it's just not the same when they're not doing what they're supposed to do.",
        id: 190900112,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [4, 9, 10, 12],
      },
      {
        audio_end_offset: 3367,
        audio_start_offset: 3360.88,
        duration: 6.119999999999891,
        id: 190900119,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3371.51,
        audio_start_offset: 3367,
        duration: 3.4600000000000364,
        id: 190900120,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 3371.766,
        audio_start_offset: 3371.51,
        duration: 0.2559999999998581,
        id: 190900121,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3497.91,
        audio_start_offset: 3371.766,
        duration: 124.03200000000015,
        highlight_id: 5250626,
        highlight_words:
          'A great challenge that I had was when I went from working at headquarters, this was around 2005 to the field office, I wanted to become a real mediator, so I wanted to do that. I wanted to be closer to home. And somebody down in Washington when they heard I was doing this, they said, "You\'re going to have to lick the boots of the other mediators up there when you go there." It\'s like okay, not the nicest thing to say but it resonated with me.',
        id: 190900122,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
        codes: [3, 38, 40],
      },
      {
        audio_end_offset: 3515.562831553974,
        audio_start_offset: 3497.91,
        duration: 17.65283155397401,
        id: 190900125,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3573.7,
        audio_start_offset: 3515.562831553974,
        duration: 58.13716844602595,
        highlight_id: 5249076,
        highlight_words:
          "Through all my years with FMCS, it's been a lot. My story is about performance appraisal. It's just how when you've had five, six different supervisors and the first few, because I was young and new, they spoiled me. They would just write wonderful things about me and things like that, and then as the years go by, you have to write that yourself. You have to document that yourself. So that's basically my story of, it's a challenge. It became a challenge because my the time the end of the year comes, I haven't written anything. And it's like no, I ... So anyways, it's a challenge still just writing yourself, to help to give yourself a good performance email. And not being spoiled by someone else doing it for you. Those days are over.",
        id: 190900126,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
        codes: [4, 38, 40],
      },
      {
        audio_end_offset: 3583.4798076370944,
        audio_start_offset: 3573.7,
        duration: 9.779807637094564,
        id: 190900127,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 3586.479190353144,
        audio_start_offset: 3583.4798076370944,
        duration: 2.999382716049695,
        id: 190900128,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 3852.55,
        audio_start_offset: 3586.479190353144,
        duration: 263.24280964685613,
        highlight_id: 5250625,
        highlight_words:
          "My story is actually a practice story too, even though I've been in a different role for the last two years. In the last eight months, I actually had to go mediate with another mediator, a lengthy strike. And we got to go, it was in a different part of the country, and you get used to running your own show as an individual mediator. You think you know how things are, and after 24 years, I learned that different parties, different places, things that you think are kind of common place, just are not. And also one of the things that had been talked about earlier, maybe by Walter, was working with other people, or Steve. I've always loved working with other mediators across the agency but never got to mediate with others. We just don't have time to do that where I'm from. So I partnered with the local mediator, and I just was ... It was very challenging because we had one week in person where very little happened, because they were still in the throes of taking each other down in vicious striking. And then about three months later, all of the sudden, they wanted to meet again, but it was all going to be virtually and done through a very stilted process in my opinion. But the co-mediator and I did things I would never have thought of, dreamed of, tried before, because we had to virtually. They only wanted to do things through supposals. And yet, they were people of low honor and trust and so it was about how does the mediator now create integrity carrying everything supposally, virtually, when you can't trust either one of them, okay? So we ended up doing something I never thought I would do but we created a written supposal record of everything we carried, including embedding their supposals right in the document and putting our giant cast of confidentiality on it, and they wouldn't even agree they'd be confidential but we kept saying, \"This is all confidential in writing.\" And luckily, they adhered to it. But the point was, I did it with the mediator. We brainstormed every step and strategized. It was really quite a brilliant process. I loved mediating with that other mediator. We both found support, creative ideas, and I learned a lot about how people do things in other parts of the country. For instance, these parties, in 20 years of working with this mediator, refused to every sidebar. They will not sidebar no matter what, ever, ever or ever, no matter what ground rules you put. You can't them two advocates in the hall to sidebar or any configuration of the sort. So it makes a very ... I never worked with a group that would never sidebar period.",
        id: 190900129,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
        codes: [4, 10, 12, 33, 25, 26, 29],
      },
      {
        audio_end_offset: 3935.736,
        audio_start_offset: 3852.55,
        duration: 73.90000000000009,
        id: 190900135,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4028.61,
        audio_start_offset: 3935.736,
        duration: 91.35400000000027,
        highlight_id: 5249079,
        highlight_words:
          "I'd like to build on something that Steven said that really resonated with me, and I didn't really realize it until he said it. But I've done a fair number of RDTs since we've been in this virtual world. And I think one of the comments you made, Steven, was lacking fun or trying to keep the fun in the exercises. I tend to tell people when I do RDTs that I'm actually somebody who believes there is something called death by PowerPoint. And so I try and make mine as, maybe to a fault, overly interactive. And that has been a huge challenge for me in this virtual world, is how do you continue to engage people in exercises on a screen? Because so many times, my exercises would have them get up and part of them leave the room, and part of them come back. So that resonated with me. I hadn't put my thumb on it. I knew I was having challenges and trying to be creative, but I didn't think about it as keeping it fun. That word didn't come to me in my mind, and I think that was helpful to hear that you've got to keep it a little bit fun for people, when you're teaching them, if you want to keep them engaged, and so I just wanted to comment on that, Steven. That was helpful.",
        id: 190900137,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
        codes: [5, 12, 31, 29],
      },
      {
        audio_end_offset: 4054.87,
        audio_start_offset: 4028.61,
        duration: 26.259999999999764,
        id: 190900139,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 4057.63,
        audio_start_offset: 4054.87,
        duration: 1.4700000000002547,
        id: 190900140,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 4246.15,
        audio_start_offset: 4057.63,
        duration: 186.07400000000052,
        highlight_id: 5249080,
        highlight_words:
          "I guess I'd follow up on something that Walter said and I guess it flows from this conversation. I think at the very beginning you mentioned about why you took the job energy from people, I think was the comment that was made. That's a number one reason why I think that I took the job. While most of us came from backgrounds where we were some type of leadership and some type of experience for these types of things, or we came from some background that allowed us to contribute to FMCS in whatever our role is here. And I think whenever we're around people, whether it's in a mediation, whether it's our colleagues and peers, whether it's an office space, whoever it is you work around, in that world. When they get taken out, like with COVID for so long, we've had to work virtually, anytime we get to reengage with people, we learn more about them. It builds camaraderie and it increases morale. And I think that energy that we don't get from each other, whether it's customers, whether it's our coworkers, whether it's in a field station, or whether it's in Washington, when we don't have that connection, we start to lose. And people are three dimensional, a screen is only two dimensional, no matter how often you meet on it. And so we lose that energy. That just can't be transferred through that.",
        id: 190900141,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [5, 12, 25, 24, 28],
      },
      {
        audio_end_offset: 4251.774,
        audio_start_offset: 4246.15,
        duration: 5.468000000000757,
        id: 190900148,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4335.91,
        audio_start_offset: 4251.774,
        duration: 82.66399999999885,
        highlight_id: 5249083,
        highlight_words:
          "I just wanted to connect very quickly with something David said way back in his intro about his spiritual check in and this being a sort of spiritual practice. I'm not a religious person, but I feel like David does. And I thought David McIntosh, I was doing this job to help people solve problems, or Walter. But I came to find out very quickly, what really I love about mediation and working with other mediators is helping people get their voice and their power and growing. Helping them speak up. The theme of this MIT thing here, the voices that don't get heard, that was my biggest thrill in mediation is like, \"Hey, quiet person, say something.\" And they'd say something amazing. And then I want to prompt them to grown blossom and more. And so, Stephanie, you need to tell your own story because no one's going to do it for you probably. So I guess I view this all as, and even connecting with the other mediators across all projects, I tell every new mediator to say yes to every project you're asked for because you'll get more out of it than you give. And it's all because we can grow together. So I just appreciate, it sounds touchy feely, David, to say spiritual but I think it is.",
        id: 190900149,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
        codes: [5, 10, 43, 44, 25],
      },
      {
        audio_end_offset: 4346.03,
        audio_start_offset: 4335.91,
        duration: 5.9099999999998545,
        id: 190900151,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4368.15,
        audio_start_offset: 4346.03,
        duration: 22.11999999999989,
        id: 190900152,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 4415.11,
        audio_start_offset: 4368.15,
        duration: 45.6200000000008,
        highlight_id: 5250631,
        highlight_words:
          "You know with the performance appraisal, I don't know if you all know that I was also in the Navy for six years. In the military, they will automatically write you up, how good you are, how bad you are. And so it carried over into FMCS, so it did happen for me at the early years, wrote how wonderful I was. And then as years go on, we're not doing that anymore. So that was the challenge of you write your own story now. It's still a challenge. I have stories.",
        id: 190900153,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
        codes: [3, 4, 38],
      },
      {
        audio_end_offset: 4433.95,
        audio_start_offset: 4415.11,
        duration: 17.910000000000764,
        id: 190900154,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4439.35,
        audio_start_offset: 4433.95,
        duration: 3.8100000000004,
        id: 190900155,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 4635.37,
        audio_start_offset: 4439.35,
        duration: 188.30000000000018,
        id: 190900156,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4694.63,
        audio_start_offset: 4635.37,
        duration: 55.82999999999993,
        highlight_id: 5249084,
        highlight_words:
          "But I guess my hope and dream is that overall, we feel connected to a caring culture. We're so proud to be part of, again, a sense of a family place. And I want to keep working to help people feel connected and that they are cared for. I just remember when I started, I couldn't believe how welcoming and connected people made me feel as a new mediator. Nobody said I had to lick anybody's boots, David. And in fact, I was treated wonderfully, everywhere I went and I always have been. And I feel privileged. Honestly, I feel like working at FMCS has been the greatest gift of my professional career, and I want other mediators and employees to feel that way.",
        id: 190900158,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
        codes: [6, 41, 37, 25],
      },
      {
        audio_end_offset: 4700.37,
        audio_start_offset: 4694.63,
        duration: 1.4200000000000728,
        id: 190900159,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4782.79,
        audio_start_offset: 4700.37,
        duration: 79.17000000000007,
        highlight_id: 5249085,
        highlight_words:
          "My hope and dream expands beyond the agency. I'd like for FMCS to be seen as a major resource for helping resolve conflict in our society. We are so polarized right now in many ways, on an interpersonal level but of course in our politics. I had written something along the lines of us working with the ad council for like public messages on conflict competence and posters everywhere and mediators going to very public forums, talking about the importance of understanding one another, listening, respecting one another, not otherizing or demonizing one another. That's my vision. I hope we can become even more interdisciplinary. We're a little bit interdisciplinary now. I know we have interest in neuroscience and things like that, but it would be nice to maybe even have some people with social work and psychology backgrounds in our agency, without forgetting our mission to help labor and management. That's vital to the economic health of the country, but it's also a chance to infuse some of the things that I'm talking about here.",
        id: 190900160,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
        codes: [6, 34, 33, 35, 44, 16],
      },
      {
        audio_end_offset: 4787.03,
        audio_start_offset: 4782.79,
        duration: 1.2399999999997817,
        id: 190900161,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4833.89,
        audio_start_offset: 4787.03,
        duration: 46.86000000000058,
        highlight_id: 5250993,
        highlight_words:
          "I guess just to follow up on that, my thoughts would be that FMCS is able to grow and to advance in what they're doing. As far as conflict management, the congress recognizes that and gives us the funding that we need to be able to do not just the labor management stuff that David mentioned, but also the other things that we can be a positive contribution not just to the US society but to international programs and everywhere we can reach our flag to, right? So if we can do that, we have to have the jingle jangle in the pocket to do that and we have to get our message up there, and to do that, we have to do the work. And I think we've been doing the work. We do great work. It's just a matter of highlighting that and showcasing that effectively, and I think that's going to happen. That's my hope and dream for FMCS.",
        id: 190900162,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [6, 41, 37, 38, 34, 35],
      },
      {
        audio_end_offset: 4835.552,
        audio_start_offset: 4833.89,
        duration: 1.6239999999997963,
        id: 190900163,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 4847.168,
        audio_start_offset: 4835.552,
        duration: 11.434000000000196,
        highlight_id: 5249087,
        highlight_words:
          "And then how my professional, personal goals go into that, I think needs to be tied to whatever the agency's mission is, and if that happens, then I can continue to help people in my area, in my sphere of influence such as it is.",
        id: 190900164,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [7, 34, 35, 44],
      },
      {
        audio_end_offset: 4899.2,
        audio_start_offset: 4847.168,
        duration: 52.03200000000015,
        id: 190900165,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5045.85,
        audio_start_offset: 4899.2,
        duration: 139.45399999999972,
        highlight_id: 5249089,
        highlight_words:
          "But my hopes and dreams, I guess for the future, that we get back to those days of those rankings because I think there has to be real things that caused those rankings, but I think it also can be somewhat of a self-fulfilling prophecy that if you attain those rankings, or close to those rankings, then people talk about that internally and then it becomes somewhat self-perpetuating. So that's my hope is really internally that we get back to that, so how would my role in that fill in?",
        id: 190900166,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
        codes: [6, 34, 35],
      },
      {
        audio_end_offset: 5048.88,
        audio_start_offset: 5045.85,
        duration: 3.0299999999997453,
        id: 190900169,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5116.93,
        audio_start_offset: 5048.88,
        duration: 68.05000000000018,
        highlight_id: 5249092,
        highlight_words:
          "For me, my hope and dreams are for FMCS to continue to be accepted into CBMs and any other service that customers want, and to see us not get too much smaller, and to just grow and adapt to changes, and I see my role in that the same as I am now, an administrative assistant. And whether or not we're in offices or working from home, I'd like to still see us grow. It doesn't matter whether it's a bigger office or a smaller office. I'd just like to see all of the mediators accepted into different cases where they're not getting active, to get active.",
        id: 190900170,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
        codes: [6, 34, 35],
      },
      {
        audio_end_offset: 5129.87,
        audio_start_offset: 5116.93,
        duration: 10.359999999999673,
        id: 190900171,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5133.8,
        audio_start_offset: 5129.87,
        duration: 3.930000000000291,
        id: 190900172,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5138.228,
        audio_start_offset: 5133.8,
        duration: 4.246000000000095,
        id: 190900173,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5138.708,
        audio_start_offset: 5138.228,
        duration: 0.4179999999996653,
        id: 190900174,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5140.376,
        audio_start_offset: 5138.708,
        duration: 1.5340000000005602,
        id: 190900175,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5220.77,
        audio_start_offset: 5140.376,
        duration: 68.02399999999943,
        id: 190900176,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5229.41,
        audio_start_offset: 5220.77,
        duration: 7.779999999999745,
        id: 190900178,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5231.27,
        audio_start_offset: 5229.41,
        duration: 0.9899999999997817,
        id: 190900179,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 5233.49,
        audio_start_offset: 5231.27,
        duration: 1.4799999999995634,
        id: 190900180,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5238.21,
        audio_start_offset: 5233.49,
        duration: 1.180000000000291,
        id: 190900181,
        speaker_id: 3,
        speaker_name: 'Speaker CC',
      },
      {
        audio_end_offset: 5252.704,
        audio_start_offset: 5238.21,
        duration: 14.347999999999956,
        id: 190900182,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5255.62,
        audio_start_offset: 5252.704,
        duration: 2.9160000000001673,
        id: 190900183,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5667.47,
        audio_start_offset: 5255.62,
        duration: 383.6900000000005,
        id: 190900184,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5681.67,
        audio_start_offset: 5667.47,
        duration: 11.789999999999964,
        id: 190900192,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5695.32,
        audio_start_offset: 5681.67,
        duration: 12.304000000000087,
        id: 190900193,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 5708.89,
        audio_start_offset: 5695.32,
        duration: 10.69000000000051,
        id: 190900194,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5768.172,
        audio_start_offset: 5708.89,
        duration: 59.18399999999929,
        highlight_id: 5249093,
        highlight_words:
          "I am pestering my EM about trying to do open office hours. I'm hoping maybe around June or July that I will have four hours once a week where my clients can just self-schedule themselves into there, to be able to do some of the things that it is, whether it's an opinion on a particular situation or whether they just need some personal time with me to talk about negotiation or something like that. And in those open office hours, I hope to block off an hour every few weeks or so and talk with another mediator whose done something really cool and just have some time with that, and that time will be open for anybody to come and listen to that conversation or engage in it.",
        id: 190900195,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
        codes: [4, 35, 25, 29],
      },
      {
        audio_end_offset: 5792.53,
        audio_start_offset: 5768.172,
        duration: 24.358000000000175,
        id: 190900196,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5859.79,
        audio_start_offset: 5792.53,
        duration: 65.14000000000033,
        highlight_id: 5249094,
        highlight_words:
          "I'd say I would like to be one of the people whose innovating in some of the directions that Steven was talking about. Having us be available to our clients for a wide range of situations, interpersonal conflicts, inter group conflicts with a keen understanding of human psychology and being able to apply, I guess learnings from other disciplines to our work. And also in that external piece that I was talking about. I love to strategize, use some of the public policy training that I have to try to see where we can get in there and legislation and just have a bigger voice for our agency to promote a really, really important message. We're busting apart at the seams of society. We're demonizing one another, and it's time to listen to one another with respect. Not agree on everything, and there's not enough people saying that. There's no center in this country anymore.",
        id: 190900197,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
        codes: [6, 10, 16],
      },
      {
        audio_end_offset: 5871.33,
        audio_start_offset: 5859.79,
        duration: 9.13000000000011,
        id: 190900198,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 5988.01,
        audio_start_offset: 5871.33,
        duration: 116.19599999999991,
        highlight_id: 5249095,
        highlight_words:
          "Just speaking from, I guess, Indiana is as center as you can get these days, I suppose, right? Geographically anyway. So the thought I was having was, as FMCS evolves here over the next year, two years, whatever this is when the restructuring finishes, I think we'll each be able to determine how we can plug in with our talents that we have. My main focus has always been on contract bargaining and arbitration. That's what my background was in. Some folks are fantastic trainers and there will always be a better trainer than I am, a facilitator. That was their background and they've been doing it for decades, right?",
        id: 190900199,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [6, 33, 16],
      },
      {
        audio_end_offset: 6215.63,
        audio_start_offset: 5988.01,
        duration: 221.57800000000043,
        id: 190900202,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6314.79,
        audio_start_offset: 6215.63,
        duration: 97.65999999999985,
        highlight_id: 5249097,
        highlight_words:
          "I think the thing that I'm taking away is that others in the agency, and I've worked with many of you, I've not worked with everybody, but others in the agency and particularly those that I've worked with are going through some of the same things that I'm going through. And that should probably be an oh duh moment, but I guess I hadn't stopped to focus on that. I've been trudging along in my own lane. So that's a takeaway for me, is that my experiences through this last couple years are maybe not so unique, that there are others that are experiencing the same. And there's things I can learn from them to help process all that. As far as the platform and the flow of conversation, to me it was pretty natural, and I think that was probably in my mind, as I evaluate it, it was platform driven, certainly facilitator driven. But then also participant driven, because I think we have a group here that my perception is people were comfortable talking about things. And the platform made that easier, for me at least, and the style made it easier.",
        id: 190900206,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
        codes: [7, 34, 43, 45],
      },
      {
        audio_end_offset: 6323.476,
        audio_start_offset: 6314.79,
        duration: 4.720000000000255,
        id: 190900208,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6370.87,
        audio_start_offset: 6323.476,
        duration: 45.80200000000059,
        highlight_id: 5249098,
        highlight_words:
          "What I'm taking away is, got to talk to more people. A lot of great ideas out there, a lot of great people are doing great things. Sometimes in leadership we talk to each other too much. We need to get out there and hear people's ideas and connect with people. So that's an important takeaway. As far as the platform is concerned, to me, I didn't really think of it as a platform. I thought of it as a facilitated discussion. It was well facilitated, so that's good. I'm curious though, if this were more cacophonous, if there was a real disagreement that we had and we were talking over each other and being real passionate, I'd like to see how this MIT thing would handle that, whether it's capable, right?",
        id: 190900209,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
        codes: [7, 43, 45],
      },
      {
        audio_end_offset: 6379.33,
        audio_start_offset: 6370.87,
        duration: 7.8400000000001455,
        id: 190900210,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6385.93,
        audio_start_offset: 6379.33,
        duration: 6.220000000000255,
        id: 190900211,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6387.782,
        audio_start_offset: 6385.93,
        duration: 1.8519999999998618,
        id: 190900212,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6394.69,
        audio_start_offset: 6387.782,
        duration: 5.807999999999993,
        id: 190900213,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6400.57,
        audio_start_offset: 6394.69,
        duration: 4.480000000000473,
        id: 190900214,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6409.28,
        audio_start_offset: 6400.57,
        duration: 8.710000000000036,
        id: 190900215,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6463.488,
        audio_start_offset: 6409.28,
        duration: 54.08600000000024,
        id: 190900216,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6465.81,
        audio_start_offset: 6463.488,
        duration: 1.0320000000001528,
        id: 190900217,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6469.650646306818,
        audio_start_offset: 6465.81,
        duration: 3.840646306817689,
        id: 190900218,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6471.316882102273,
        audio_start_offset: 6469.650646306818,
        duration: 1.6662357954546678,
        id: 190900219,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6503.83,
        audio_start_offset: 6471.316882102273,
        duration: 31.46311789772699,
        highlight_id: 5249099,
        highlight_words:
          "I really enjoy, I'm going to look for some more trainings if you have some more, commissioner, for sure. So I'll be signing up for those. Great job today, it really kept things flowing. I think whoever said, the folks that were here were open to communicating, I think that was true. I thought it was a very organic experience, as far as our sharing, and it's nice to hear other folks have similar concerns, thoughts and successes as we all shared today, so it was nice to hear.",
        id: 190900220,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
        codes: [7, 34, 43, 16],
      },
      {
        audio_end_offset: 6508.45,
        audio_start_offset: 6503.83,
        duration: 2.550000000000182,
        id: 190900221,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6511.18,
        audio_start_offset: 6508.45,
        duration: 2.730000000000473,
        id: 190900222,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6515.26,
        audio_start_offset: 6511.18,
        duration: 4.079999999999927,
        id: 190900223,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6518.456419505678,
        audio_start_offset: 6515.26,
        duration: 3.1964195056780227,
        id: 190900224,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6588.75,
        audio_start_offset: 6518.456419505678,
        duration: 68.45958049432102,
        id: 190900225,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6592.992,
        audio_start_offset: 6588.75,
        duration: 4.144000000000233,
        id: 190900227,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6596.07,
        audio_start_offset: 6592.992,
        duration: 1.4979999999995925,
        id: 190900228,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 6601.53,
        audio_start_offset: 6596.07,
        duration: 5.010000000000218,
        id: 190900229,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6602.22,
        audio_start_offset: 6601.53,
        duration: 0.6900000000005093,
        id: 190900230,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6606.45,
        audio_start_offset: 6602.22,
        duration: 4.229999999999563,
        id: 190900231,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6608.61,
        audio_start_offset: 6606.45,
        duration: 1.480000000000473,
        id: 190900232,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6609.9,
        audio_start_offset: 6608.61,
        duration: 1.1199999999998909,
        id: 190900233,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6619.13,
        audio_start_offset: 6609.9,
        duration: 0.9600000000000364,
        id: 190900234,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6619.567901200112,
        audio_start_offset: 6619.13,
        duration: 0.4379012001118099,
        id: 190900235,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6620.614,
        audio_start_offset: 6619.567901200112,
        duration: 1.046098799887659,
        id: 190900236,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6629.07,
        audio_start_offset: 6620.614,
        duration: 3.1760000000003856,
        id: 190900237,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6632.43,
        audio_start_offset: 6629.07,
        duration: 2.1520000000000437,
        id: 190900238,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6644.73,
        audio_start_offset: 6632.43,
        duration: 11.4399999999996,
        id: 190900239,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6680.48,
        audio_start_offset: 6644.73,
        duration: 35.75,
        id: 190900240,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6682.407271573604,
        audio_start_offset: 6680.48,
        duration: 1.92727157360423,
        id: 190900241,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6691.02,
        audio_start_offset: 6682.407271573604,
        duration: 8.612728426396643,
        id: 190900242,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6700.788,
        audio_start_offset: 6691.02,
        duration: 9.765999999999622,
        id: 190900243,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6704.79,
        audio_start_offset: 6700.788,
        duration: 2.412000000000262,
        id: 190900244,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6712.53,
        audio_start_offset: 6704.79,
        duration: 4.829999999999927,
        id: 190900245,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6742.89,
        audio_start_offset: 6712.53,
        duration: 30.030000000000655,
        id: 190900246,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6745.047179023508,
        audio_start_offset: 6742.89,
        duration: 2.157179023507524,
        id: 190900247,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6749.43,
        audio_start_offset: 6745.047179023508,
        duration: 3.4528209764921485,
        id: 190900248,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6752.85,
        audio_start_offset: 6749.43,
        duration: 2.8499999999994543,
        id: 190900249,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6755.88,
        audio_start_offset: 6752.85,
        duration: 1.949999999999818,
        id: 190900250,
        speaker_id: 7,
        speaker_name: 'Speaker SB',
      },
      {
        audio_end_offset: 6801.21,
        audio_start_offset: 6755.88,
        duration: 44.88000000000011,
        id: 190900251,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6813.69,
        audio_start_offset: 6801.21,
        duration: 11.140000000000327,
        id: 190900252,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6817.95,
        audio_start_offset: 6813.69,
        duration: 3.030000000000655,
        id: 190900253,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6819.518,
        audio_start_offset: 6817.95,
        duration: 1.4960000000000946,
        id: 190900254,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6820.14,
        audio_start_offset: 6819.518,
        duration: 0.6220000000002983,
        id: 190900255,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6830.25,
        audio_start_offset: 6820.14,
        duration: 8.519999999999527,
        id: 190900256,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 6834.51,
        audio_start_offset: 6830.25,
        duration: 3.100000000000364,
        id: 190900257,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6836.91,
        audio_start_offset: 6834.51,
        duration: 1.5299999999997453,
        id: 190900258,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6837.96,
        audio_start_offset: 6836.91,
        duration: 1.050000000000182,
        id: 190900259,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6838.223351206434,
        audio_start_offset: 6837.96,
        duration: 0.26335120643398113,
        id: 190900260,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6840.686,
        audio_start_offset: 6838.223351206434,
        duration: 2.3186487935663536,
        id: 190900261,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6843.51,
        audio_start_offset: 6840.686,
        duration: 2.824000000000524,
        id: 190900262,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 6843.63,
        audio_start_offset: 6843.51,
        duration: 0.11999999999989086,
        id: 190900263,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6847.252,
        audio_start_offset: 6843.63,
        duration: 2.8159999999998035,
        id: 190900264,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6852.338,
        audio_start_offset: 6847.252,
        duration: 5.085999999999331,
        id: 190900265,
        speaker_id: 4,
        speaker_name: 'Speaker WA',
      },
      {
        audio_end_offset: 6855.45,
        audio_start_offset: 6852.338,
        duration: 3.11200000000008,
        id: 190900266,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6859.65,
        audio_start_offset: 6855.45,
        duration: 4.199999999999818,
        id: 190900267,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6880.344,
        audio_start_offset: 6859.65,
        duration: 20.463999999999942,
        id: 190900268,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6882.27,
        audio_start_offset: 6880.344,
        duration: 0.8159999999998035,
        id: 190900269,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6886.584,
        audio_start_offset: 6882.27,
        duration: 4.167999999999665,
        id: 190900270,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6887.508,
        audio_start_offset: 6886.584,
        duration: 0.7420000000001892,
        id: 190900271,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6888.6,
        audio_start_offset: 6887.508,
        duration: 1.092000000000553,
        id: 190900272,
        speaker_id: 6,
        speaker_name: 'Speaker SC',
      },
      {
        audio_end_offset: 6889.872365737594,
        audio_start_offset: 6888.6,
        duration: 1.2723657375936455,
        id: 190900273,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6900.7,
        audio_start_offset: 6889.872365737594,
        duration: 10.827634262405809,
        id: 190900274,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6911.022,
        audio_start_offset: 6900.7,
        duration: 10.322000000000116,
        id: 190900275,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6919.802,
        audio_start_offset: 6911.022,
        duration: 8.67200000000048,
        id: 190900276,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6925.166,
        audio_start_offset: 6919.802,
        duration: 5.220000000000255,
        id: 190900277,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6926.91,
        audio_start_offset: 6925.166,
        duration: 1.7439999999996871,
        id: 190900278,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6929.49,
        audio_start_offset: 6926.91,
        duration: 1.050000000000182,
        id: 190900279,
        speaker_id: 5,
        speaker_name: 'Speaker DB',
      },
      {
        audio_end_offset: 6932.71,
        audio_start_offset: 6929.49,
        duration: 0.930000000000291,
        id: 190900280,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6933.16,
        audio_start_offset: 6932.71,
        duration: 0.3999999999996362,
        id: 190900281,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6934.332106790482,
        audio_start_offset: 6933.16,
        duration: 1.1721067904818483,
        id: 190900282,
        speaker_id: 2,
        speaker_name: 'Speaker DA',
      },
      {
        audio_end_offset: 6934.697251886245,
        audio_start_offset: 6934.332106790482,
        duration: 0.3651450957631823,
        id: 190900283,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6934.99,
        audio_start_offset: 6934.697251886245,
        duration: 0.2927481137548966,
        id: 190900284,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6937.06,
        audio_start_offset: 6934.99,
        duration: 2.0700000000006185,
        id: 190900285,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6938.968,
        audio_start_offset: 6937.06,
        duration: 1.725999999999658,
        id: 190900286,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6942.076,
        audio_start_offset: 6938.968,
        duration: 2.97400000000016,
        id: 190900287,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6943.38182374541,
        audio_start_offset: 6942.076,
        duration: 1.3058237454097252,
        id: 190900288,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6944.774,
        audio_start_offset: 6943.38182374541,
        duration: 1.392176254590595,
        id: 190900289,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6945.83,
        audio_start_offset: 6944.774,
        duration: 1.0559999999995853,
        id: 190900290,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 6945.94,
        audio_start_offset: 6945.83,
        duration: 0.10999999999967258,
        id: 190900291,
        speaker_id: 0,
        speaker_name: 'Speaker LD',
      },
      {
        audio_end_offset: 6946.182,
        audio_start_offset: 6945.94,
        duration: 0.24200000000018917,
        id: 190900292,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
    ],
  },
  {
    duration: 10491.480792,
    speaker_count: 11,
    id: 1911,
    snippets: [
      {
        audio_end_offset: 1.64,
        audio_start_offset: 0.37,
        duration: 1.27,
        id: 191100000,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 3.17,
        audio_start_offset: 1.64,
        duration: 1.53,
        id: 191100001,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 38.744,
        audio_start_offset: 3.17,
        duration: 35.056,
        id: 191100002,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 40.532,
        audio_start_offset: 38.744,
        duration: 1.7879999999999967,
        id: 191100003,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 229.108,
        audio_start_offset: 40.532,
        duration: 186.92399999999998,
        id: 191100004,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 397.03,
        audio_start_offset: 229.108,
        duration: 164.07199999999995,
        id: 191100007,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 397.528,
        audio_start_offset: 397.03,
        duration: 0.4980000000000473,
        id: 191100010,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 398.95,
        audio_start_offset: 397.528,
        duration: 0.9119999999999777,
        id: 191100011,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 467.396,
        audio_start_offset: 398.95,
        duration: 68.31200000000001,
        id: 191100012,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 471.63,
        audio_start_offset: 467.396,
        duration: 4.2339999999999804,
        id: 191100013,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 474.09,
        audio_start_offset: 471.63,
        duration: 2.4599999999999795,
        id: 191100014,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 475.248,
        audio_start_offset: 474.09,
        duration: 1.0360000000000014,
        id: 191100015,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 476.832,
        audio_start_offset: 475.248,
        duration: 1.4259999999999877,
        id: 191100016,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 486.09,
        audio_start_offset: 476.832,
        duration: 8.74799999999999,
        id: 191100017,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 567.916,
        audio_start_offset: 486.09,
        duration: 81.69200000000006,
        id: 191100018,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 569.054,
        audio_start_offset: 567.916,
        duration: 1.13799999999992,
        id: 191100019,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 580.504,
        audio_start_offset: 569.054,
        duration: 10.984000000000037,
        id: 191100020,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 587.47,
        audio_start_offset: 580.504,
        duration: 6.576000000000022,
        id: 191100021,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 609.25,
        audio_start_offset: 587.47,
        duration: 21.399999999999977,
        id: 191100022,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 619.36,
        audio_start_offset: 609.25,
        duration: 9.940000000000055,
        id: 191100023,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 620.356,
        audio_start_offset: 619.36,
        duration: 0.8020000000000209,
        id: 191100024,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 621.94,
        audio_start_offset: 620.356,
        duration: 1.5339999999999918,
        id: 191100025,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 622.99,
        audio_start_offset: 621.94,
        duration: 0.599999999999909,
        id: 191100026,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 623.344,
        audio_start_offset: 622.99,
        duration: 0.35400000000004184,
        id: 191100027,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 633.016,
        audio_start_offset: 623.344,
        duration: 8.975999999999999,
        id: 191100028,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 645.484,
        audio_start_offset: 633.016,
        duration: 12.468000000000075,
        id: 191100029,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 652.122,
        audio_start_offset: 645.484,
        duration: 6.469999999999914,
        id: 191100030,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 652.636,
        audio_start_offset: 652.122,
        duration: 0.44000000000005457,
        id: 191100031,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 653.162,
        audio_start_offset: 652.636,
        duration: 0.5260000000000673,
        id: 191100032,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 654.844,
        audio_start_offset: 653.162,
        duration: 0.8179999999999836,
        id: 191100033,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 663.37,
        audio_start_offset: 654.844,
        duration: 8.015999999999963,
        id: 191100034,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 664.074,
        audio_start_offset: 663.37,
        duration: 0.6680000000000064,
        id: 191100035,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 665.394,
        audio_start_offset: 664.074,
        duration: 1.164000000000101,
        id: 191100036,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 679.57,
        audio_start_offset: 665.394,
        duration: 13.615999999999985,
        id: 191100037,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 681.31,
        audio_start_offset: 679.57,
        duration: 0.92999999999995,
        id: 191100038,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
      },
      {
        audio_end_offset: 682.51,
        audio_start_offset: 681.31,
        duration: 0.8800000000001091,
        id: 191100039,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 684.13,
        audio_start_offset: 682.51,
        duration: 0.9900000000000091,
        id: 191100040,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 685.254,
        audio_start_offset: 684.13,
        duration: 0.9679999999999609,
        id: 191100041,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 687.31,
        audio_start_offset: 685.254,
        duration: 0.8859999999999673,
        id: 191100042,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 699.33,
        audio_start_offset: 687.31,
        duration: 8.180000000000064,
        id: 191100043,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 700.71,
        audio_start_offset: 699.33,
        duration: 0.9900000000000091,
        id: 191100044,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 703.11,
        audio_start_offset: 700.71,
        duration: 2.019999999999982,
        id: 191100045,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 705.69,
        audio_start_offset: 703.11,
        duration: 0.9900000000000091,
        id: 191100046,
        speaker_id: 7,
        speaker_name: 'Speaker AC',
      },
      {
        audio_end_offset: 707.01,
        audio_start_offset: 705.69,
        duration: 0.8799999999999955,
        id: 191100047,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 709.11,
        audio_start_offset: 707.01,
        duration: 0.9300000000000637,
        id: 191100048,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
      },
      {
        audio_end_offset: 714.25,
        audio_start_offset: 709.11,
        duration: 1,
        id: 191100049,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 716.53,
        audio_start_offset: 714.25,
        duration: 0.9900000000000091,
        id: 191100050,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 716.884,
        audio_start_offset: 716.53,
        duration: 0.32799999999997453,
        id: 191100051,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 717.0573884555382,
        audio_start_offset: 716.884,
        duration: 0.17338845553820192,
        id: 191100052,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 727.97,
        audio_start_offset: 717.0573884555382,
        duration: 8.382611544461838,
        id: 191100053,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 731.324,
        audio_start_offset: 727.97,
        duration: 3.20799999999997,
        id: 191100054,
        speaker_id: 10,
        speaker_name: 'Speaker ME',
      },
      {
        audio_end_offset: 828.17,
        audio_start_offset: 731.324,
        duration: 96.16399999999999,
        id: 191100055,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 830.45,
        audio_start_offset: 828.17,
        duration: 1.8899999999999864,
        id: 191100057,
        speaker_id: 10,
        speaker_name: 'Speaker ME',
      },
      {
        audio_end_offset: 1049.25,
        audio_start_offset: 830.45,
        duration: 216.062,
        id: 191100058,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1105.17,
        audio_start_offset: 1049.25,
        duration: 54.930000000000064,
        id: 191100062,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
      },
      {
        audio_end_offset: 1110.09,
        audio_start_offset: 1105.17,
        duration: 2.980000000000018,
        id: 191100063,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1146.33,
        audio_start_offset: 1110.09,
        duration: 35.070000000000164,
        id: 191100064,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 1149.33,
        audio_start_offset: 1146.33,
        duration: 2.5,
        id: 191100065,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1199.83,
        audio_start_offset: 1149.33,
        duration: 49.460000000000036,
        id: 191100066,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 1204.49,
        audio_start_offset: 1199.83,
        duration: 1.900000000000091,
        id: 191100067,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1315.21,
        audio_start_offset: 1204.49,
        duration: 109.92999999999984,
        id: 191100068,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 1333.03,
        audio_start_offset: 1315.21,
        duration: 17.00999999999999,
        id: 191100070,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1364.47,
        audio_start_offset: 1333.03,
        duration: 30.50999999999999,
        id: 191100071,
        speaker_id: 7,
        speaker_name: 'Speaker AC',
      },
      {
        audio_end_offset: 1369.33,
        audio_start_offset: 1364.47,
        duration: 2.5,
        id: 191100072,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1491.01,
        audio_start_offset: 1369.33,
        duration: 119.93900000000008,
        id: 191100073,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
      },
      {
        audio_end_offset: 1497.35,
        audio_start_offset: 1491.01,
        duration: 4,
        id: 191100075,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1540.154,
        audio_start_offset: 1497.35,
        duration: 42.76800000000003,
        id: 191100076,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 1543.908,
        audio_start_offset: 1540.154,
        duration: 2.395999999999958,
        id: 191100077,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1604.73,
        audio_start_offset: 1543.908,
        duration: 60.19200000000001,
        id: 191100078,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 1612.15,
        audio_start_offset: 1604.73,
        duration: 2.1399999999998727,
        id: 191100079,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1656.88,
        audio_start_offset: 1612.15,
        duration: 44.73000000000002,
        id: 191100080,
        speaker_id: 10,
        speaker_name: 'Speaker ME',
      },
      {
        audio_end_offset: 1831.45,
        audio_start_offset: 1656.88,
        duration: 171.58799999999997,
        id: 191100081,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1910.69,
        audio_start_offset: 1831.45,
        duration: 74.43000000000006,
        highlight_id: 5249100,
        highlight_words:
          "I mean, I think that I could start with the challenges. When we first went virtually, I was really concerned about how to read the mood of the clients and read the room in a way that you do in person naturally. Online, it's much harder to gear that. And I know that I messed it up a few times in the beginning in some RDT's that it was very difficult, but when I found the opportunities through the tech team and learning how to use various, pull everywhere, all of those things to keep people engaged, and the more engaged they were, even though I couldn't be in the room and feel them, by the way that they were interacting with me, I could feel where they were. And I think that a lot of the work that we do is intuitive and it relies on emotional intelligence, and so that can be difficult in a virtual situation. So the opportunity there is to find as many different tools that we can to keep people engaged and interacting with us so that we can really figure out where they are coming from.",
        id: 191100085,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
        codes: [3, 2, 12, 24, 28],
      },
      {
        audio_end_offset: 1919.81,
        audio_start_offset: 1910.69,
        duration: 7.720000000000027,
        id: 191100086,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 1920.836,
        audio_start_offset: 1919.81,
        duration: 0.8920000000000528,
        id: 191100087,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
      },
      {
        audio_end_offset: 1926.93,
        audio_start_offset: 1920.836,
        duration: 3.69399999999996,
        id: 191100088,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2017.13,
        audio_start_offset: 1926.93,
        duration: 88.25,
        highlight_id: 5249101,
        highlight_words:
          "Well, I think the opportunity was for us to continue working. I mean, without the technology, we would have just been unemployed for two years. So I think the opportunity was there, and I think everybody took it rather well and made it work so that the mission of the agency, I think, was extremely successful during this period. The challenges are convincing people that this is the way to go and not wait. In the beginning, people didn't want to do it at all, so I think the challenges, to some degree, were overcome at least in my perspective. A lot of the initial work was done with people I already knew and I had engaged in before, we had a good rapport with each other. So they, I believe, just trusted me a little bit in the beginning that this was going to work and it followed through, and I think then we had the successes that just build upon themselves with people that we didn't know. So I was happy with what really turned out in the end and now that's all changing because technology is getting in the way right now.",
        id: 191100089,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [3, 2, 25, 26, 30, 17, 15],
      },
      {
        audio_end_offset: 2034.23,
        audio_start_offset: 2017.13,
        duration: 16.589999999999918,
        id: 191100090,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2062.83,
        audio_start_offset: 2034.23,
        duration: 26.259999999999764,
        highlight_id: 5249102,
        highlight_words:
          "Well, I had a few people that took to it right away because they were in a position where they needed to have something, so they were forced into it, whether they liked it or not. But there was a lot of people that didn't want to do it, they wanted to wait. The wait times ranged anywhere from a couple of months to maybe six months. After that, it just started to flow.",
        id: 191100091,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [3, 4, 17, 16],
      },
      {
        audio_end_offset: 2071.838,
        audio_start_offset: 2062.83,
        duration: 9.008000000000266,
        id: 191100092,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2176.77,
        audio_start_offset: 2071.838,
        duration: 101.39799999999968,
        highlight_id: 5249103,
        highlight_words:
          "So I came onto the agency in November of 2019, so I had about four months of in-person work before we went fully remote. The first week of new mediator training was the first week that ended up being the work-from-home period, which has obviously continued largely up through today. So I would say for me, the biggest challenge initially was, what the hell do I do with my day? I was really only initially finding comfort reaching out to people, and Barb and Walt were people that I shadowed early on, but that, I think, really quickly became a bit of an opportunity. I consider myself a digital native, and so I really did start feeling as though I was a value add when it comes to application of technology to the work of the agency. Not only for fellow mediators that I was helping out, but also for potential clients who were, I think, uneasy in the initial six-month to a year period where people finally started to embrace what was going to be a much longer time in this space that people may have originally thought they were going to be in. I think that because of that, the partnership is that much stronger if you're... The first thing in the virtual room is you're helping someone figure out these problems and get connected and get talking to one another. It's a easy first step, I think, to making a really valuable relationship with not only a colleague, but also with folks that you work with and assist in your CBM work or grievance mediation work or whatever it might be.",
        id: 191100093,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
        codes: [3, 4, 2, 10, 12, 33, 35, 25, 30, 16],
      },
      {
        audio_end_offset: 2196.252,
        audio_start_offset: 2176.77,
        duration: 19.32400000000007,
        id: 191100095,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2237.89,
        audio_start_offset: 2196.252,
        duration: 41.63799999999992,
        highlight_id: 5249104,
        highlight_words:
          "I mean, for very few people, I don't want to say no one, but for very few people, this is the preferable way of having a conversation. And so I think if the first step is the mutual acknowledgement of, yeah, here we are, but then step two is, let's do some commonplace ways to get a little bit, mini steps closer to what might be how you're used to doing things, I felt as though it was an easy first step in a good relationship, but also just proving that you're a helpful presence in the room to a skeptic.",
        id: 191100096,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
        codes: [4, 25],
      },
      {
        audio_end_offset: 2250.566,
        audio_start_offset: 2237.89,
        duration: 12.67599999999993,
        id: 191100097,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2267.97,
        audio_start_offset: 2250.566,
        duration: 15.934000000000196,
        id: 191100098,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 2277.67,
        audio_start_offset: 2267.97,
        duration: 5.920000000000073,
        id: 191100099,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2290.61,
        audio_start_offset: 2277.67,
        duration: 10.650000000000091,
        id: 191100100,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 2292.69,
        audio_start_offset: 2290.61,
        duration: 2.0799999999999272,
        id: 191100101,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 2296.23,
        audio_start_offset: 2292.69,
        duration: 3.5399999999999636,
        id: 191100102,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 2300.31,
        audio_start_offset: 2296.23,
        duration: 4.079999999999927,
        id: 191100103,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 2301.852,
        audio_start_offset: 2300.31,
        duration: 1.5039999999999054,
        id: 191100104,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 2303.412,
        audio_start_offset: 2301.852,
        duration: 1.4020000000000437,
        id: 191100105,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 2651.79,
        audio_start_offset: 2303.412,
        duration: 344.14400000000023,
        highlight_id: 5249105,
        highlight_words:
          "I had driven home from Vermont. State negotiations, they tend to be anywhere from 13 to 18 hours on settlement day, but they finished early. And so I stopped at Target, picked up some stuff, and the buzz that day was, \"I wonder if were going to shut down.\" Coming from the clients, not from me. And so I'm like, \"ll right, I need some stuff.\" And then I believe we got the email, it was either a Saturday or a Sunday morning, and I had 14 meetings booked that next week. Couple of grievance mediations, some CBMs, two RDTs, I don't know, a couple of EAOs, and I'm like, \"Okay, so how's this going to go? Please don't furlough us.\" And at that point in time... You were right about, we got some talkers here, because I'm like the worst. I had done one virtual meeting with Moira three months prior. That was my only virtual world experience. I had never FaceTimed, nothing. I don't even know what the names of the other stuff beyond what we use are, still, okay? So opportunities, I feel it was sink or swim, like Walt said. We were employed, right? What are we going to do to keep getting paid? I'm going to do it, because my husband was furloughed, so yeah. But I know it was a critical opportunity to acquire some needed and very timely job market skills, right? And resist my inner dinosaur.",
        id: 191100106,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [4, 2, 30, 17, 15, 16],
      },
      {
        audio_end_offset: 2706.87,
        audio_start_offset: 2651.79,
        duration: 53.36999999999989,
        id: 191100111,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 2833.75,
        audio_start_offset: 2706.87,
        duration: 120.07999999999993,
        highlight_id: 5249107,
        highlight_words:
          "I think a lot of the intensity translated into the platform. I mean, I didn't have anybody get so mad or angry in online virtual session, where they just left, disappeared, because they could leave the meeting, right? That was my biggest fear. Sometimes, and it happened with both parties and many of us maybe have experienced it, where there's this pre-coordinated or coordinated, the other side won't budge and everybody closes their books at the same time, stands up and walks out of the room. And I'm, \"Well, I know how I would handle that,\" right? I wouldn't run after them down the hallway, but I've been like \"Hey folks...\" You handle it. The intensity definitely came through. I think in the virtual world, for me at least, silence was crickets, was, oh, okay. And I had the early COVID stages inner struggle not to fill that void for everybody and take that on, because I wouldn't do that in person. You have to let it be uncomfortably quiet, because they need to feel that too. I'm not going to take all that on in person, I'm not going to take it all on here. I might count down in my head and say, \"Folks, I'm going to open the breakout rooms and I'm going to join this team first, and then I'll be there for about 10 or 15 and then I'm going to come to your team\".",
        id: 191100112,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [4, 11, 12, 24, 29],
      },
      {
        audio_end_offset: 2844.59,
        audio_start_offset: 2833.75,
        duration: 7.420000000000073,
        id: 191100114,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 3037.61,
        audio_start_offset: 2844.59,
        duration: 190.36799999999994,
        highlight_id: 5249108,
        highlight_words:
          "I think an opportunity that the technology brought foremost for me is, it provides a space and the ability to be in a lot of places at a lot of different times, right? I think everybody has understood that during the pandemic, one positive to this is that, not only can you be involved in different things in different places at different times, you don't have to factor into the going out into the field and doing things part of the job, right? It's, as soon as I'm done with this meeting, I've got another one on a completely unrelated topic, with a completely different person, dealing with these issues.",
        id: 191100115,
        speaker_id: 7,
        speaker_name: 'Speaker AC',
        codes: [2, 35, 29],
      },
      {
        audio_end_offset: 3097.37,
        audio_start_offset: 3037.61,
        duration: 58.48000000000002,
        id: 191100120,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 3160.91,
        audio_start_offset: 3097.37,
        duration: 62.49000000000024,
        highlight_id: 5249112,
        highlight_words:
          "I think that's an accurate representation of where we were once we got folks to be able to sign on board and they weren't just rolling contracts over. And to this day even, I'll be in a meeting and you have to shift your brain like that from, you could have a hardcore private sector CBM case where, very draining in one way, and then all of a sudden, I'm facilitating IBB with a group of teachers in Illinois somewhere. And I completely have to shift my mindset and my brain is still stuck in that other meeting, and I'm trying to pull up Google Docs to get my stuff in order because I didn't have time to get it all ready. And I have to apologize to the group when I'm checking in and say, \"Hey, by the way, I just transitioned meetings, so give me a minute to get my head space right.\" Yeah, I think I miss a little bit of that reflection time, as a lot of mediators, at least that my experience have shadowed me, I've shadowed with, that debrief time is always helpful, even if it's with yourself.",
        id: 191100121,
        speaker_id: 7,
        speaker_name: 'Speaker AC',
        codes: [4, 31, 30, 29],
      },
      {
        audio_end_offset: 3175.01,
        audio_start_offset: 3160.91,
        duration: 12.039999999999964,
        id: 191100123,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 3622.336,
        audio_start_offset: 3175.01,
        duration: 441.3199999999997,
        highlight_id: 5249113,
        highlight_words:
          "I guess, the challenge first, and the opportunity second. On the challenge, organizational and personal. On the organizational, some of you have mentioned already, the challenge of seeing how hard it was for some to adopt technology during a pandemic, or adapt I should say. There's many aspects to this, more than we have time for today, but one key feature of it was always that many of our colleagues were refusing to think flexibly. That is to say that they were taught how to do the job in one particular way, and they were just simply preferring to wait until the job configuration matched the way that they were taught how to do the job. Whether that was six months out or two years out, they were just going to wait it out. And there are still some folks for whom that is the approach today, and I recognize that many of you found it frustrating. I certainly did.",
        id: 191100124,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
        codes: [3, 4, 2, 17, 15],
      },
      {
        audio_end_offset: 3675.724,
        audio_start_offset: 3622.336,
        duration: 53.302000000000135,
        id: 191100132,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 3725.85,
        audio_start_offset: 3675.724,
        duration: 48.00599999999986,
        highlight_id: 5249119,
        highlight_words:
          "Okay, so challenges and opportunities. So, let's see, it started in March. I mean, my calendar is always scheduled out, and so some meetings were canceled, people figured they would wait for the pandemic to end, right? That didn't happen very quickly obviously, but then I had an employment case and a grievance mediation and we said, \"Well, let's do those virtually. I pretty much got on the bandwagon very quickly and started doing... What do you call them? Oh, geez. Trials.",
        id: 191100133,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
        codes: [3, 4, 2, 10, 30, 29],
      },
      {
        audio_end_offset: 3729.05,
        audio_start_offset: 3725.85,
        duration: 3.200000000000273,
        id: 191100134,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 4183.576,
        audio_start_offset: 3729.05,
        duration: 447.88000000000056,
        highlight_id: 5249120,
        highlight_words:
          "Yeah, just a EAO with everybody I knew, which I know a lot, because I've been around for a while. I mean, I don't know a lot, I know a lot of people because I've been around for a while. And so, we really did, and Brady, it was great, because I think it was an opportunity to bond with Brady, have him help me with the technology and give him the shadowing opportunities early on, and meet a lot of the different people as result of that. So I think it was a mixed bag, but I think I was pretty quick to jump on the bandwagon, if you will, on the virtual meetings and get people on board, and I actually had some arbitrators that I know that joined in, and et cetera. Okay, so that was that.",
        id: 191100135,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
        codes: [3, 4, 2, 41, 25, 30],
      },
      {
        audio_end_offset: 4191.61,
        audio_start_offset: 4183.576,
        duration: 8.03399999999965,
        id: 191100143,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 4236.91,
        audio_start_offset: 4191.61,
        duration: 41.86999999999989,
        highlight_id: 5250589,
        highlight_words:
          "I had a thought, and maybe it will take the form of a joke, I don't know, but about the people who rejected, resisted, whatevered virtual, they must be in the bushes, because I didn't know them before and I don't know, out of sight out of mind. And like Barbara said, not up to me, that's someone else's job.",
        id: 191100144,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [4, 17],
      },
      {
        audio_end_offset: 4260.76,
        audio_start_offset: 4236.91,
        duration: 23.850000000000364,
        id: 191100145,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 4868.46,
        audio_start_offset: 4260.76,
        duration: 595.0860000000002,
        highlight_id: 5250591,
        highlight_words:
          'I never understood that, coming from a perspective of always wanting to perform and to be the best to provide a service to the public, why one would resist trying to improve oneself to do that. And that never really... I never understood that, rather than just think, "Okay, this will pass by." I think we all thought, well, at least I know I did that first day, "Oh, in two weeks, the kids will get back to school, we\'ll be back at work. We got two weeks." Frankly, at that point, I was like, "Awesome, this is sweet, because you know what I can do know? I\'ve got all these virtual..." They were training snippets from different places like NJC and different places that I attended that they have stuff online that I was like, "I\'ve never gotten a chance to sit down and read it or watch the videos," and I filled up that time with just being able to take in new information that I hadn\'t otherwise. It was just everything was piling up and piling up like, "I want to get to this." And so I just never understood the mentality of why not at least try something to better yourself, and more importantly, you\'re working for this agency because you believe in it, you believe in the mission, at least, that\'s my perspective, why not try to help that along. And so I\'ve always struggled with that.',
        id: 191100146,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
        codes: [4, 17, 16],
      },
      {
        audio_end_offset: 4878.01,
        audio_start_offset: 4868.46,
        duration: 7.269999999999527,
        id: 191100157,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 4953.94,
        audio_start_offset: 4878.01,
        duration: 75.92999999999938,
        id: 191100158,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5004.07,
        audio_start_offset: 4953.94,
        duration: 48,
        highlight_id: 5250590,
        highlight_words:
          'I mean, yes, they were interwoven and you could always see the pros and cons, and I think one of the things that helped a lot of us successfully get through that was looking at the opportunities that provided and not prolonging and thinking about and regretting, "Oh this is such a challenge. Oh, this is awful." By being able to be optimistic, think forward and say, "Hey, how can this work? How can I improve myself? Yes, this is a challenge, but we can get past this." That is the way that the organization can develop to be even better, and everybody individually too. We all have to grow, we all have to develop, and by being able to focus on those opportunity points, man, what can we do?',
        id: 191100159,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
        codes: [3, 4, 2, 41, 33],
      },
      {
        audio_end_offset: 5020.09,
        audio_start_offset: 5004.07,
        duration: 15.69000000000051,
        id: 191100160,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5088.25,
        audio_start_offset: 5020.09,
        duration: 67.30000000000018,
        id: 191100161,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 5201.21,
        audio_start_offset: 5088.25,
        duration: 110.2460000000001,
        id: 191100162,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5289.67,
        audio_start_offset: 5201.21,
        duration: 86.59199999999964,
        highlight_id: 5249330,
        highlight_words:
          "I mean, I think that, like Christy was saying, about having the kids, working from home at the same time. I'm a single mom and my kids are 12 and 13, so 11 and 12 through most of the pandemic. I'm not good at math or apparently elementary school or middle school subjects in general, from what I learned, but what was really great about it is, in my history of work, I've always kept my personal life very separate from what I'm doing on a day-to-day basis, so having those two worlds collide all of a sudden, in a way that I can't help it when my 11-year-old is going to walk through here in her unicorn onesie wanting help with whatever it is. As much as I try to prevent it, it's going to happen.",
        id: 191100164,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
        codes: [5, 30, 22],
      },
      {
        audio_end_offset: 5320.804,
        audio_start_offset: 5289.67,
        duration: 31.134000000000015,
        id: 191100166,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5321.812,
        audio_start_offset: 5320.804,
        duration: 0.8500000000003638,
        id: 191100167,
        speaker_id: 3,
        speaker_name: 'Speaker LE',
      },
      {
        audio_end_offset: 5336.65,
        audio_start_offset: 5321.812,
        duration: 14.837999999999738,
        id: 191100168,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5381.242,
        audio_start_offset: 5336.65,
        duration: 44.42399999999998,
        highlight_id: 5249332,
        highlight_words:
          "Yeah, it's really back to the last question, but I think it is important. I think that again, it was both, double-edged sword, an opportunity was, I at least, and I think many, many people, got involved in cases that we wouldn't typically get involved in because they were really just using our platform, there wasn't a whole lot of mediation going on. The downside to that was, what a bore? And time-consuming. So I just wanted to say that in that regard. And I wish there was a pandemic when my kids were little. So I really appreciate those comments.",
        id: 191100169,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
        codes: [5, 34, 24, 28],
      },
      {
        audio_end_offset: 5386.79,
        audio_start_offset: 5381.242,
        duration: 3.3580000000001746,
        id: 191100170,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5487.71,
        audio_start_offset: 5386.79,
        duration: 99.21000000000004,
        highlight_id: 5249333,
        highlight_words:
          "I don't know that I could pinpoint any one particular case that stands out above everything else. What I do realize though, and I didn't think about until just now, is that, after having run through a number of sample sessions with people to show them what we had, I was just amazed when I think back on it, as how well everybody got accustomed to the system and understood it and worked it. It took very little after a 15 minute of reorientation, it too very little effort to have people very comfortable with the system, and I can feel that looking back over it, I think they were comfortable that we were doing things just as we had always done before. And it was not a lot of skepticism about the program. So I think that was a valuable piece. But that was the amazing part to me, whether anybody did anything extraordinary or not. I come from a different perspective than a lot of people. This business is this business. If you've been around long enough, there isn't much you're going to be surprised at. So something spectacular? No, I haven't seen much in 30 years spectacular but I was comfortable that they felt at ease using the system, and it made the normal scenario work.",
        id: 191100171,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [5, 35, 30, 15, 16],
      },
      {
        audio_end_offset: 5506.7,
        audio_start_offset: 5487.71,
        duration: 17.26000000000022,
        id: 191100173,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5635.056,
        audio_start_offset: 5506.7,
        duration: 127.41200000000026,
        highlight_id: 5250599,
        highlight_words:
          "So Barbara, I hope I don't steal this one from you, but this is one that I shadowed you on, but that was Pasnap. I will always remember this as being the first, I would say, more major cases during the first year of the quarantine period. It was so relevant too because it was a nurses union that was highlighting inadequate compensation for frontline work, inadequate safety materials, a lot of low morale because of work conditions premised on the pandemic. And just in terms of the challenges of the mediation, it was this huge nurses group that, they were sharing space, so they were all masked, they all wanted to log on, on individual devices, and it was such an interesting... And I think if I could distill down the lessons of successful mediation through technology and through all these challenges, it would be this. Because I was really in the background for this watching Barb do it all, but it was so educational just being a fly on the wall in all this.",
        id: 191100174,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
        codes: [5, 10, 12, 40, 26, 30],
      },
      {
        audio_end_offset: 5665.148971918877,
        audio_start_offset: 5635.056,
        duration: 30.092971918877083,
        id: 191100176,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 5671.239605573419,
        audio_start_offset: 5665.148971918877,
        duration: 6.090633654542216,
        id: 191100177,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 5672.797320471597,
        audio_start_offset: 5671.239605573419,
        duration: 1.5577148981783466,
        id: 191100178,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 5700.25,
        audio_start_offset: 5672.797320471597,
        duration: 26.162679528402805,
        id: 191100179,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 5706.88,
        audio_start_offset: 5700.25,
        duration: 6.630000000000109,
        id: 191100180,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 5710.431091703057,
        audio_start_offset: 5706.88,
        duration: 3.5510917030569544,
        id: 191100181,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 5718.89,
        audio_start_offset: 5710.431091703057,
        duration: 8.458908296943264,
        id: 191100182,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 5752.43,
        audio_start_offset: 5718.89,
        duration: 32.00999999999931,
        highlight_id: 5250601,
        highlight_words:
          'I will certainly agree with you there. There were a couple that when they ended at 3:30 in the morning, it was nice to be able to walk upstairs versus trying to drive home in that state. But no, I think that we could spend... Obviously, we should have another one of these just to talk about those of us who were in healthcare negotiations or strikes with nurses and things in this pandemic, because, what an amazing conversation to be part of? It was so fascinating. Annie, experience that stood out to you.',
        id: 191100183,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
        codes: [5, 31, 29, 20],
      },
      {
        audio_end_offset: 5753.91,
        audio_start_offset: 5752.43,
        duration: 1.4799999999995634,
        id: 191100184,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 5838.05,
        audio_start_offset: 5753.91,
        duration: 84.14000000000033,
        highlight_id: 5249338,
        highlight_words:
          "So there are two. There's an old and a more recent. So my husband came home one day in July of 2020, and he's like, \"Hey, Switch.\" He called me Switch. And it took me a minute to realize he was calling me switch because that's one of the characters in The Matrix, who sits and does the programming when the numbers fall and everything. Because I had one meeting on my personal laptop, one on my work laptop, and another meeting on my phone, same time. Now, I was muted in a couple of them, and everybody knew what was going on. It wasn't like it was a secret thing, they didn't know I was with them and they didn't know I was... Whatever. And I was like, \"Holy crap, seven months ago, I could barely manage email on my phone.\" I mean that's a gross overstatement. Second example, last Tuesday, Walt, I don't know if you went to Hershey with that labor group, oh, five years ago, they did an RBO?",
        id: 191100185,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [4, 30, 15, 16],
      },
      {
        audio_end_offset: 5839.39,
        audio_start_offset: 5838.05,
        duration: 1.3400000000001455,
        id: 191100186,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 5955.95,
        audio_start_offset: 5839.39,
        duration: 113.58199999999852,
        highlight_id: 5249341,
        highlight_words:
          "Yeah? So I was in an RDT with them again because their leadership has turned over, and Cindy and I did another mini RBO virtually a couple months ago, and now we're facilitating the labor management or the, I should say, labor, labor. The officers meetings, right? And so we're sitting there and they had just worked through a really tough problem inter-personal, like communication-based, ax-grinding-based, and so everybody is apologizing. You feel like when you open up a pressure cooker, the air escapes and it's like, okay, everyone is human again. And all of a sudden, and I'm not kidding you, you can call Cindy, this happened, this woman is looking at the screen and then she keels over. I'm like, \"Dammit, we've lived through 25 months of this pandemic situation and everybody has stayed alive, and now what the hell is this about?\" Turns out, the woman was recently diagnosed with vertigo, and she had an episode. So we say to the President, I'm like, \"You've to get 911 to her house. So he's got to call headquarters and executive director goes to her house and everything, and this is all happening on Zoom people. Paramedics come to the door and knocked down the door, that's on the Zoom meeting. She was home alone. So I'm like, \"All right, I'm not going to forget this one.\"",
        id: 191100187,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [4, 12, 33, 24, 26],
      },
      {
        audio_end_offset: 5961.29,
        audio_start_offset: 5955.95,
        duration: 4.720000000000255,
        id: 191100189,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5968.49,
        audio_start_offset: 5961.29,
        duration: 5.430000000000291,
        id: 191100190,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 5969.93,
        audio_start_offset: 5968.49,
        duration: 1.4400000000005093,
        id: 191100191,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 5998.83,
        audio_start_offset: 5969.93,
        duration: 27.25,
        id: 191100192,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
      },
      {
        audio_end_offset: 6006.19,
        audio_start_offset: 5998.83,
        duration: 5.069999999999709,
        id: 191100193,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 6120.43,
        audio_start_offset: 6006.19,
        duration: 110.46000000000004,
        highlight_id: 5249321,
        highlight_words:
          "The way we communicate in the virtual space is interesting. From my point of view, I think what I said earlier sums up the pros and cons, but moving forward, communication that's interesting. I'm on a computer screen, I have the ability to look up in realtime, mid-conversation without letting you know that I'm doing it. Searching the internet, looking up some fact, figure, answer, et cetera. I'm texting somebody, talking to one party via text on the other screen and I find how I'm going to be able to, if I'm in person, be able to do these things if all I have is a notepad and a pen and I'm trying to have a conversation in person. So I'm somewhat limited in that regard. So communication and the modes that we have it in the virtual space definitely stuck out to me. Also, how people communicate face-to-face over this platform. Are there those people who are off-camera and you don't know what they're doing and then they'll pipe up and they will say something. Are people more emboldened to say things over a computer screen versus in person. Maybe that's a good or a bad thing. It could be bad, I think, for a variety of reasons. But it also might be good because it might foster participation for somebody who is less likely to speak up in a meeting, depending on who they are with, and you might get that participation that you wouldn't otherwise. So aside from all the things I said earlier, I think communication and how we do it, I think is going to change forever, moving forward. In a meeting, are we going to tolerate people being on their phones more before or pulling out a laptop and having those conversations when we're in person because we're so reliant upon it?",
        id: 191100194,
        speaker_id: 7,
        speaker_name: 'Speaker AC',
        codes: [2, 33, 25, 29],
      },
      {
        audio_end_offset: 6157.13,
        audio_start_offset: 6120.43,
        duration: 33.81999999999971,
        id: 191100196,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 6395.52,
        audio_start_offset: 6157.13,
        duration: 235.8020000000006,
        highlight_id: 5249324,
        highlight_words:
          "The thing that I'm experiencing more than any other is how much more intentional we need to be in terms of delivering the highest quality. So a lot of the examples that were just given, including, Tom, the one that you just offered, it's been happening everywhere, and it demonstrated to me how the teaming approach is proving to be so powerful. There's something about these platforms where unless it's just a garden variety small group, perhaps collective bargaining scenario, but maybe a group you've known already, unless it's down at that level, almost any delivery, service delivery can be improved, I think with adding people to your team. And so, this is what we also experienced on the project I had referenced earlier, during this conversation today, Washington Resource Management planned negotiations with the State of Washington, multiple agencies led by the Attorney General's Office, 17 Native American Tribes, additional tribal orgaizations and then many federal agencies. And to wrangle a group that large, that's the one where full plenary had 175 people on it, to manage a group that large, we needed four of us.",
        id: 191100197,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
        codes: [4, 13, 10, 35, 26, 29],
      },
      {
        audio_end_offset: 6431.31,
        audio_start_offset: 6395.52,
        duration: 35.099999999999454,
        id: 191100202,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 6434.04,
        audio_start_offset: 6431.31,
        duration: 2.5599999999994907,
        id: 191100203,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
      },
      {
        audio_end_offset: 6435.24,
        audio_start_offset: 6434.04,
        duration: 1.0299999999997453,
        id: 191100204,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 6541.696,
        audio_start_offset: 6435.24,
        duration: 106.21399999999994,
        highlight_id: 5250602,
        highlight_words:
          "What you just said is so incredibly powerful, and I think it's worth bring out in this meeting. In all other aspects of service delivery, highest quality professional services in the United States, there have been huge changes over the last number of decades. Decades that many of us have been working, right? Where flexible approach involving lots of preparation and/or some kind of a partner or team delivery mode is the norm, right? Whether it's a legal team or a consulting team or a medical team or, you name it, it could be, at those levels, a teaming approach is proving to be very, very successful. It also enables each team member to also serve on other teams, and so in some cases, actually expand their practice with lots of interesing, high quality client work. And yet, for whatever the reasons, we can't probe them here, that level of thinking felixibly only arrived at Federal Mediation recently for pandemic, and it was considered the norm that we work alone or solo. And I understand there's geography involve there. This isn't to say we could've done it or should've done it differently, but I think we should embrace the lessons of the moment and decide as an organization if there are significant improvements we can make and do things differently on a go-forward basis. And that's a conversation that I'm hoping is underway across all corners of our organization, because I think we all have to contribute to it. I'd rather not see that as a matter of policy, but as a matter of highest quality practitioner approach.",
        id: 191100205,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
        codes: [5, 10, 34, 33, 30],
      },
      {
        audio_end_offset: 6559.81,
        audio_start_offset: 6541.696,
        duration: 17.003999999999905,
        id: 191100207,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 7007.35,
        audio_start_offset: 6559.81,
        duration: 437.003999999999,
        highlight_id: 5250603,
        highlight_words:
          "So on the communication piece that was brought up, and I forgot to mention this before, as far as, one of the benefits I found, and I don't know that everybody else found this, because talking through people, was that, parties that were somewhat entrenched or had a really intense relationship and like to aggravate each other at the table, they actually, when they went to vitual, they cut all that out. And I go back, and I'm not sure if that's because they just wanted it over with because they didn't know how to use the system, and they were like, \"I don't want to do this very much longer,\" or if they just didn't understand it. But it does go back to what Josh was just saying as far as intentionality and preparing, and being ready for it. I don't think they knew how to handle this situation. And so I found those negotiations or those mediations that I had very interesting on, I thought it was a benefit, because the parties got to an agreement faster. They didn't do all the huffing and puffing and blowing and storming out and all of that, it was like, \"Okay, here we are. Let's get this done because we need to get it done.\" So that was one thing that I had found. And going back to that communication part, and I think you had really got this, was, are we going to allow people to be on their computers... Not allow, but be acceptable to be on their computers or during the meetings, to be on their phones all the time? I don't know. I still dislike that.",
        id: 191100208,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
        codes: [5, 40, 24, 28],
      },
      {
        audio_end_offset: 7087.45,
        audio_start_offset: 7007.35,
        duration: 78.9399999999996,
        id: 191100217,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 7088.57,
        audio_start_offset: 7087.45,
        duration: 1.1199999999998909,
        id: 191100219,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 7100.266,
        audio_start_offset: 7088.57,
        duration: 11.67200000000048,
        id: 191100220,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 7210.27,
        audio_start_offset: 7100.266,
        duration: 106.4940000000015,
        highlight_id: 5249126,
        highlight_words:
          "Always on our minds. I think going forward, I don't want this to become the takeover of how we do business, not withstanding the fact that most of our businesses are one-on-one kind of scenario. No matter how we do it, whether were one-on-one or 10-on-one, this is a people business. And without any physical interaction and face-to-face communications, it will suffer. So I look at this tool as just being another accommodation for certain situations, and not what the norm is going to be. I think a lot of people think this is going to be the norm. We're never going to have to leave our house, and we could just sit in front of a \"tube\" all day long. I think it's a great thing. I mean, I like it. I do like the fact that 9:00 at night, when I get done a meeting, I don't have to drive two hours to go home, I can walk 50 feet to the kitchen and get something to eat. But I also know that if I don't have the ability to sit here, shake your hand, have a cup of coffee with you and look you in the eye and watch what's going on, that there's a big loss here to the effectiveness of what we do. So yeah, it's here. I'm looking forward to using it as another accommodation to get the mission of the agency performed.",
        id: 191100221,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [6, 13, 10, 12, 38, 34, 45, 25, 28, 20],
      },
      {
        audio_end_offset: 7217.83,
        audio_start_offset: 7210.27,
        duration: 7.109999999999673,
        id: 191100223,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 7372.75,
        audio_start_offset: 7217.83,
        duration: 149.6300000000001,
        highlight_id: 5249127,
        highlight_words:
          "I remember, one of the most important things someone told me when I started with FMCS was, \"Don't let yourself get federalized.\" What they meant by that is, don't fall into the rut of, I guess, assuming that the way things are done, are done that way for a reason, if that makes sense. And it's been really, really, really interesting being here and being able to talk to other people who don't work for FMCS, but also work in similar either federal agencies or state agencies, or even larger, I call them beurocracies, and just the willingness to experiment and try things over the last two years. And not only the level of experimentation, but the willingness to experiment and the opennnes to trying something new, and critically, if something doesn't work, discarding that thing, in pretty short order. I think it's a good thing. I really do. And I hope to see more of it. I hope this positions us to try more things more frequently.",
        id: 191100224,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
        codes: [6, 38, 34, 24],
      },
      {
        audio_end_offset: 7379.08,
        audio_start_offset: 7372.75,
        duration: 6.329999999999927,
        id: 191100227,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 7668.59,
        audio_start_offset: 7379.08,
        duration: 287.3000000000002,
        highlight_id: 5249129,
        highlight_words:
          "So I have been thinking a lot about how to stetch and/or manipulate the virtual capability, because, I'll be honest, folks, in the span of another six weeks, I'm going to be leaving home on a Monday and not coming home until Friday again. So what Christy describes as the things that she was able to literally blow the dust off the pile and dive in and learn and revisit and all those kinds of things, I'm thinking that that's going to not really be as accesible as it has been. Even though, like Brady just said, you're on how many hours a day and you don't leave your house and all that stuff, I told Josh six weeks ago that I thought I was becoming agoraphobic. Oh my God, people scare me. How did I go from that to Tuesday? I did, because it was like riding a bike, right? All of my fears, all those things we talked with clients about, communication in conflict, blah, blah, blah, yeah, it's like, you got to face your fears, you got to work through it. And so a couple of the ideas that I've had is, well, one of them was spured by a recent situation where I had done virtual training, steward supervisor training for 300 people at this worksite, mixed. And I guess they really liked it, because management was like, \"Well, when we start bargaining in four months, can you be with us from the very beginning?\" And I remember, I was saying, \"Yeah, let's talk about it, because we're obviously going to have a conversation. You should have a conversation with the union, together, let's find out if everybody is in the same page.\" And I'm thinking at that point bargaing will be virtual, right?",
        id: 191100228,
        speaker_id: 6,
        speaker_name: 'Speaker AB',
        codes: [6, 12, 24, 29, 15, 19, 20],
      },
      {
        audio_end_offset: 7710.07,
        audio_start_offset: 7668.59,
        duration: 39.470000000000255,
        id: 191100232,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8094.348,
        audio_start_offset: 7710.07,
        duration: 378.8580000000002,
        highlight_id: 5249131,
        highlight_words:
          "It's a combination approach. There's a whole lot that can be done virtually, and some work that I would still love to do or see folks doing, but I'd like to be out there too. I'd like to see them, I'd like to be there in person. And I think with that, Annie and others, will come a greater... It's going to take months or a year or longer, but a greater capacity and capability for how to scehdule and marry all that up, so that it turns out that if you have to go to Vermont, you might be able to go next week, but then you don't have to go again for another five or six weeks. And that's something from having put the miles on my cars back in the day. That would be very desirable.",
        id: 191100233,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
        codes: [6, 10, 11, 29, 15, 20],
      },
      {
        audio_end_offset: 8098.2,
        audio_start_offset: 8094.348,
        duration: 3.8519999999998618,
        id: 191100241,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8137.574,
        audio_start_offset: 8098.2,
        duration: 39.21799999999985,
        highlight_id: 5250612,
        highlight_words:
          "Shouldn't the best conflict management professionals, the best US federal mediators have the full array of tools and abilities at their disposal to help the conflict get resolved? So that also now includes in-person and virtual. Same as Walt and I have been practicing together for decades on this, and Barb. Walt and I love trying technology solutions together over the years, and we added that on. I wanted that too. So I just want more. But I don't want the inflexible thinking preventing us from getting more.",
        id: 191100242,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
        codes: [6, 15, 16],
      },
      {
        audio_end_offset: 8140.92,
        audio_start_offset: 8137.574,
        duration: 3.2960000000002765,
        id: 191100243,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8180.79,
        audio_start_offset: 8140.92,
        duration: 39.86999999999989,
        highlight_id: 5250613,
        highlight_words:
          "My concern is, people tend to latch on to something and it becomes the go-to methodology. And my concern is, it's appropriate in certain cases, and Josh had a couple, I've had a couple that just made sense to do it that way, but I think it should be an additional way to accomplish our task without destroying the interpersonal relationship that has to exist in a lot of the cases. That's all.",
        id: 191100244,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [6, 38, 40, 17],
      },
      {
        audio_end_offset: 8268.57,
        audio_start_offset: 8180.79,
        duration: 85.88000000000011,
        highlight_id: 5249135,
        highlight_words:
          "Josh, you made me think of something that we always said, I know in my conversations with Javier is that, what if we did this? Yeah, let's do it on top of what we do now, right? Let's just keep getting more. Your comment, \"I just want more. Why don't we do that on top of what we do now?\" And the thing that tied back into Walt that I thought was so fascniating is I think that there's just this big question that I keep hearing from a whole bunch of people that everyone says there's something lost when we're not together. And one of the questions I keep asking folks, I keep asking myself is, \"Is what's lost something that's more personal to me or did it have an impact on the outcome of what went on? I don't know that my outcomes have been different, so is what's lost something lost inside of me, which is not unimportant?\" And I think there has been something that's changed or been different for me, maybe lost for me in that experience, but I don't know that it's been lost in outcomes, and I think that's one of the things that is so fascinating in what we do. Barbara, the future, where are we going? Where are you going?",
        id: 191100245,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
        codes: [6, 13, 10, 12, 34, 24, 28],
      },
      {
        audio_end_offset: 8443.87,
        audio_start_offset: 8268.57,
        duration: 169.98799999999937,
        highlight_id: 5250614,
        highlight_words:
          "But anyway, well, I think the rule now is, the mediators do their work at their discretion, whether they want to do it live or Memorex... live or on Zoom or virtually, but that we're supposed to default on certain types of cases to doing virtually. I think, look, if you have a responsible person who's professional, knows what they're supposed to be doing, makes the agency look good and gets the job done, then the mediator should use their descretion of how they believe they need to service their customers. There are some customers that will probably continue wanting to do things by Zoom and there are others that we all have that have been doing things live for a long time. So that's one thing.",
        id: 191100247,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
        codes: [6, 10, 34, 29, 17, 15],
      },
      {
        audio_end_offset: 8468.2,
        audio_start_offset: 8443.87,
        duration: 24.279999999998836,
        id: 191100250,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8470.394,
        audio_start_offset: 8468.2,
        duration: 2.1939999999995052,
        id: 191100251,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8470.477553522416,
        audio_start_offset: 8470.394,
        duration: 0.08355352241596847,
        id: 191100252,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8472.25,
        audio_start_offset: 8470.477553522416,
        duration: 1.7724464775837987,
        id: 191100253,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 8477.98,
        audio_start_offset: 8472.25,
        duration: 5.729999999999563,
        id: 191100254,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8480.27,
        audio_start_offset: 8477.98,
        duration: 2.290000000000873,
        id: 191100255,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 8494.774,
        audio_start_offset: 8480.27,
        duration: 14.503999999998996,
        id: 191100256,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8495.380675908811,
        audio_start_offset: 8494.774,
        duration: 0.6066759088116669,
        id: 191100257,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 8496.262,
        audio_start_offset: 8495.380675908811,
        duration: 0.8333240911888424,
        id: 191100258,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8506.37,
        audio_start_offset: 8496.262,
        duration: 8.88799999999901,
        id: 191100259,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 8526.71,
        audio_start_offset: 8506.37,
        duration: 19.649999999999636,
        id: 191100260,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8529.74,
        audio_start_offset: 8526.71,
        duration: 3.030000000000655,
        id: 191100261,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 8533.634113356333,
        audio_start_offset: 8529.74,
        duration: 3.894113356333037,
        id: 191100262,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8540.58949926072,
        audio_start_offset: 8533.634113356333,
        duration: 6.955385904386276,
        id: 191100263,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 8541.914573681617,
        audio_start_offset: 8540.58949926072,
        duration: 1.3250744208980905,
        id: 191100264,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8793.512,
        audio_start_offset: 8541.914573681617,
        duration: 248.7094263183808,
        highlight_id: 5250617,
        highlight_words:
          "I was like, \"Oh, I'm so ready for this.\" All jazzed up. And I agree, I think this is a layering of, it's another tool, it's another opportunity. I want to point out, when we think about just the history of the though process and the development of labor relations and how we work in this field, prior to 2020, back even 2010, earlier on, people thought or talked about virtual or telephonic mediations or virtual mediations, and there was all... I recall reading a lot of things about it and the pros and the cons, and a lot of conversation we'd have about, \"Yes, this could be a benefit,\" or, \"No, and that's terrible,\" and I was more in the camp of in-person because you need to communicate, you can have that personal interaction. And hit 2020, we all realized it can work, it does work. May not be the most effective, but yes, there's a place for it in this world. The one thing that I want to point out or just give a compeletely different perspective here to think about, I watch my sons, both of them, on their video screens. [inaudible] for the past two years have been virtual in school for how long? A year and a half or so? They know how to communicate via virtual. They've learned this. They're playing games that are interactive virtually. They are buying virtual clothes. I'm spending money on a virtual skin. This is ridiculous to me, right?",
        id: 191100265,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
        codes: [6, 2, 38, 28, 30, 15],
      },
      {
        audio_end_offset: 8795.9,
        audio_start_offset: 8793.512,
        duration: 2.2780000000002474,
        id: 191100270,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8801.63,
        audio_start_offset: 8795.9,
        duration: 4.680000000000291,
        id: 191100271,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 8855.23,
        audio_start_offset: 8801.63,
        duration: 51.31000000000131,
        id: 191100272,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8858.608,
        audio_start_offset: 8855.23,
        duration: 3.2560000000012224,
        id: 191100273,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8871.49,
        audio_start_offset: 8858.608,
        duration: 12.371999999999389,
        id: 191100274,
        speaker_id: 8,
        speaker_name: 'Speaker JB',
      },
      {
        audio_end_offset: 8873.8,
        audio_start_offset: 8871.49,
        duration: 2.139999999999418,
        id: 191100275,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8882.56,
        audio_start_offset: 8873.8,
        duration: 8.760000000000218,
        id: 191100276,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8884.898,
        audio_start_offset: 8882.56,
        duration: 2.337999999999738,
        id: 191100277,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8897.17,
        audio_start_offset: 8884.898,
        duration: 11.162000000000262,
        id: 191100278,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8933.27,
        audio_start_offset: 8897.17,
        duration: 36.100000000000364,
        highlight_id: 5250618,
        highlight_words:
          "Remember one thing now, talking about following up on Christy looking at 50 years from now, your children are so adept at using the technology and the virtual world, they're going to, I believe, exist in a world where wars are fought this way, and they'll never be looking at the wrong end of a gun.",
        id: 191100279,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
        codes: [7, 15],
      },
      {
        audio_end_offset: 8936.08132262052,
        audio_start_offset: 8933.27,
        duration: 2.8113226205186947,
        id: 191100280,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 8940.56,
        audio_start_offset: 8936.08132262052,
        duration: 4.478677379480359,
        id: 191100281,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 8943.23,
        audio_start_offset: 8940.56,
        duration: 2.1599999999998545,
        id: 191100282,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 8978.07,
        audio_start_offset: 8943.23,
        duration: 32.01000000000022,
        id: 191100283,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 8981.018,
        audio_start_offset: 8978.07,
        duration: 2.7559999999994034,
        id: 191100284,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9002.344,
        audio_start_offset: 8981.018,
        duration: 21.18000000000029,
        highlight_id: 5250619,
        highlight_words:
          "As a participant, I thought this was fantastic. Thank you for letting me partcipate. The topic was great. I think really pulled it out. I think it was very easy. It didn't feel... Very easy, great conversation, so I had a lot of fun with it, so I appreciate it.",
        id: 191100285,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
        codes: [7, 43],
      },
      {
        audio_end_offset: 9007.21,
        audio_start_offset: 9002.344,
        duration: 4.3659999999999854,
        id: 191100286,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9047.77,
        audio_start_offset: 9007.21,
        duration: 39.39000000000124,
        highlight_id: 5250620,
        highlight_words:
          "What's different about this technology? I mean, we can have this type of conversation with small groups, and we should, on any topic. I mean, we've talked about the incumbent mediator training, for example. That was something that came out of the partnership. We keep asking for it again. I mean, I guess, eventually, we'll get some of it. But this is good. This is mediators talking to each other about stuff that relates to us and our practice. But my curiosity is, what is this... I forget the name of the-",
        id: 191100287,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
        codes: [7, 37, 25, 15],
      },
      {
        audio_end_offset: 9048.906,
        audio_start_offset: 9047.77,
        duration: 0.9920000000001892,
        id: 191100288,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9053.5,
        audio_start_offset: 9048.906,
        duration: 4.593999999999141,
        id: 191100289,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9097.59,
        audio_start_offset: 9053.5,
        duration: 37.43000000000029,
        id: 191100290,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9102.322,
        audio_start_offset: 9097.59,
        duration: 4.731999999999971,
        id: 191100291,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9110.31,
        audio_start_offset: 9102.322,
        duration: 7.2479999999995925,
        id: 191100292,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9115.246,
        audio_start_offset: 9110.31,
        duration: 4.935999999999694,
        id: 191100293,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9142.07,
        audio_start_offset: 9115.246,
        duration: 26.824000000000524,
        id: 191100294,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9143.132,
        audio_start_offset: 9142.07,
        duration: 1.0619999999998981,
        id: 191100295,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9144.80337221633,
        audio_start_offset: 9143.132,
        duration: 1.6713722163312923,
        id: 191100296,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9158.888,
        audio_start_offset: 9144.80337221633,
        duration: 13.902627783669232,
        id: 191100297,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9182.75,
        audio_start_offset: 9158.888,
        duration: 22.93199999999888,
        id: 191100298,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9187.67,
        audio_start_offset: 9182.75,
        duration: 4.530000000000655,
        id: 191100299,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9205.37,
        audio_start_offset: 9187.67,
        duration: 16.18000000000029,
        id: 191100300,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9316.04,
        audio_start_offset: 9205.37,
        duration: 110.54799999999886,
        id: 191100301,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9336.25,
        audio_start_offset: 9316.04,
        duration: 17.75,
        id: 191100303,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9338.69,
        audio_start_offset: 9336.25,
        duration: 2.4400000000005093,
        id: 191100304,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9349.721212287439,
        audio_start_offset: 9338.69,
        duration: 11.031212287438393,
        id: 191100305,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9368.57,
        audio_start_offset: 9349.721212287439,
        duration: 18.848787712560807,
        id: 191100306,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9371.63,
        audio_start_offset: 9368.57,
        duration: 3.0599999999994907,
        id: 191100307,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9377.15,
        audio_start_offset: 9371.63,
        duration: 5.079999999999927,
        id: 191100308,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9402.11,
        audio_start_offset: 9377.15,
        duration: 24.960000000000946,
        id: 191100309,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9493.67,
        audio_start_offset: 9402.11,
        duration: 87.49399999999878,
        id: 191100310,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 9497.75,
        audio_start_offset: 9493.67,
        duration: 3.7600000000002183,
        id: 191100312,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9498.392,
        audio_start_offset: 9497.75,
        duration: 0.6419999999998254,
        id: 191100313,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9501.47,
        audio_start_offset: 9498.392,
        duration: 3.07799999999952,
        id: 191100314,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9579.79,
        audio_start_offset: 9501.47,
        duration: 77.15999999999985,
        id: 191100315,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9597.102,
        audio_start_offset: 9579.79,
        duration: 17.143999999998414,
        id: 191100316,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9639.01,
        audio_start_offset: 9597.102,
        duration: 41.227999999999156,
        id: 191100317,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9730.528,
        audio_start_offset: 9639.01,
        duration: 91.23799999999937,
        id: 191100318,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9738.97,
        audio_start_offset: 9730.528,
        duration: 8.441999999999098,
        id: 191100320,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9739.996,
        audio_start_offset: 9738.97,
        duration: 0.8320000000003347,
        id: 191100321,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 9779.83,
        audio_start_offset: 9739.996,
        duration: 37.64400000000023,
        id: 191100322,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 9863.4,
        audio_start_offset: 9779.83,
        duration: 83.39999999999964,
        id: 191100323,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 9903.352358247423,
        audio_start_offset: 9863.4,
        duration: 39.952358247423035,
        id: 191100324,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 9904.966612665685,
        audio_start_offset: 9903.352358247423,
        duration: 1.614254418262135,
        id: 191100325,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 9939.28,
        audio_start_offset: 9904.966612665685,
        duration: 32.273387334314975,
        id: 191100326,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 9997.058,
        audio_start_offset: 9939.28,
        duration: 57.58599999999933,
        id: 191100327,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10003.59,
        audio_start_offset: 9997.058,
        duration: 5.2519999999985885,
        id: 191100328,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10005.3,
        audio_start_offset: 10003.59,
        duration: 1.5399999999990541,
        id: 191100329,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10018.17,
        audio_start_offset: 10005.3,
        duration: 12.8700000000008,
        id: 191100330,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10044.964,
        audio_start_offset: 10018.17,
        duration: 26.64799999999923,
        id: 191100331,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10046.296,
        audio_start_offset: 10044.964,
        duration: 1.1980000000003201,
        id: 191100332,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10047.256,
        audio_start_offset: 10046.296,
        duration: 0.7659999999996217,
        id: 191100333,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10080.37,
        audio_start_offset: 10047.256,
        duration: 31.52400000000125,
        id: 191100334,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10101.07,
        audio_start_offset: 10080.37,
        duration: 20.30999999999949,
        id: 191100335,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10103.98,
        audio_start_offset: 10101.07,
        duration: 2.9099999999998545,
        id: 191100336,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10106.33,
        audio_start_offset: 10103.98,
        duration: 2.350000000000364,
        id: 191100337,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10109.63,
        audio_start_offset: 10106.33,
        duration: 2.3700000000008004,
        id: 191100338,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10138.43,
        audio_start_offset: 10109.63,
        duration: 26.34400000000096,
        id: 191100339,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10167.524,
        audio_start_offset: 10138.43,
        duration: 28.94800000000032,
        id: 191100340,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10173.958,
        audio_start_offset: 10167.524,
        duration: 6.242000000000189,
        id: 191100341,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10211.686,
        audio_start_offset: 10173.958,
        duration: 37.70399999999972,
        id: 191100342,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10274.24,
        audio_start_offset: 10211.686,
        duration: 62.384000000000015,
        id: 191100343,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 10277.576,
        audio_start_offset: 10274.24,
        duration: 3.201999999999316,
        id: 191100344,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10280.492,
        audio_start_offset: 10277.576,
        duration: 2.916000000001077,
        id: 191100345,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10291.07,
        audio_start_offset: 10280.492,
        duration: 8.997999999999593,
        id: 191100346,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10294.25,
        audio_start_offset: 10291.07,
        duration: 3.180000000000291,
        id: 191100347,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10296.41,
        audio_start_offset: 10294.25,
        duration: 1.7099999999991269,
        id: 191100348,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10299.884,
        audio_start_offset: 10296.41,
        duration: 3.32799999999952,
        id: 191100349,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10306.37,
        audio_start_offset: 10299.884,
        duration: 5.9760000000005675,
        id: 191100350,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10311.008,
        audio_start_offset: 10306.37,
        duration: 4.6379999999990105,
        id: 191100351,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10328.57,
        audio_start_offset: 10311.008,
        duration: 17.11200000000099,
        id: 191100352,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10343.338,
        audio_start_offset: 10328.57,
        duration: 14.768000000000029,
        id: 191100353,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10358.166,
        audio_start_offset: 10343.338,
        duration: 14.82799999999952,
        id: 191100354,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10358.288,
        audio_start_offset: 10358.166,
        duration: 0.12200000000120781,
        id: 191100355,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10360.97,
        audio_start_offset: 10358.288,
        duration: 2.6819999999988795,
        id: 191100356,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10369.71,
        audio_start_offset: 10360.97,
        duration: 5.3700000000008,
        id: 191100357,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10377.97,
        audio_start_offset: 10369.71,
        duration: 6.730000000001382,
        id: 191100358,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10378.367731610337,
        audio_start_offset: 10377.97,
        duration: 0.3977316103373596,
        id: 191100359,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 10381.45,
        audio_start_offset: 10378.367731610337,
        duration: 2.272268389662713,
        id: 191100360,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10384.97,
        audio_start_offset: 10381.45,
        duration: 0.75,
        id: 191100361,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10386.83,
        audio_start_offset: 10384.97,
        duration: 0.9899999999997817,
        id: 191100362,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10398.23,
        audio_start_offset: 10386.83,
        duration: 10.290000000000873,
        id: 191100363,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10401.478,
        audio_start_offset: 10398.23,
        duration: 3.0560000000004948,
        id: 191100364,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10404.81,
        audio_start_offset: 10401.478,
        duration: 3.3320000000003347,
        id: 191100365,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10405.97,
        audio_start_offset: 10404.81,
        duration: 1.1599999999998545,
        id: 191100366,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10407.47,
        audio_start_offset: 10405.97,
        duration: 0.9899999999997817,
        id: 191100367,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10408.22,
        audio_start_offset: 10407.47,
        duration: 0.75,
        id: 191100368,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10412.51,
        audio_start_offset: 10408.22,
        duration: 2.9400000000005093,
        id: 191100369,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10412.816,
        audio_start_offset: 10412.51,
        duration: 0.30600000000049477,
        id: 191100370,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10414.28,
        audio_start_offset: 10412.816,
        duration: 1.4639999999999418,
        id: 191100371,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 10416.068,
        audio_start_offset: 10414.28,
        duration: 1.6659999999992579,
        id: 191100372,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10418.96,
        audio_start_offset: 10416.068,
        duration: 2.8919999999998254,
        id: 191100373,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 10423.59,
        audio_start_offset: 10418.96,
        duration: 4.630000000001019,
        id: 191100374,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10425.35,
        audio_start_offset: 10423.59,
        duration: 1.639999999999418,
        id: 191100375,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10426.836,
        audio_start_offset: 10425.35,
        duration: 1.4719999999997526,
        id: 191100376,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 10436.472,
        audio_start_offset: 10426.836,
        duration: 9.478000000000975,
        id: 191100377,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10453.262,
        audio_start_offset: 10436.472,
        duration: 16.74200000000019,
        id: 191100378,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10454.49,
        audio_start_offset: 10453.262,
        duration: 0.5979999999999563,
        id: 191100379,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10460.49,
        audio_start_offset: 10454.49,
        duration: 3.9400000000005093,
        id: 191100380,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10463.762,
        audio_start_offset: 10460.49,
        duration: 3.1039999999993597,
        id: 191100381,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10465.258,
        audio_start_offset: 10463.762,
        duration: 1.495999999999185,
        id: 191100382,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10466.268,
        audio_start_offset: 10465.258,
        duration: 0.8880000000008295,
        id: 191100383,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10467.12,
        audio_start_offset: 10466.268,
        duration: 0.8520000000007713,
        id: 191100384,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10467.695978647687,
        audio_start_offset: 10467.12,
        duration: 0.5759786476864974,
        id: 191100385,
        speaker_id: 2,
        speaker_name: 'Speaker BE',
      },
      {
        audio_end_offset: 10470.51,
        audio_start_offset: 10467.695978647687,
        duration: 1.7040213523123384,
        id: 191100386,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10472.93518263859,
        audio_start_offset: 10470.51,
        duration: 2.425182638589831,
        id: 191100387,
        speaker_id: 5,
        speaker_name: 'Speaker BD',
      },
      {
        audio_end_offset: 10480.43,
        audio_start_offset: 10472.93518263859,
        duration: 7.494817361410242,
        id: 191100388,
        speaker_id: 1,
        speaker_name: 'Speaker KH',
      },
      {
        audio_end_offset: 10484.11,
        audio_start_offset: 10480.43,
        duration: 2.75,
        id: 191100389,
        speaker_id: 9,
        speaker_name: 'Speaker CD',
      },
      {
        audio_end_offset: 10485.173431433937,
        audio_start_offset: 10484.11,
        duration: 1.0634314339367847,
        id: 191100390,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
      {
        audio_end_offset: 10485.61,
        audio_start_offset: 10485.173431433937,
        duration: 0.43656856606321526,
        id: 191100391,
        speaker_id: 4,
        speaker_name: 'Speaker WB',
      },
      {
        audio_end_offset: 10486.04,
        audio_start_offset: 10485.61,
        duration: 0.43000000000029104,
        id: 191100392,
        speaker_id: 0,
        speaker_name: 'Speaker TD',
      },
    ],
  },
];
